// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* purgecss start ignore */

:root,[data-bs-theme=light]{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-dark-primary: #252f3f;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-dark-primary-rgb: 37, 47, 63;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size:1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545
}

[data-bs-theme=dark]{
  color-scheme:dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f
}

*,*::before,*::after{
  box-sizing:border-box
}

@media(prefers-reduced-motion: no-preference){
  :root{
    scroll-behavior:smooth
  }
}

body{
  margin:0;
  font-family:var(--bs-body-font-family);
  font-size:var(--bs-body-font-size);
  font-weight:var(--bs-body-font-weight);
  line-height:var(--bs-body-line-height);
  color:var(--bs-body-color);
  text-align:var(--bs-body-text-align);
  background-color:var(--bs-body-bg);
  -webkit-text-size-adjust:100%;
  -webkit-tap-highlight-color:rgba(0,0,0,0)
}

hr{
  margin:1rem 0;
  color:inherit;
  border:0;
  border-top:var(--bs-border-width) solid;
  opacity:.25
}

h6,.h6,h5,.h5,h4,.h4,h3,.h3,h2,.h2,h1,.h1{
  margin-top:0;
  margin-bottom:.5rem;
  font-weight:500;
  line-height:1.2;
  color:var(--bs-heading-color)
}

h1,.h1{
  font-size:calc(1.375rem + 1.5vw)
}

@media(min-width: 1200px){
  h1,.h1{
    font-size:2.5rem
  }
}

h2,.h2{
  font-size:calc(1.325rem + 0.9vw)
}

@media(min-width: 1200px){
  h2,.h2{
    font-size:2rem
  }
}

h3,.h3{
  font-size:calc(1.3rem + 0.6vw)
}

@media(min-width: 1200px){
  h3,.h3{
    font-size:1.75rem
  }
}

h4,.h4{
  font-size:calc(1.275rem + 0.3vw)
}

@media(min-width: 1200px){
  h4,.h4{
    font-size:1.5rem
  }
}

h5,.h5{
  font-size:1.25rem
}

h6,.h6{
  font-size:1rem
}

p{
  margin-top:0;
  margin-bottom:1rem
}

abbr[title]{
  text-decoration:underline dotted;
  cursor:help;
  text-decoration-skip-ink:none
}

address{
  margin-bottom:1rem;
  font-style:normal;
  line-height:inherit
}

ol,ul{
  padding-left:2rem
}

ol,ul,dl{
  margin-top:0;
  margin-bottom:1rem
}

ol ol,ul ul,ol ul,ul ol{
  margin-bottom:0
}

dt{
  font-weight:700
}

dd{
  margin-bottom:.5rem;
  margin-left:0
}

blockquote{
  margin:0 0 1rem
}

b,strong{
  font-weight:bolder
}

small,.small{
  font-size:0.875em
}

mark,.mark{
  padding:.1875em;
  color:var(--bs-highlight-color);
  background-color:var(--bs-highlight-bg)
}

sub,sup{
  position:relative;
  font-size:0.75em;
  line-height:0;
  vertical-align:baseline
}

sub{
  bottom:-0.25em
}

sup{
  top:-0.5em
}

a{
  color:rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration:underline
}

a:hover{
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb)
}

a:not([href]):not([class]),a:not([href]):not([class]):hover{
  color:inherit;
  text-decoration:none
}

pre,code,kbd,samp{
  font-family:var(--bs-font-monospace);
  font-size:1em
}

pre{
  display:block;
  margin-top:0;
  margin-bottom:1rem;
  overflow:auto;
  font-size:0.875em
}

pre code{
  font-size:inherit;
  color:inherit;
  word-break:normal
}

code{
  font-size:0.875em;
  color:var(--bs-code-color);
  word-wrap:break-word
}

a>code{
  color:inherit
}

kbd{
  padding:.1875rem .375rem;
  font-size:0.875em;
  color:var(--bs-body-bg);
  background-color:var(--bs-body-color);
  border-radius:.25rem
}

kbd kbd{
  padding:0;
  font-size:1em
}

figure{
  margin:0 0 1rem
}

img,svg{
  vertical-align:middle
}

table{
  caption-side:bottom;
  border-collapse:collapse
}

caption{
  padding-top:.5rem;
  padding-bottom:.5rem;
  color:var(--bs-secondary-color);
  text-align:left
}

th{
  text-align:inherit;
  text-align:-webkit-match-parent
}

thead,tbody,tfoot,tr,td,th{
  border-color:inherit;
  border-style:solid;
  border-width:0
}

label{
  display:inline-block
}

button{
  border-radius:0
}

button:focus:not(:focus-visible){
  outline:0
}

input,button,select,optgroup,textarea{
  margin:0;
  font-family:inherit;
  font-size:inherit;
  line-height:inherit
}

button,select{
  text-transform:none
}

[role=button]{
  cursor:pointer
}

select{
  word-wrap:normal
}

select:disabled{
  opacity:1
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator{
  display:none !important
}

button,[type=button],[type=reset],[type=submit]{
  -webkit-appearance:button
}

button:not(:disabled),[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled){
  cursor:pointer
}

::-moz-focus-inner{
  padding:0;
  border-style:none
}

textarea{
  resize:vertical
}

fieldset{
  min-width:0;
  padding:0;
  margin:0;
  border:0
}

legend{
  float:left;
  width:100%;
  padding:0;
  margin-bottom:.5rem;
  font-size:calc(1.275rem + 0.3vw);
  line-height:inherit
}

@media(min-width: 1200px){
  legend{
    font-size:1.5rem
  }
}

legend+*{
  clear:left
}

::-webkit-datetime-edit-fields-wrapper,::-webkit-datetime-edit-text,::-webkit-datetime-edit-minute,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-year-field{
  padding:0
}

::-webkit-inner-spin-button{
  height:auto
}

[type=search]{
  -webkit-appearance:textfield;
  outline-offset:-2px
}

::-webkit-search-decoration{
  -webkit-appearance:none
}

::-webkit-color-swatch-wrapper{
  padding:0
}

::file-selector-button{
  font:inherit;
  -webkit-appearance:button
}

output{
  display:inline-block
}

iframe{
  border:0
}

summary{
  display:list-item;
  cursor:pointer
}

progress{
  vertical-align:baseline
}

[hidden]{
  display:none !important
}

.lead{
  font-size:1.25rem;
  font-weight:300
}

.display-1{
  font-size:calc(1.625rem + 4.5vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-1{
    font-size:5rem
  }
}

.display-2{
  font-size:calc(1.575rem + 3.9vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-2{
    font-size:4.5rem
  }
}

.display-3{
  font-size:calc(1.525rem + 3.3vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-3{
    font-size:4rem
  }
}

.display-4{
  font-size:calc(1.475rem + 2.7vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-4{
    font-size:3.5rem
  }
}

.display-5{
  font-size:calc(1.425rem + 2.1vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-5{
    font-size:3rem
  }
}

.display-6{
  font-size:calc(1.375rem + 1.5vw);
  font-weight:300;
  line-height:1.2
}

@media(min-width: 1200px){
  .display-6{
    font-size:2.5rem
  }
}

.list-unstyled{
  padding-left:0;
  list-style:none
}

.list-inline{
  padding-left:0;
  list-style:none
}

.list-inline-item{
  display:inline-block
}

.list-inline-item:not(:last-child){
  margin-right:.5rem
}

.initialism{
  font-size:0.875em;
  text-transform:uppercase
}

.blockquote{
  margin-bottom:1rem;
  font-size:1.25rem
}

.blockquote>:last-child{
  margin-bottom:0
}

.blockquote-footer{
  margin-top:-1rem;
  margin-bottom:1rem;
  font-size:0.875em;
  color:#6c757d
}

.blockquote-footer::before{
  content:"— "
}

.img-fluid{
  max-width:100%;
  height:auto
}

.img-thumbnail{
  padding:.25rem;
  background-color:var(--bs-body-bg);
  border:var(--bs-border-width) solid var(--bs-border-color);
  border-radius:var(--bs-border-radius);
  max-width:100%;
  height:auto
}

.figure{
  display:inline-block
}

.figure-img{
  margin-bottom:.5rem;
  line-height:1
}

.figure-caption{
  font-size:0.875em;
  color:var(--bs-secondary-color)
}

.container,.container-fluid,.container-xxl,.container-xl,.container-lg,.container-md,.container-sm{
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width:100%;
  padding-right:calc(var(--bs-gutter-x)*.5);
  padding-left:calc(var(--bs-gutter-x)*.5);
  margin-right:auto;
  margin-left:auto
}

@media(min-width: 576px){
  .container-sm,.container{
    max-width:540px
  }
}

@media(min-width: 768px){
  .container-md,.container-sm,.container{
    max-width:720px
  }
}

@media(min-width: 992px){
  .container-lg,.container-md,.container-sm,.container{
    max-width:960px
  }
}

@media(min-width: 1200px){
  .container-xl,.container-lg,.container-md,.container-sm,.container{
    max-width:1140px
  }
}

@media(min-width: 1400px){
  .container-xxl,.container-xl,.container-lg,.container-md,.container-sm,.container{
    max-width:1320px
  }
}

:root{
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px
}

.row{
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display:flex;
  flex-wrap:wrap;
  margin-top:calc(-1*var(--bs-gutter-y));
  margin-right:calc(-0.5*var(--bs-gutter-x));
  margin-left:calc(-0.5*var(--bs-gutter-x))
}

.row>*{
  flex-shrink:0;
  width:100%;
  max-width:100%;
  padding-right:calc(var(--bs-gutter-x)*.5);
  padding-left:calc(var(--bs-gutter-x)*.5);
  margin-top:var(--bs-gutter-y)
}

.col{
  flex:1 0 0%
}

.row-cols-auto>*{
  flex:0 0 auto;
  width:auto
}

.row-cols-1>*{
  flex:0 0 auto;
  width:100%
}

.row-cols-2>*{
  flex:0 0 auto;
  width:50%
}

.row-cols-3>*{
  flex:0 0 auto;
  width:33.33333333%
}

.row-cols-4>*{
  flex:0 0 auto;
  width:25%
}

.row-cols-5>*{
  flex:0 0 auto;
  width:20%
}

.row-cols-6>*{
  flex:0 0 auto;
  width:16.66666667%
}

.col-auto{
  flex:0 0 auto;
  width:auto
}

.col-1{
  flex:0 0 auto;
  width:8.33333333%
}

.col-2{
  flex:0 0 auto;
  width:16.66666667%
}

.col-3{
  flex:0 0 auto;
  width:25%
}

.col-4{
  flex:0 0 auto;
  width:33.33333333%
}

.col-5{
  flex:0 0 auto;
  width:41.66666667%
}

.col-6{
  flex:0 0 auto;
  width:50%
}

.col-7{
  flex:0 0 auto;
  width:58.33333333%
}

.col-8{
  flex:0 0 auto;
  width:66.66666667%
}

.col-9{
  flex:0 0 auto;
  width:75%
}

.col-10{
  flex:0 0 auto;
  width:83.33333333%
}

.col-11{
  flex:0 0 auto;
  width:91.66666667%
}

.col-12{
  flex:0 0 auto;
  width:100%
}

.offset-1{
  margin-left:8.33333333%
}

.offset-2{
  margin-left:16.66666667%
}

.offset-3{
  margin-left:25%
}

.offset-4{
  margin-left:33.33333333%
}

.offset-5{
  margin-left:41.66666667%
}

.offset-6{
  margin-left:50%
}

.offset-7{
  margin-left:58.33333333%
}

.offset-8{
  margin-left:66.66666667%
}

.offset-9{
  margin-left:75%
}

.offset-10{
  margin-left:83.33333333%
}

.offset-11{
  margin-left:91.66666667%
}

.g-0,.gx-0{
  --bs-gutter-x: 0
}

.g-0,.gy-0{
  --bs-gutter-y: 0
}

.g-1,.gx-1{
  --bs-gutter-x: 0.25rem
}

.g-1,.gy-1{
  --bs-gutter-y: 0.25rem
}

.g-2,.gx-2{
  --bs-gutter-x: 0.5rem
}

.g-2,.gy-2{
  --bs-gutter-y: 0.5rem
}

.g-3,.gx-3{
  --bs-gutter-x: 1rem
}

.g-3,.gy-3{
  --bs-gutter-y: 1rem
}

.g-4,.gx-4{
  --bs-gutter-x: 1.5rem
}

.g-4,.gy-4{
  --bs-gutter-y: 1.5rem
}

.g-5,.gx-5{
  --bs-gutter-x: 3rem
}

.g-5,.gy-5{
  --bs-gutter-y: 3rem
}

@media(min-width: 576px){
  .col-sm{
    flex:1 0 0%
  }

  .row-cols-sm-auto>*{
    flex:0 0 auto;
    width:auto
  }

  .row-cols-sm-1>*{
    flex:0 0 auto;
    width:100%
  }

  .row-cols-sm-2>*{
    flex:0 0 auto;
    width:50%
  }

  .row-cols-sm-3>*{
    flex:0 0 auto;
    width:33.33333333%
  }

  .row-cols-sm-4>*{
    flex:0 0 auto;
    width:25%
  }

  .row-cols-sm-5>*{
    flex:0 0 auto;
    width:20%
  }

  .row-cols-sm-6>*{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-sm-auto{
    flex:0 0 auto;
    width:auto
  }

  .col-sm-1{
    flex:0 0 auto;
    width:8.33333333%
  }

  .col-sm-2{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-sm-3{
    flex:0 0 auto;
    width:25%
  }

  .col-sm-4{
    flex:0 0 auto;
    width:33.33333333%
  }

  .col-sm-5{
    flex:0 0 auto;
    width:41.66666667%
  }

  .col-sm-6{
    flex:0 0 auto;
    width:50%
  }

  .col-sm-7{
    flex:0 0 auto;
    width:58.33333333%
  }

  .col-sm-8{
    flex:0 0 auto;
    width:66.66666667%
  }

  .col-sm-9{
    flex:0 0 auto;
    width:75%
  }

  .col-sm-10{
    flex:0 0 auto;
    width:83.33333333%
  }

  .col-sm-11{
    flex:0 0 auto;
    width:91.66666667%
  }

  .col-sm-12{
    flex:0 0 auto;
    width:100%
  }

  .offset-sm-0{
    margin-left:0
  }

  .offset-sm-1{
    margin-left:8.33333333%
  }

  .offset-sm-2{
    margin-left:16.66666667%
  }

  .offset-sm-3{
    margin-left:25%
  }

  .offset-sm-4{
    margin-left:33.33333333%
  }

  .offset-sm-5{
    margin-left:41.66666667%
  }

  .offset-sm-6{
    margin-left:50%
  }

  .offset-sm-7{
    margin-left:58.33333333%
  }

  .offset-sm-8{
    margin-left:66.66666667%
  }

  .offset-sm-9{
    margin-left:75%
  }

  .offset-sm-10{
    margin-left:83.33333333%
  }

  .offset-sm-11{
    margin-left:91.66666667%
  }

  .g-sm-0,.gx-sm-0{
    --bs-gutter-x: 0
  }

  .g-sm-0,.gy-sm-0{
    --bs-gutter-y: 0
  }

  .g-sm-1,.gx-sm-1{
    --bs-gutter-x: 0.25rem
  }

  .g-sm-1,.gy-sm-1{
    --bs-gutter-y: 0.25rem
  }

  .g-sm-2,.gx-sm-2{
    --bs-gutter-x: 0.5rem
  }

  .g-sm-2,.gy-sm-2{
    --bs-gutter-y: 0.5rem
  }

  .g-sm-3,.gx-sm-3{
    --bs-gutter-x: 1rem
  }

  .g-sm-3,.gy-sm-3{
    --bs-gutter-y: 1rem
  }

  .g-sm-4,.gx-sm-4{
    --bs-gutter-x: 1.5rem
  }

  .g-sm-4,.gy-sm-4{
    --bs-gutter-y: 1.5rem
  }

  .g-sm-5,.gx-sm-5{
    --bs-gutter-x: 3rem
  }

  .g-sm-5,.gy-sm-5{
    --bs-gutter-y: 3rem
  }
}

@media(min-width: 768px){
  .col-md{
    flex:1 0 0%
  }

  .row-cols-md-auto>*{
    flex:0 0 auto;
    width:auto
  }

  .row-cols-md-1>*{
    flex:0 0 auto;
    width:100%
  }

  .row-cols-md-2>*{
    flex:0 0 auto;
    width:50%
  }

  .row-cols-md-3>*{
    flex:0 0 auto;
    width:33.33333333%
  }

  .row-cols-md-4>*{
    flex:0 0 auto;
    width:25%
  }

  .row-cols-md-5>*{
    flex:0 0 auto;
    width:20%
  }

  .row-cols-md-6>*{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-md-auto{
    flex:0 0 auto;
    width:auto
  }

  .col-md-1{
    flex:0 0 auto;
    width:8.33333333%
  }

  .col-md-2{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-md-3{
    flex:0 0 auto;
    width:25%
  }

  .col-md-4{
    flex:0 0 auto;
    width:33.33333333%
  }

  .col-md-5{
    flex:0 0 auto;
    width:41.66666667%
  }

  .col-md-6{
    flex:0 0 auto;
    width:50%
  }

  .col-md-7{
    flex:0 0 auto;
    width:58.33333333%
  }

  .col-md-8{
    flex:0 0 auto;
    width:66.66666667%
  }

  .col-md-9{
    flex:0 0 auto;
    width:75%
  }

  .col-md-10{
    flex:0 0 auto;
    width:83.33333333%
  }

  .col-md-11{
    flex:0 0 auto;
    width:91.66666667%
  }

  .col-md-12{
    flex:0 0 auto;
    width:100%
  }

  .offset-md-0{
    margin-left:0
  }

  .offset-md-1{
    margin-left:8.33333333%
  }

  .offset-md-2{
    margin-left:16.66666667%
  }

  .offset-md-3{
    margin-left:25%
  }

  .offset-md-4{
    margin-left:33.33333333%
  }

  .offset-md-5{
    margin-left:41.66666667%
  }

  .offset-md-6{
    margin-left:50%
  }

  .offset-md-7{
    margin-left:58.33333333%
  }

  .offset-md-8{
    margin-left:66.66666667%
  }

  .offset-md-9{
    margin-left:75%
  }

  .offset-md-10{
    margin-left:83.33333333%
  }

  .offset-md-11{
    margin-left:91.66666667%
  }

  .g-md-0,.gx-md-0{
    --bs-gutter-x: 0
  }

  .g-md-0,.gy-md-0{
    --bs-gutter-y: 0
  }

  .g-md-1,.gx-md-1{
    --bs-gutter-x: 0.25rem
  }

  .g-md-1,.gy-md-1{
    --bs-gutter-y: 0.25rem
  }

  .g-md-2,.gx-md-2{
    --bs-gutter-x: 0.5rem
  }

  .g-md-2,.gy-md-2{
    --bs-gutter-y: 0.5rem
  }

  .g-md-3,.gx-md-3{
    --bs-gutter-x: 1rem
  }

  .g-md-3,.gy-md-3{
    --bs-gutter-y: 1rem
  }

  .g-md-4,.gx-md-4{
    --bs-gutter-x: 1.5rem
  }

  .g-md-4,.gy-md-4{
    --bs-gutter-y: 1.5rem
  }

  .g-md-5,.gx-md-5{
    --bs-gutter-x: 3rem
  }

  .g-md-5,.gy-md-5{
    --bs-gutter-y: 3rem
  }
}

@media(min-width: 992px){
  .col-lg{
    flex:1 0 0%
  }

  .row-cols-lg-auto>*{
    flex:0 0 auto;
    width:auto
  }

  .row-cols-lg-1>*{
    flex:0 0 auto;
    width:100%
  }

  .row-cols-lg-2>*{
    flex:0 0 auto;
    width:50%
  }

  .row-cols-lg-3>*{
    flex:0 0 auto;
    width:33.33333333%
  }

  .row-cols-lg-4>*{
    flex:0 0 auto;
    width:25%
  }

  .row-cols-lg-5>*{
    flex:0 0 auto;
    width:20%
  }

  .row-cols-lg-6>*{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-lg-auto{
    flex:0 0 auto;
    width:auto
  }

  .col-lg-1{
    flex:0 0 auto;
    width:8.33333333%
  }

  .col-lg-2{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-lg-3{
    flex:0 0 auto;
    width:25%
  }

  .col-lg-4{
    flex:0 0 auto;
    width:33.33333333%
  }

  .col-lg-5{
    flex:0 0 auto;
    width:41.66666667%
  }

  .col-lg-6{
    flex:0 0 auto;
    width:50%
  }

  .col-lg-7{
    flex:0 0 auto;
    width:58.33333333%
  }

  .col-lg-8{
    flex:0 0 auto;
    width:66.66666667%
  }

  .col-lg-9{
    flex:0 0 auto;
    width:75%
  }

  .col-lg-10{
    flex:0 0 auto;
    width:83.33333333%
  }

  .col-lg-11{
    flex:0 0 auto;
    width:91.66666667%
  }

  .col-lg-12{
    flex:0 0 auto;
    width:100%
  }

  .offset-lg-0{
    margin-left:0
  }

  .offset-lg-1{
    margin-left:8.33333333%
  }

  .offset-lg-2{
    margin-left:16.66666667%
  }

  .offset-lg-3{
    margin-left:25%
  }

  .offset-lg-4{
    margin-left:33.33333333%
  }

  .offset-lg-5{
    margin-left:41.66666667%
  }

  .offset-lg-6{
    margin-left:50%
  }

  .offset-lg-7{
    margin-left:58.33333333%
  }

  .offset-lg-8{
    margin-left:66.66666667%
  }

  .offset-lg-9{
    margin-left:75%
  }

  .offset-lg-10{
    margin-left:83.33333333%
  }

  .offset-lg-11{
    margin-left:91.66666667%
  }

  .g-lg-0,.gx-lg-0{
    --bs-gutter-x: 0
  }

  .g-lg-0,.gy-lg-0{
    --bs-gutter-y: 0
  }

  .g-lg-1,.gx-lg-1{
    --bs-gutter-x: 0.25rem
  }

  .g-lg-1,.gy-lg-1{
    --bs-gutter-y: 0.25rem
  }

  .g-lg-2,.gx-lg-2{
    --bs-gutter-x: 0.5rem
  }

  .g-lg-2,.gy-lg-2{
    --bs-gutter-y: 0.5rem
  }

  .g-lg-3,.gx-lg-3{
    --bs-gutter-x: 1rem
  }

  .g-lg-3,.gy-lg-3{
    --bs-gutter-y: 1rem
  }

  .g-lg-4,.gx-lg-4{
    --bs-gutter-x: 1.5rem
  }

  .g-lg-4,.gy-lg-4{
    --bs-gutter-y: 1.5rem
  }

  .g-lg-5,.gx-lg-5{
    --bs-gutter-x: 3rem
  }

  .g-lg-5,.gy-lg-5{
    --bs-gutter-y: 3rem
  }
}

@media(min-width: 1200px){
  .col-xl{
    flex:1 0 0%
  }

  .row-cols-xl-auto>*{
    flex:0 0 auto;
    width:auto
  }

  .row-cols-xl-1>*{
    flex:0 0 auto;
    width:100%
  }

  .row-cols-xl-2>*{
    flex:0 0 auto;
    width:50%
  }

  .row-cols-xl-3>*{
    flex:0 0 auto;
    width:33.33333333%
  }

  .row-cols-xl-4>*{
    flex:0 0 auto;
    width:25%
  }

  .row-cols-xl-5>*{
    flex:0 0 auto;
    width:20%
  }

  .row-cols-xl-6>*{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-xl-auto{
    flex:0 0 auto;
    width:auto
  }

  .col-xl-1{
    flex:0 0 auto;
    width:8.33333333%
  }

  .col-xl-2{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-xl-3{
    flex:0 0 auto;
    width:25%
  }

  .col-xl-4{
    flex:0 0 auto;
    width:33.33333333%
  }

  .col-xl-5{
    flex:0 0 auto;
    width:41.66666667%
  }

  .col-xl-6{
    flex:0 0 auto;
    width:50%
  }

  .col-xl-7{
    flex:0 0 auto;
    width:58.33333333%
  }

  .col-xl-8{
    flex:0 0 auto;
    width:66.66666667%
  }

  .col-xl-9{
    flex:0 0 auto;
    width:75%
  }

  .col-xl-10{
    flex:0 0 auto;
    width:83.33333333%
  }

  .col-xl-11{
    flex:0 0 auto;
    width:91.66666667%
  }

  .col-xl-12{
    flex:0 0 auto;
    width:100%
  }

  .offset-xl-0{
    margin-left:0
  }

  .offset-xl-1{
    margin-left:8.33333333%
  }

  .offset-xl-2{
    margin-left:16.66666667%
  }

  .offset-xl-3{
    margin-left:25%
  }

  .offset-xl-4{
    margin-left:33.33333333%
  }

  .offset-xl-5{
    margin-left:41.66666667%
  }

  .offset-xl-6{
    margin-left:50%
  }

  .offset-xl-7{
    margin-left:58.33333333%
  }

  .offset-xl-8{
    margin-left:66.66666667%
  }

  .offset-xl-9{
    margin-left:75%
  }

  .offset-xl-10{
    margin-left:83.33333333%
  }

  .offset-xl-11{
    margin-left:91.66666667%
  }

  .g-xl-0,.gx-xl-0{
    --bs-gutter-x: 0
  }

  .g-xl-0,.gy-xl-0{
    --bs-gutter-y: 0
  }

  .g-xl-1,.gx-xl-1{
    --bs-gutter-x: 0.25rem
  }

  .g-xl-1,.gy-xl-1{
    --bs-gutter-y: 0.25rem
  }

  .g-xl-2,.gx-xl-2{
    --bs-gutter-x: 0.5rem
  }

  .g-xl-2,.gy-xl-2{
    --bs-gutter-y: 0.5rem
  }

  .g-xl-3,.gx-xl-3{
    --bs-gutter-x: 1rem
  }

  .g-xl-3,.gy-xl-3{
    --bs-gutter-y: 1rem
  }

  .g-xl-4,.gx-xl-4{
    --bs-gutter-x: 1.5rem
  }

  .g-xl-4,.gy-xl-4{
    --bs-gutter-y: 1.5rem
  }

  .g-xl-5,.gx-xl-5{
    --bs-gutter-x: 3rem
  }

  .g-xl-5,.gy-xl-5{
    --bs-gutter-y: 3rem
  }
}

@media(min-width: 1400px){
  .col-xxl{
    flex:1 0 0%
  }

  .row-cols-xxl-auto>*{
    flex:0 0 auto;
    width:auto
  }

  .row-cols-xxl-1>*{
    flex:0 0 auto;
    width:100%
  }

  .row-cols-xxl-2>*{
    flex:0 0 auto;
    width:50%
  }

  .row-cols-xxl-3>*{
    flex:0 0 auto;
    width:33.33333333%
  }

  .row-cols-xxl-4>*{
    flex:0 0 auto;
    width:25%
  }

  .row-cols-xxl-5>*{
    flex:0 0 auto;
    width:20%
  }

  .row-cols-xxl-6>*{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-xxl-auto{
    flex:0 0 auto;
    width:auto
  }

  .col-xxl-1{
    flex:0 0 auto;
    width:8.33333333%
  }

  .col-xxl-2{
    flex:0 0 auto;
    width:16.66666667%
  }

  .col-xxl-3{
    flex:0 0 auto;
    width:25%
  }

  .col-xxl-4{
    flex:0 0 auto;
    width:33.33333333%
  }

  .col-xxl-5{
    flex:0 0 auto;
    width:41.66666667%
  }

  .col-xxl-6{
    flex:0 0 auto;
    width:50%
  }

  .col-xxl-7{
    flex:0 0 auto;
    width:58.33333333%
  }

  .col-xxl-8{
    flex:0 0 auto;
    width:66.66666667%
  }

  .col-xxl-9{
    flex:0 0 auto;
    width:75%
  }

  .col-xxl-10{
    flex:0 0 auto;
    width:83.33333333%
  }

  .col-xxl-11{
    flex:0 0 auto;
    width:91.66666667%
  }

  .col-xxl-12{
    flex:0 0 auto;
    width:100%
  }

  .offset-xxl-0{
    margin-left:0
  }

  .offset-xxl-1{
    margin-left:8.33333333%
  }

  .offset-xxl-2{
    margin-left:16.66666667%
  }

  .offset-xxl-3{
    margin-left:25%
  }

  .offset-xxl-4{
    margin-left:33.33333333%
  }

  .offset-xxl-5{
    margin-left:41.66666667%
  }

  .offset-xxl-6{
    margin-left:50%
  }

  .offset-xxl-7{
    margin-left:58.33333333%
  }

  .offset-xxl-8{
    margin-left:66.66666667%
  }

  .offset-xxl-9{
    margin-left:75%
  }

  .offset-xxl-10{
    margin-left:83.33333333%
  }

  .offset-xxl-11{
    margin-left:91.66666667%
  }

  .g-xxl-0,.gx-xxl-0{
    --bs-gutter-x: 0
  }

  .g-xxl-0,.gy-xxl-0{
    --bs-gutter-y: 0
  }

  .g-xxl-1,.gx-xxl-1{
    --bs-gutter-x: 0.25rem
  }

  .g-xxl-1,.gy-xxl-1{
    --bs-gutter-y: 0.25rem
  }

  .g-xxl-2,.gx-xxl-2{
    --bs-gutter-x: 0.5rem
  }

  .g-xxl-2,.gy-xxl-2{
    --bs-gutter-y: 0.5rem
  }

  .g-xxl-3,.gx-xxl-3{
    --bs-gutter-x: 1rem
  }

  .g-xxl-3,.gy-xxl-3{
    --bs-gutter-y: 1rem
  }

  .g-xxl-4,.gx-xxl-4{
    --bs-gutter-x: 1.5rem
  }

  .g-xxl-4,.gy-xxl-4{
    --bs-gutter-y: 1.5rem
  }

  .g-xxl-5,.gx-xxl-5{
    --bs-gutter-x: 3rem
  }

  .g-xxl-5,.gy-xxl-5{
    --bs-gutter-y: 3rem
  }
}

.table{
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width:100%;
  margin-bottom:1rem;
  vertical-align:top;
  border-color:var(--bs-table-border-color)
}

.table>:not(caption)>*>*{
  padding:.5rem .5rem;
  color:var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color:var(--bs-table-bg);
  border-bottom-width:var(--bs-border-width);
  box-shadow:inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)))
}

.table>tbody{
  vertical-align:inherit
}

.table>thead{
  vertical-align:bottom
}

.table-group-divider{
  border-top:calc(var(--bs-border-width)*2) solid currentcolor
}

.caption-top{
  caption-side:top
}

.table-sm>:not(caption)>*>*{
  padding:.25rem .25rem
}

.table-bordered>:not(caption)>*{
  border-width:var(--bs-border-width) 0
}

.table-bordered>:not(caption)>*>*{
  border-width:0 var(--bs-border-width)
}

.table-borderless>:not(caption)>*>*{
  border-bottom-width:0
}

.table-borderless>:not(:first-child){
  border-top-width:0
}

.table-striped>tbody>tr:nth-of-type(odd)>*{
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg)
}

.table-striped-columns>:not(caption)>tr>:nth-child(even){
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg)
}

.table-active{
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg)
}

.table-hover>tbody>tr:hover>*{
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg)
}

.table-primary{
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-secondary{
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-success{
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-info{
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-warning{
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-danger{
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-light{
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-dark{
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color:var(--bs-table-color);
  border-color:var(--bs-table-border-color)
}

.table-responsive{
  overflow-x:auto;
  -webkit-overflow-scrolling:touch
}

@media(max-width: 575.98px){
  .table-responsive-sm{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch
  }
}

@media(max-width: 767.98px){
  .table-responsive-md{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch
  }
}

@media(max-width: 991.98px){
  .table-responsive-lg{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch
  }
}

@media(max-width: 1199.98px){
  .table-responsive-xl{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch
  }
}

@media(max-width: 1399.98px){
  .table-responsive-xxl{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch
  }
}

.btn{
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size:1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display:inline-block;
  padding:var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family:var(--bs-btn-font-family);
  font-size:var(--bs-btn-font-size);
  font-weight:var(--bs-btn-font-weight);
  line-height:var(--bs-btn-line-height);
  color:var(--bs-btn-color);
  text-align:center;
  text-decoration:none;
  vertical-align:middle;
  cursor:pointer;
  user-select:none;
  border:var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius:var(--bs-btn-border-radius);
  background-color:var(--bs-btn-bg);
  transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out
}

@media(prefers-reduced-motion: reduce){
  .btn{
    transition:none
  }
}

.btn:hover{
  color:var(--bs-btn-hover-color);
  background-color:var(--bs-btn-hover-bg);
  border-color:var(--bs-btn-hover-border-color)
}

.btn-check+.btn:hover{
  color:var(--bs-btn-color);
  background-color:var(--bs-btn-bg);
  border-color:var(--bs-btn-border-color)
}

.btn:focus-visible{
  color:var(--bs-btn-hover-color);
  background-color:var(--bs-btn-hover-bg);
  border-color:var(--bs-btn-hover-border-color);
  outline:0;
  box-shadow:var(--bs-btn-focus-box-shadow)
}

.btn-check:focus-visible+.btn{
  border-color:var(--bs-btn-hover-border-color);
  outline:0;
  box-shadow:var(--bs-btn-focus-box-shadow)
}

.btn-check:checked+.btn,:not(.btn-check)+.btn:active,.btn:first-child:active,.btn.active,.btn.show{
  color:var(--bs-btn-active-color);
  background-color:var(--bs-btn-active-bg);
  border-color:var(--bs-btn-active-border-color)
}

.btn-check:checked+.btn:focus-visible,:not(.btn-check)+.btn:active:focus-visible,.btn:first-child:active:focus-visible,.btn.active:focus-visible,.btn.show:focus-visible{
  box-shadow:var(--bs-btn-focus-box-shadow)
}

.btn:disabled,.btn.disabled,fieldset:disabled .btn{
  color:var(--bs-btn-disabled-color);
  pointer-events:none;
  background-color:var(--bs-btn-disabled-bg);
  border-color:var(--bs-btn-disabled-border-color);
  opacity:var(--bs-btn-disabled-opacity)
}

.btn-primary{
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd
}

.btn-secondary{
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d
}

.btn-success{
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754
}

.btn-info{
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0
}

.btn-warning{
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107
}

.btn-danger{
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545
}

.btn-light{
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa
}

.btn-dark{
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529
}

.btn-dark-primary{
  --bs-btn-color: #fff;
  --bs-btn-bg: #252f3f;
  --bs-btn-border-color: #252f3f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1f2836;
  --bs-btn-hover-border-color: #1e2632;
  --bs-btn-focus-shadow-rgb: 70, 78, 92;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1e2632;
  --bs-btn-active-border-color: #1c232f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #252f3f;
  --bs-btn-disabled-border-color: #252f3f
}

.btn-outline-primary{
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none
}

.btn-outline-secondary{
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none
}

.btn-outline-success{
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none
}

.btn-outline-info{
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none
}

.btn-outline-warning{
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none
}

.btn-outline-danger{
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none
}

.btn-outline-light{
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none
}

.btn-outline-dark{
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none
}

.btn-outline-dark-primary{
  --bs-btn-color: #252f3f;
  --bs-btn-border-color: #252f3f;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #252f3f;
  --bs-btn-hover-border-color: #252f3f;
  --bs-btn-focus-shadow-rgb: 37, 47, 63;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #252f3f;
  --bs-btn-active-border-color: #252f3f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #252f3f;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #252f3f;
  --bs-gradient: none
}

.btn-link{
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration:underline
}

.btn-link:focus-visible{
  color:var(--bs-btn-color)
}

.btn-link:hover{
  color:var(--bs-btn-hover-color)
}

.btn-lg,.btn-group-lg>.btn{
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size:1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg)
}

.btn-sm,.btn-group-sm>.btn{
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size:0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm)
}

.fade{
  transition:opacity .15s linear
}

@media(prefers-reduced-motion: reduce){
  .fade{
    transition:none
  }
}

.fade:not(.show){
  opacity:0
}

.collapse:not(.show){
  display:none
}

.collapsing{
  height:0;
  overflow:hidden;
  transition:height .35s ease
}

@media(prefers-reduced-motion: reduce){
  .collapsing{
    transition:none
  }
}

.collapsing.collapse-horizontal{
  width:0;
  height:auto;
  transition:width .35s ease
}

@media(prefers-reduced-motion: reduce){
  .collapsing.collapse-horizontal{
    transition:none
  }
}

.btn-group,.btn-group-vertical{
  position:relative;
  display:inline-flex;
  vertical-align:middle
}

.btn-group>.btn,.btn-group-vertical>.btn{
  position:relative;
  flex:1 1 auto
}

.btn-group>.btn-check:checked+.btn,.btn-group>.btn-check:focus+.btn,.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn-check:checked+.btn,.btn-group-vertical>.btn-check:focus+.btn,.btn-group-vertical>.btn:hover,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn.active{
  z-index:1
}

.btn-toolbar{
  display:flex;
  flex-wrap:wrap;
  justify-content:flex-start
}

.btn-toolbar .input-group{
  width:auto
}

.btn-group{
  border-radius:var(--bs-border-radius)
}

.btn-group>:not(.btn-check:first-child)+.btn,.btn-group>.btn-group:not(:first-child){
  margin-left:calc(var(--bs-border-width)*-1)
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),.btn-group>.btn.dropdown-toggle-split:first-child,.btn-group>.btn-group:not(:last-child)>.btn{
  border-top-right-radius:0;
  border-bottom-right-radius:0
}

.btn-group>.btn:nth-child(n+3),.btn-group>:not(.btn-check)+.btn,.btn-group>.btn-group:not(:first-child)>.btn{
  border-top-left-radius:0;
  border-bottom-left-radius:0
}

.dropdown-toggle-split{
  padding-right:.5625rem;
  padding-left:.5625rem
}

.dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after,.dropend .dropdown-toggle-split::after{
  margin-left:0
}

.dropstart .dropdown-toggle-split::before{
  margin-right:0
}

.btn-sm+.dropdown-toggle-split,.btn-group-sm>.btn+.dropdown-toggle-split{
  padding-right:.375rem;
  padding-left:.375rem
}

.btn-lg+.dropdown-toggle-split,.btn-group-lg>.btn+.dropdown-toggle-split{
  padding-right:.75rem;
  padding-left:.75rem
}

.btn-group-vertical{
  flex-direction:column;
  align-items:flex-start;
  justify-content:center
}

.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{
  width:100%
}

.btn-group-vertical>.btn:not(:first-child),.btn-group-vertical>.btn-group:not(:first-child){
  margin-top:calc(var(--bs-border-width)*-1)
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.btn-group-vertical>.btn-group:not(:last-child)>.btn{
  border-bottom-right-radius:0;
  border-bottom-left-radius:0
}

.btn-group-vertical>.btn~.btn,.btn-group-vertical>.btn-group:not(:first-child)>.btn{
  border-top-left-radius:0;
  border-top-right-radius:0
}

.nav{
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display:flex;
  flex-wrap:wrap;
  padding-left:0;
  margin-bottom:0;
  list-style:none
}

.nav-link{
  display:block;
  padding:var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size:var(--bs-nav-link-font-size);
  font-weight:var(--bs-nav-link-font-weight);
  color:var(--bs-nav-link-color);
  text-decoration:none;
  background:none;
  border:0;
  transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out
}

@media(prefers-reduced-motion: reduce){
  .nav-link{
    transition:none
  }
}

.nav-link:hover,.nav-link:focus{
  color:var(--bs-nav-link-hover-color)
}

.nav-link:focus-visible{
  outline:0;
  box-shadow:0 0 0 .25rem rgba(13,110,253,.25)
}

.nav-link.disabled,.nav-link:disabled{
  color:var(--bs-nav-link-disabled-color);
  pointer-events:none;
  cursor:default
}

.nav-tabs{
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom:var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)
}

.nav-tabs .nav-link{
  margin-bottom:calc(-1*var(--bs-nav-tabs-border-width));
  border:var(--bs-nav-tabs-border-width) solid rgba(0,0,0,0);
  border-top-left-radius:var(--bs-nav-tabs-border-radius);
  border-top-right-radius:var(--bs-nav-tabs-border-radius)
}

.nav-tabs .nav-link:hover,.nav-tabs .nav-link:focus{
  isolation:isolate;
  border-color:var(--bs-nav-tabs-link-hover-border-color)
}

.nav-tabs .nav-link.active,.nav-tabs .nav-item.show .nav-link{
  color:var(--bs-nav-tabs-link-active-color);
  background-color:var(--bs-nav-tabs-link-active-bg);
  border-color:var(--bs-nav-tabs-link-active-border-color)
}

.nav-tabs .dropdown-menu{
  margin-top:calc(-1*var(--bs-nav-tabs-border-width));
  border-top-left-radius:0;
  border-top-right-radius:0
}

.nav-pills{
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd
}

.nav-pills .nav-link{
  border-radius:var(--bs-nav-pills-border-radius)
}

.nav-pills .nav-link.active,.nav-pills .show>.nav-link{
  color:var(--bs-nav-pills-link-active-color);
  background-color:var(--bs-nav-pills-link-active-bg)
}

.nav-underline{
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap:var(--bs-nav-underline-gap)
}

.nav-underline .nav-link{
  padding-right:0;
  padding-left:0;
  border-bottom:var(--bs-nav-underline-border-width) solid rgba(0,0,0,0)
}

.nav-underline .nav-link:hover,.nav-underline .nav-link:focus{
  border-bottom-color:currentcolor
}

.nav-underline .nav-link.active,.nav-underline .show>.nav-link{
  font-weight:700;
  color:var(--bs-nav-underline-link-active-color);
  border-bottom-color:currentcolor
}

.nav-fill>.nav-link,.nav-fill .nav-item{
  flex:1 1 auto;
  text-align:center
}

.nav-justified>.nav-link,.nav-justified .nav-item{
  flex-basis:0;
  flex-grow:1;
  text-align:center
}

.nav-fill .nav-item .nav-link,.nav-justified .nav-item .nav-link{
  width:100%
}

.tab-content>.tab-pane{
  display:none
}

.tab-content>.active{
  display:block
}

.navbar{
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position:relative;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  justify-content:space-between;
  padding:var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)
}

.navbar>.container,.navbar>.container-fluid,.navbar>.container-sm,.navbar>.container-md,.navbar>.container-lg,.navbar>.container-xl,.navbar>.container-xxl{
  display:flex;
  flex-wrap:inherit;
  align-items:center;
  justify-content:space-between
}

.navbar-brand{
  padding-top:var(--bs-navbar-brand-padding-y);
  padding-bottom:var(--bs-navbar-brand-padding-y);
  margin-right:var(--bs-navbar-brand-margin-end);
  font-size:var(--bs-navbar-brand-font-size);
  color:var(--bs-navbar-brand-color);
  text-decoration:none;
  white-space:nowrap
}

.navbar-brand:hover,.navbar-brand:focus{
  color:var(--bs-navbar-brand-hover-color)
}

.navbar-nav{
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display:flex;
  flex-direction:column;
  padding-left:0;
  margin-bottom:0;
  list-style:none
}

.navbar-nav .nav-link.active,.navbar-nav .nav-link.show{
  color:var(--bs-navbar-active-color)
}

.navbar-nav .dropdown-menu{
  position:static
}

.navbar-text{
  padding-top:.5rem;
  padding-bottom:.5rem;
  color:var(--bs-navbar-color)
}

.navbar-text a,.navbar-text a:hover,.navbar-text a:focus{
  color:var(--bs-navbar-active-color)
}

.navbar-collapse{
  flex-basis:100%;
  flex-grow:1;
  align-items:center
}

.navbar-toggler{
  padding:var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size:var(--bs-navbar-toggler-font-size);
  line-height:1;
  color:var(--bs-navbar-color);
  background-color:rgba(0,0,0,0);
  border:var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius:var(--bs-navbar-toggler-border-radius);
  transition:var(--bs-navbar-toggler-transition)
}

@media(prefers-reduced-motion: reduce){
  .navbar-toggler{
    transition:none
  }
}

.navbar-toggler:hover{
  text-decoration:none
}

.navbar-toggler:focus{
  text-decoration:none;
  outline:0;
  box-shadow:0 0 0 var(--bs-navbar-toggler-focus-width)
}

.navbar-toggler-icon{
  display:inline-block;
  width:1.5em;
  height:1.5em;
  vertical-align:middle;
  background-image:var(--bs-navbar-toggler-icon-bg);
  background-repeat:no-repeat;
  background-position:center;
  background-size:100%
}

.navbar-nav-scroll{
  max-height:var(--bs-scroll-height, 75vh);
  overflow-y:auto
}

@media(min-width: 576px){
  .navbar-expand-sm{
    flex-wrap:nowrap;
    justify-content:flex-start
  }

  .navbar-expand-sm .navbar-nav{
    flex-direction:row
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu{
    position:absolute
  }

  .navbar-expand-sm .navbar-nav .nav-link{
    padding-right:var(--bs-navbar-nav-link-padding-x);
    padding-left:var(--bs-navbar-nav-link-padding-x)
  }

  .navbar-expand-sm .navbar-nav-scroll{
    overflow:visible
  }

  .navbar-expand-sm .navbar-collapse{
    display:flex !important;
    flex-basis:auto
  }

  .navbar-expand-sm .navbar-toggler{
    display:none
  }

  .navbar-expand-sm .offcanvas{
    position:static;
    z-index:auto;
    flex-grow:1;
    width:auto !important;
    height:auto !important;
    visibility:visible !important;
    background-color:rgba(0,0,0,0) !important;
    border:0 !important;
    transform:none !important;
    transition:none
  }

  .navbar-expand-sm .offcanvas .offcanvas-header{
    display:none
  }

  .navbar-expand-sm .offcanvas .offcanvas-body{
    display:flex;
    flex-grow:0;
    padding:0;
    overflow-y:visible
  }
}

@media(min-width: 768px){
  .navbar-expand-md{
    flex-wrap:nowrap;
    justify-content:flex-start
  }

  .navbar-expand-md .navbar-nav{
    flex-direction:row
  }

  .navbar-expand-md .navbar-nav .dropdown-menu{
    position:absolute
  }

  .navbar-expand-md .navbar-nav .nav-link{
    padding-right:var(--bs-navbar-nav-link-padding-x);
    padding-left:var(--bs-navbar-nav-link-padding-x)
  }

  .navbar-expand-md .navbar-nav-scroll{
    overflow:visible
  }

  .navbar-expand-md .navbar-collapse{
    display:flex !important;
    flex-basis:auto
  }

  .navbar-expand-md .navbar-toggler{
    display:none
  }

  .navbar-expand-md .offcanvas{
    position:static;
    z-index:auto;
    flex-grow:1;
    width:auto !important;
    height:auto !important;
    visibility:visible !important;
    background-color:rgba(0,0,0,0) !important;
    border:0 !important;
    transform:none !important;
    transition:none
  }

  .navbar-expand-md .offcanvas .offcanvas-header{
    display:none
  }

  .navbar-expand-md .offcanvas .offcanvas-body{
    display:flex;
    flex-grow:0;
    padding:0;
    overflow-y:visible
  }
}

@media(min-width: 992px){
  .navbar-expand-lg{
    flex-wrap:nowrap;
    justify-content:flex-start
  }

  .navbar-expand-lg .navbar-nav{
    flex-direction:row
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu{
    position:absolute
  }

  .navbar-expand-lg .navbar-nav .nav-link{
    padding-right:var(--bs-navbar-nav-link-padding-x);
    padding-left:var(--bs-navbar-nav-link-padding-x)
  }

  .navbar-expand-lg .navbar-nav-scroll{
    overflow:visible
  }

  .navbar-expand-lg .navbar-collapse{
    display:flex !important;
    flex-basis:auto
  }

  .navbar-expand-lg .navbar-toggler{
    display:none
  }

  .navbar-expand-lg .offcanvas{
    position:static;
    z-index:auto;
    flex-grow:1;
    width:auto !important;
    height:auto !important;
    visibility:visible !important;
    background-color:rgba(0,0,0,0) !important;
    border:0 !important;
    transform:none !important;
    transition:none
  }

  .navbar-expand-lg .offcanvas .offcanvas-header{
    display:none
  }

  .navbar-expand-lg .offcanvas .offcanvas-body{
    display:flex;
    flex-grow:0;
    padding:0;
    overflow-y:visible
  }
}

@media(min-width: 1200px){
  .navbar-expand-xl{
    flex-wrap:nowrap;
    justify-content:flex-start
  }

  .navbar-expand-xl .navbar-nav{
    flex-direction:row
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu{
    position:absolute
  }

  .navbar-expand-xl .navbar-nav .nav-link{
    padding-right:var(--bs-navbar-nav-link-padding-x);
    padding-left:var(--bs-navbar-nav-link-padding-x)
  }

  .navbar-expand-xl .navbar-nav-scroll{
    overflow:visible
  }

  .navbar-expand-xl .navbar-collapse{
    display:flex !important;
    flex-basis:auto
  }

  .navbar-expand-xl .navbar-toggler{
    display:none
  }

  .navbar-expand-xl .offcanvas{
    position:static;
    z-index:auto;
    flex-grow:1;
    width:auto !important;
    height:auto !important;
    visibility:visible !important;
    background-color:rgba(0,0,0,0) !important;
    border:0 !important;
    transform:none !important;
    transition:none
  }

  .navbar-expand-xl .offcanvas .offcanvas-header{
    display:none
  }

  .navbar-expand-xl .offcanvas .offcanvas-body{
    display:flex;
    flex-grow:0;
    padding:0;
    overflow-y:visible
  }
}

@media(min-width: 1400px){
  .navbar-expand-xxl{
    flex-wrap:nowrap;
    justify-content:flex-start
  }

  .navbar-expand-xxl .navbar-nav{
    flex-direction:row
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu{
    position:absolute
  }

  .navbar-expand-xxl .navbar-nav .nav-link{
    padding-right:var(--bs-navbar-nav-link-padding-x);
    padding-left:var(--bs-navbar-nav-link-padding-x)
  }

  .navbar-expand-xxl .navbar-nav-scroll{
    overflow:visible
  }

  .navbar-expand-xxl .navbar-collapse{
    display:flex !important;
    flex-basis:auto
  }

  .navbar-expand-xxl .navbar-toggler{
    display:none
  }

  .navbar-expand-xxl .offcanvas{
    position:static;
    z-index:auto;
    flex-grow:1;
    width:auto !important;
    height:auto !important;
    visibility:visible !important;
    background-color:rgba(0,0,0,0) !important;
    border:0 !important;
    transform:none !important;
    transition:none
  }

  .navbar-expand-xxl .offcanvas .offcanvas-header{
    display:none
  }

  .navbar-expand-xxl .offcanvas .offcanvas-body{
    display:flex;
    flex-grow:0;
    padding:0;
    overflow-y:visible
  }
}

.navbar-expand{
  flex-wrap:nowrap;
  justify-content:flex-start
}

.navbar-expand .navbar-nav{
  flex-direction:row
}

.navbar-expand .navbar-nav .dropdown-menu{
  position:absolute
}

.navbar-expand .navbar-nav .nav-link{
  padding-right:var(--bs-navbar-nav-link-padding-x);
  padding-left:var(--bs-navbar-nav-link-padding-x)
}

.navbar-expand .navbar-nav-scroll{
  overflow:visible
}

.navbar-expand .navbar-collapse{
  display:flex !important;
  flex-basis:auto
}

.navbar-expand .navbar-toggler{
  display:none
}

.navbar-expand .offcanvas{
  position:static;
  z-index:auto;
  flex-grow:1;
  width:auto !important;
  height:auto !important;
  visibility:visible !important;
  background-color:rgba(0,0,0,0) !important;
  border:0 !important;
  transform:none !important;
  transition:none
}

.navbar-expand .offcanvas .offcanvas-header{
  display:none
}

.navbar-expand .offcanvas .offcanvas-body{
  display:flex;
  flex-grow:0;
  padding:0;
  overflow-y:visible
}

.navbar-dark,.navbar[data-bs-theme=dark]{
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

[data-bs-theme=dark] .navbar-toggler-icon{
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

.card{
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position:relative;
  display:flex;
  flex-direction:column;
  min-width:0;
  height:var(--bs-card-height);
  color:var(--bs-body-color);
  word-wrap:break-word;
  background-color:var(--bs-card-bg);
  background-clip:border-box;
  border:var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius:var(--bs-card-border-radius)
}

.card>hr{
  margin-right:0;
  margin-left:0
}

.card>.list-group{
  border-top:inherit;
  border-bottom:inherit
}

.card>.list-group:first-child{
  border-top-width:0;
  border-top-left-radius:var(--bs-card-inner-border-radius);
  border-top-right-radius:var(--bs-card-inner-border-radius)
}

.card>.list-group:last-child{
  border-bottom-width:0;
  border-bottom-right-radius:var(--bs-card-inner-border-radius);
  border-bottom-left-radius:var(--bs-card-inner-border-radius)
}

.card>.card-header+.list-group,.card>.list-group+.card-footer{
  border-top:0
}

.card-body{
  flex:1 1 auto;
  padding:var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color:var(--bs-card-color)
}

.card-title{
  margin-bottom:var(--bs-card-title-spacer-y);
  color:var(--bs-card-title-color)
}

.card-subtitle{
  margin-top:calc(-0.5*var(--bs-card-title-spacer-y));
  margin-bottom:0;
  color:var(--bs-card-subtitle-color)
}

.card-text:last-child{
  margin-bottom:0
}

.card-link+.card-link{
  margin-left:var(--bs-card-spacer-x)
}

.card-header{
  padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom:0;
  color:var(--bs-card-cap-color);
  background-color:var(--bs-card-cap-bg);
  border-bottom:var(--bs-card-border-width) solid var(--bs-card-border-color)
}

.card-header:first-child{
  border-radius:var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0
}

.card-footer{
  padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color:var(--bs-card-cap-color);
  background-color:var(--bs-card-cap-bg);
  border-top:var(--bs-card-border-width) solid var(--bs-card-border-color)
}

.card-footer:last-child{
  border-radius:0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)
}

.card-header-tabs{
  margin-right:calc(-0.5*var(--bs-card-cap-padding-x));
  margin-bottom:calc(-1*var(--bs-card-cap-padding-y));
  margin-left:calc(-0.5*var(--bs-card-cap-padding-x));
  border-bottom:0
}

.card-header-tabs .nav-link.active{
  background-color:var(--bs-card-bg);
  border-bottom-color:var(--bs-card-bg)
}

.card-header-pills{
  margin-right:calc(-0.5*var(--bs-card-cap-padding-x));
  margin-left:calc(-0.5*var(--bs-card-cap-padding-x))
}

.card-img-overlay{
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  padding:var(--bs-card-img-overlay-padding);
  border-radius:var(--bs-card-inner-border-radius)
}

.card-img,.card-img-top,.card-img-bottom{
  width:100%
}

.card-img,.card-img-top{
  border-top-left-radius:var(--bs-card-inner-border-radius);
  border-top-right-radius:var(--bs-card-inner-border-radius)
}

.card-img,.card-img-bottom{
  border-bottom-right-radius:var(--bs-card-inner-border-radius);
  border-bottom-left-radius:var(--bs-card-inner-border-radius)
}

.card-group>.card{
  margin-bottom:var(--bs-card-group-margin)
}

@media(min-width: 576px){
  .card-group{
    display:flex;
    flex-flow:row wrap
  }

  .card-group>.card{
    flex:1 0 0%;
    margin-bottom:0
  }

  .card-group>.card+.card{
    margin-left:0;
    border-left:0
  }

  .card-group>.card:not(:last-child){
    border-top-right-radius:0;
    border-bottom-right-radius:0
  }

  .card-group>.card:not(:last-child) .card-img-top,.card-group>.card:not(:last-child) .card-header{
    border-top-right-radius:0
  }

  .card-group>.card:not(:last-child) .card-img-bottom,.card-group>.card:not(:last-child) .card-footer{
    border-bottom-right-radius:0
  }

  .card-group>.card:not(:first-child){
    border-top-left-radius:0;
    border-bottom-left-radius:0
  }

  .card-group>.card:not(:first-child) .card-img-top,.card-group>.card:not(:first-child) .card-header{
    border-top-left-radius:0
  }

  .card-group>.card:not(:first-child) .card-img-bottom,.card-group>.card:not(:first-child) .card-footer{
    border-bottom-left-radius:0
  }
}

.badge{
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size:0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display:inline-block;
  padding:var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size:var(--bs-badge-font-size);
  font-weight:var(--bs-badge-font-weight);
  line-height:1;
  color:var(--bs-badge-color);
  text-align:center;
  white-space:nowrap;
  vertical-align:baseline;
  border-radius:var(--bs-badge-border-radius)
}

.badge:empty{
  display:none
}

.btn .badge{
  position:relative;
  top:-1px
}

.alert{
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position:relative;
  padding:var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom:var(--bs-alert-margin-bottom);
  color:var(--bs-alert-color);
  background-color:var(--bs-alert-bg);
  border:var(--bs-alert-border);
  border-radius:var(--bs-alert-border-radius)
}

.alert-heading{
  color:inherit
}

.alert-link{
  font-weight:700;
  color:var(--bs-alert-link-color)
}

.alert-dismissible{
  padding-right:3rem
}

.alert-dismissible .btn-close{
  position:absolute;
  top:0;
  right:0;
  z-index:2;
  padding:1.25rem 1rem
}

.alert-primary{
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis)
}

.alert-secondary{
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis)
}

.alert-success{
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis)
}

.alert-info{
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis)
}

.alert-warning{
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis)
}

.alert-danger{
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis)
}

.alert-light{
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis)
}

.alert-dark{
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis)
}

.alert-dark-primary{
  --bs-alert-color: var(--bs-dark-primary-text-emphasis);
  --bs-alert-bg: var(--bs-dark-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-primary-border-subtle);
  --bs-alert-link-color: var(--bs-dark-primary-text-emphasis)
}

.list-group{
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display:flex;
  flex-direction:column;
  padding-left:0;
  margin-bottom:0;
  border-radius:var(--bs-list-group-border-radius)
}

.list-group-numbered{
  list-style-type:none;
  counter-reset:section
}

.list-group-numbered>.list-group-item::before{
  content:counters(section, ".") ". ";
  counter-increment:section
}

.list-group-item-action{
  width:100%;
  color:var(--bs-list-group-action-color);
  text-align:inherit
}

.list-group-item-action:hover,.list-group-item-action:focus{
  z-index:1;
  color:var(--bs-list-group-action-hover-color);
  text-decoration:none;
  background-color:var(--bs-list-group-action-hover-bg)
}

.list-group-item-action:active{
  color:var(--bs-list-group-action-active-color);
  background-color:var(--bs-list-group-action-active-bg)
}

.list-group-item{
  position:relative;
  display:block;
  padding:var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color:var(--bs-list-group-color);
  text-decoration:none;
  background-color:var(--bs-list-group-bg);
  border:var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)
}

.list-group-item:first-child{
  border-top-left-radius:inherit;
  border-top-right-radius:inherit
}

.list-group-item:last-child{
  border-bottom-right-radius:inherit;
  border-bottom-left-radius:inherit
}

.list-group-item.disabled,.list-group-item:disabled{
  color:var(--bs-list-group-disabled-color);
  pointer-events:none;
  background-color:var(--bs-list-group-disabled-bg)
}

.list-group-item.active{
  z-index:2;
  color:var(--bs-list-group-active-color);
  background-color:var(--bs-list-group-active-bg);
  border-color:var(--bs-list-group-active-border-color)
}

.list-group-item+.list-group-item{
  border-top-width:0
}

.list-group-item+.list-group-item.active{
  margin-top:calc(-1*var(--bs-list-group-border-width));
  border-top-width:var(--bs-list-group-border-width)
}

.list-group-horizontal{
  flex-direction:row
}

.list-group-horizontal>.list-group-item:first-child:not(:last-child){
  border-bottom-left-radius:var(--bs-list-group-border-radius);
  border-top-right-radius:0
}

.list-group-horizontal>.list-group-item:last-child:not(:first-child){
  border-top-right-radius:var(--bs-list-group-border-radius);
  border-bottom-left-radius:0
}

.list-group-horizontal>.list-group-item.active{
  margin-top:0
}

.list-group-horizontal>.list-group-item+.list-group-item{
  border-top-width:var(--bs-list-group-border-width);
  border-left-width:0
}

.list-group-horizontal>.list-group-item+.list-group-item.active{
  margin-left:calc(-1*var(--bs-list-group-border-width));
  border-left-width:var(--bs-list-group-border-width)
}

@media(min-width: 576px){
  .list-group-horizontal-sm{
    flex-direction:row
  }

  .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child){
    border-bottom-left-radius:var(--bs-list-group-border-radius);
    border-top-right-radius:0
  }

  .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child){
    border-top-right-radius:var(--bs-list-group-border-radius);
    border-bottom-left-radius:0
  }

  .list-group-horizontal-sm>.list-group-item.active{
    margin-top:0
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item{
    border-top-width:var(--bs-list-group-border-width);
    border-left-width:0
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active{
    margin-left:calc(-1*var(--bs-list-group-border-width));
    border-left-width:var(--bs-list-group-border-width)
  }
}

@media(min-width: 768px){
  .list-group-horizontal-md{
    flex-direction:row
  }

  .list-group-horizontal-md>.list-group-item:first-child:not(:last-child){
    border-bottom-left-radius:var(--bs-list-group-border-radius);
    border-top-right-radius:0
  }

  .list-group-horizontal-md>.list-group-item:last-child:not(:first-child){
    border-top-right-radius:var(--bs-list-group-border-radius);
    border-bottom-left-radius:0
  }

  .list-group-horizontal-md>.list-group-item.active{
    margin-top:0
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item{
    border-top-width:var(--bs-list-group-border-width);
    border-left-width:0
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active{
    margin-left:calc(-1*var(--bs-list-group-border-width));
    border-left-width:var(--bs-list-group-border-width)
  }
}

@media(min-width: 992px){
  .list-group-horizontal-lg{
    flex-direction:row
  }

  .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child){
    border-bottom-left-radius:var(--bs-list-group-border-radius);
    border-top-right-radius:0
  }

  .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child){
    border-top-right-radius:var(--bs-list-group-border-radius);
    border-bottom-left-radius:0
  }

  .list-group-horizontal-lg>.list-group-item.active{
    margin-top:0
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item{
    border-top-width:var(--bs-list-group-border-width);
    border-left-width:0
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active{
    margin-left:calc(-1*var(--bs-list-group-border-width));
    border-left-width:var(--bs-list-group-border-width)
  }
}

@media(min-width: 1200px){
  .list-group-horizontal-xl{
    flex-direction:row
  }

  .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child){
    border-bottom-left-radius:var(--bs-list-group-border-radius);
    border-top-right-radius:0
  }

  .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child){
    border-top-right-radius:var(--bs-list-group-border-radius);
    border-bottom-left-radius:0
  }

  .list-group-horizontal-xl>.list-group-item.active{
    margin-top:0
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item{
    border-top-width:var(--bs-list-group-border-width);
    border-left-width:0
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active{
    margin-left:calc(-1*var(--bs-list-group-border-width));
    border-left-width:var(--bs-list-group-border-width)
  }
}

@media(min-width: 1400px){
  .list-group-horizontal-xxl{
    flex-direction:row
  }

  .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child){
    border-bottom-left-radius:var(--bs-list-group-border-radius);
    border-top-right-radius:0
  }

  .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child){
    border-top-right-radius:var(--bs-list-group-border-radius);
    border-bottom-left-radius:0
  }

  .list-group-horizontal-xxl>.list-group-item.active{
    margin-top:0
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item{
    border-top-width:var(--bs-list-group-border-width);
    border-left-width:0
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active{
    margin-left:calc(-1*var(--bs-list-group-border-width));
    border-left-width:var(--bs-list-group-border-width)
  }
}

.list-group-flush{
  border-radius:0
}

.list-group-flush>.list-group-item{
  border-width:0 0 var(--bs-list-group-border-width)
}

.list-group-flush>.list-group-item:last-child{
  border-bottom-width:0
}

.list-group-item-primary{
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis)
}

.list-group-item-secondary{
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis)
}

.list-group-item-success{
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis)
}

.list-group-item-info{
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis)
}

.list-group-item-warning{
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis)
}

.list-group-item-danger{
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis)
}

.list-group-item-light{
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis)
}

.list-group-item-dark{
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis)
}

.list-group-item-dark-primary{
  --bs-list-group-color: var(--bs-dark-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-primary-text-emphasis)
}

.btn-close{
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing:content-box;
  width:1em;
  height:1em;
  padding:.25em .25em;
  color:var(--bs-btn-close-color);
  background:rgba(0,0,0,0) var(--bs-btn-close-bg) center/1em auto no-repeat;
  border:0;
  border-radius:.375rem;
  opacity:var(--bs-btn-close-opacity)
}

.btn-close:hover{
  color:var(--bs-btn-close-color);
  text-decoration:none;
  opacity:var(--bs-btn-close-hover-opacity)
}

.btn-close:focus{
  outline:0;
  box-shadow:var(--bs-btn-close-focus-shadow);
  opacity:var(--bs-btn-close-focus-opacity)
}

.btn-close:disabled,.btn-close.disabled{
  pointer-events:none;
  user-select:none;
  opacity:var(--bs-btn-close-disabled-opacity)
}

.btn-close-white{
  filter:var(--bs-btn-close-white-filter)
}

[data-bs-theme=dark] .btn-close{
  filter:var(--bs-btn-close-white-filter)
}

.modal{
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position:fixed;
  top:0;
  left:0;
  z-index:var(--bs-modal-zindex);
  display:none;
  width:100%;
  height:100%;
  overflow-x:hidden;
  overflow-y:auto;
  outline:0
}

.modal-dialog{
  position:relative;
  width:auto;
  margin:var(--bs-modal-margin);
  pointer-events:none
}

.modal.fade .modal-dialog{
  transition:transform .3s ease-out;
  transform:translate(0, -50px)
}

@media(prefers-reduced-motion: reduce){
  .modal.fade .modal-dialog{
    transition:none
  }
}

.modal.show .modal-dialog{
  transform:none
}

.modal.modal-static .modal-dialog{
  transform:scale(1.02)
}

.modal-dialog-scrollable{
  height:calc(100% - var(--bs-modal-margin)*2)
}

.modal-dialog-scrollable .modal-content{
  max-height:100%;
  overflow:hidden
}

.modal-dialog-scrollable .modal-body{
  overflow-y:auto
}

.modal-dialog-centered{
  display:flex;
  align-items:center;
  min-height:calc(100% - var(--bs-modal-margin)*2)
}

.modal-content{
  position:relative;
  display:flex;
  flex-direction:column;
  width:100%;
  color:var(--bs-modal-color);
  pointer-events:auto;
  background-color:var(--bs-modal-bg);
  background-clip:padding-box;
  border:var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius:var(--bs-modal-border-radius);
  outline:0
}

.modal-backdrop{
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position:fixed;
  top:0;
  left:0;
  z-index:var(--bs-backdrop-zindex);
  width:100vw;
  height:100vh;
  background-color:var(--bs-backdrop-bg)
}

.modal-backdrop.fade{
  opacity:0
}

.modal-backdrop.show{
  opacity:var(--bs-backdrop-opacity)
}

.modal-header{
  display:flex;
  flex-shrink:0;
  align-items:center;
  justify-content:space-between;
  padding:var(--bs-modal-header-padding);
  border-bottom:var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius:var(--bs-modal-inner-border-radius);
  border-top-right-radius:var(--bs-modal-inner-border-radius)
}

.modal-header .btn-close{
  padding:calc(var(--bs-modal-header-padding-y)*.5) calc(var(--bs-modal-header-padding-x)*.5);
  margin:calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto
}

.modal-title{
  margin-bottom:0;
  line-height:var(--bs-modal-title-line-height)
}

.modal-body{
  position:relative;
  flex:1 1 auto;
  padding:var(--bs-modal-padding)
}

.modal-footer{
  display:flex;
  flex-shrink:0;
  flex-wrap:wrap;
  align-items:center;
  justify-content:flex-end;
  padding:calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap)*.5);
  background-color:var(--bs-modal-footer-bg);
  border-top:var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius:var(--bs-modal-inner-border-radius);
  border-bottom-left-radius:var(--bs-modal-inner-border-radius)
}

.modal-footer>*{
  margin:calc(var(--bs-modal-footer-gap)*.5)
}

@media(min-width: 576px){
  .modal{
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow)
  }

  .modal-dialog{
    max-width:var(--bs-modal-width);
    margin-right:auto;
    margin-left:auto
  }

  .modal-sm{
    --bs-modal-width: 300px
  }
}

@media(min-width: 992px){
  .modal-lg,.modal-xl{
    --bs-modal-width: 800px
  }
}

@media(min-width: 1200px){
  .modal-xl{
    --bs-modal-width: 1140px
  }
}

.modal-fullscreen{
  width:100vw;
  max-width:none;
  height:100%;
  margin:0
}

.modal-fullscreen .modal-content{
  height:100%;
  border:0;
  border-radius:0
}

.modal-fullscreen .modal-header,.modal-fullscreen .modal-footer{
  border-radius:0
}

.modal-fullscreen .modal-body{
  overflow-y:auto
}

@media(max-width: 575.98px){
  .modal-fullscreen-sm-down{
    width:100vw;
    max-width:none;
    height:100%;
    margin:0
  }

  .modal-fullscreen-sm-down .modal-content{
    height:100%;
    border:0;
    border-radius:0
  }

  .modal-fullscreen-sm-down .modal-header,.modal-fullscreen-sm-down .modal-footer{
    border-radius:0
  }

  .modal-fullscreen-sm-down .modal-body{
    overflow-y:auto
  }
}

@media(max-width: 767.98px){
  .modal-fullscreen-md-down{
    width:100vw;
    max-width:none;
    height:100%;
    margin:0
  }

  .modal-fullscreen-md-down .modal-content{
    height:100%;
    border:0;
    border-radius:0
  }

  .modal-fullscreen-md-down .modal-header,.modal-fullscreen-md-down .modal-footer{
    border-radius:0
  }

  .modal-fullscreen-md-down .modal-body{
    overflow-y:auto
  }
}

@media(max-width: 991.98px){
  .modal-fullscreen-lg-down{
    width:100vw;
    max-width:none;
    height:100%;
    margin:0
  }

  .modal-fullscreen-lg-down .modal-content{
    height:100%;
    border:0;
    border-radius:0
  }

  .modal-fullscreen-lg-down .modal-header,.modal-fullscreen-lg-down .modal-footer{
    border-radius:0
  }

  .modal-fullscreen-lg-down .modal-body{
    overflow-y:auto
  }
}

@media(max-width: 1199.98px){
  .modal-fullscreen-xl-down{
    width:100vw;
    max-width:none;
    height:100%;
    margin:0
  }

  .modal-fullscreen-xl-down .modal-content{
    height:100%;
    border:0;
    border-radius:0
  }

  .modal-fullscreen-xl-down .modal-header,.modal-fullscreen-xl-down .modal-footer{
    border-radius:0
  }

  .modal-fullscreen-xl-down .modal-body{
    overflow-y:auto
  }
}

@media(max-width: 1399.98px){
  .modal-fullscreen-xxl-down{
    width:100vw;
    max-width:none;
    height:100%;
    margin:0
  }

  .modal-fullscreen-xxl-down .modal-content{
    height:100%;
    border:0;
    border-radius:0
  }

  .modal-fullscreen-xxl-down .modal-header,.modal-fullscreen-xxl-down .modal-footer{
    border-radius:0
  }

  .modal-fullscreen-xxl-down .modal-body{
    overflow-y:auto
  }
}

.tooltip{
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size:0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index:var(--bs-tooltip-zindex);
  display:block;
  margin:var(--bs-tooltip-margin);
  font-family:var(--bs-font-sans-serif);
  font-style:normal;
  font-weight:400;
  line-height:1.5;
  text-align:left;
  text-align:start;
  text-decoration:none;
  text-shadow:none;
  text-transform:none;
  letter-spacing:normal;
  word-break:normal;
  white-space:normal;
  word-spacing:normal;
  line-break:auto;
  font-size:var(--bs-tooltip-font-size);
  word-wrap:break-word;
  opacity:0
}

.tooltip.show{
  opacity:var(--bs-tooltip-opacity)
}

.tooltip .tooltip-arrow{
  display:block;
  width:var(--bs-tooltip-arrow-width);
  height:var(--bs-tooltip-arrow-height)
}

.tooltip .tooltip-arrow::before{
  position:absolute;
  content:"";
  border-color:rgba(0,0,0,0);
  border-style:solid
}

.bs-tooltip-top .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow{
  bottom:calc(-1*var(--bs-tooltip-arrow-height))
}

.bs-tooltip-top .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before{
  top:-1px;
  border-width:var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;
  border-top-color:var(--bs-tooltip-bg)
}

.bs-tooltip-end .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow{
  left:calc(-1*var(--bs-tooltip-arrow-height));
  width:var(--bs-tooltip-arrow-height);
  height:var(--bs-tooltip-arrow-width)
}

.bs-tooltip-end .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before{
  right:-1px;
  border-width:calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;
  border-right-color:var(--bs-tooltip-bg)
}

.bs-tooltip-bottom .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow{
  top:calc(-1*var(--bs-tooltip-arrow-height))
}

.bs-tooltip-bottom .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before{
  bottom:-1px;
  border-width:0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);
  border-bottom-color:var(--bs-tooltip-bg)
}

.bs-tooltip-start .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow{
  right:calc(-1*var(--bs-tooltip-arrow-height));
  width:var(--bs-tooltip-arrow-height);
  height:var(--bs-tooltip-arrow-width)
}

.bs-tooltip-start .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before{
  left:-1px;
  border-width:calc(var(--bs-tooltip-arrow-width)*.5) 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);
  border-left-color:var(--bs-tooltip-bg)
}

.tooltip-inner{
  max-width:var(--bs-tooltip-max-width);
  padding:var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color:var(--bs-tooltip-color);
  text-align:center;
  background-color:var(--bs-tooltip-bg);
  border-radius:var(--bs-tooltip-border-radius)
}

.clearfix::after{
  display:block;
  clear:both;
  content:""
}

.text-bg-primary{
  color:#fff !important;
  background-color:RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-secondary{
  color:#fff !important;
  background-color:RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-success{
  color:#fff !important;
  background-color:RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-info{
  color:#000 !important;
  background-color:RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-warning{
  color:#000 !important;
  background-color:RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-danger{
  color:#fff !important;
  background-color:RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-light{
  color:#000 !important;
  background-color:RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-dark{
  color:#fff !important;
  background-color:RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important
}

.text-bg-dark-primary{
  color:#fff !important;
  background-color:RGBA(var(--bs-dark-primary-rgb), var(--bs-bg-opacity, 1)) !important
}

.link-primary{
  color:RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-primary:hover,.link-primary:focus{
  color:RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important
}

.link-secondary{
  color:RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-secondary:hover,.link-secondary:focus{
  color:RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important
}

.link-success{
  color:RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-success:hover,.link-success:focus{
  color:RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important
}

.link-info{
  color:RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-info:hover,.link-info:focus{
  color:RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important
}

.link-warning{
  color:RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-warning:hover,.link-warning:focus{
  color:RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important
}

.link-danger{
  color:RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-danger:hover,.link-danger:focus{
  color:RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important
}

.link-light{
  color:RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-light:hover,.link-light:focus{
  color:RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important
}

.link-dark{
  color:RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-dark:hover,.link-dark:focus{
  color:RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important
}

.link-dark-primary{
  color:RGBA(var(--bs-dark-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-dark-primary-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-dark-primary:hover,.link-dark-primary:focus{
  color:RGBA(30, 38, 50, var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(30, 38, 50, var(--bs-link-underline-opacity, 1)) !important
}

.link-body-emphasis{
  color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-body-emphasis:hover,.link-body-emphasis:focus{
  color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important
}

.focus-ring:focus{
  outline:0;
  box-shadow:var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)
}

.icon-link{
  display:inline-flex;
  gap:.375rem;
  align-items:center;
  text-decoration-color:rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset:.25em;
  backface-visibility:hidden
}

.icon-link>.bi{
  flex-shrink:0;
  width:1em;
  height:1em;
  fill:currentcolor;
  transition:.2s ease-in-out transform
}

@media(prefers-reduced-motion: reduce){
  .icon-link>.bi{
    transition:none
  }
}

.icon-link-hover:hover>.bi,.icon-link-hover:focus-visible>.bi{
  transform:var(--bs-icon-link-transform, translate3d(0.25em, 0, 0))
}

.ratio{
  position:relative;
  width:100%
}

.ratio::before{
  display:block;
  padding-top:var(--bs-aspect-ratio);
  content:""
}

.ratio>*{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%
}

.ratio-1x1{
  --bs-aspect-ratio: 100%
}

.ratio-4x3{
  --bs-aspect-ratio: 75%
}

.ratio-16x9{
  --bs-aspect-ratio: 56.25%
}

.ratio-21x9{
  --bs-aspect-ratio: 42.8571428571%
}

.fixed-top{
  position:fixed;
  top:0;
  right:0;
  left:0;
  z-index:1030
}

.fixed-bottom{
  position:fixed;
  right:0;
  bottom:0;
  left:0;
  z-index:1030
}

.sticky-top{
  position:sticky;
  top:0;
  z-index:1020
}

.sticky-bottom{
  position:sticky;
  bottom:0;
  z-index:1020
}

@media(min-width: 576px){
  .sticky-sm-top{
    position:sticky;
    top:0;
    z-index:1020
  }

  .sticky-sm-bottom{
    position:sticky;
    bottom:0;
    z-index:1020
  }
}

@media(min-width: 768px){
  .sticky-md-top{
    position:sticky;
    top:0;
    z-index:1020
  }

  .sticky-md-bottom{
    position:sticky;
    bottom:0;
    z-index:1020
  }
}

@media(min-width: 992px){
  .sticky-lg-top{
    position:sticky;
    top:0;
    z-index:1020
  }

  .sticky-lg-bottom{
    position:sticky;
    bottom:0;
    z-index:1020
  }
}

@media(min-width: 1200px){
  .sticky-xl-top{
    position:sticky;
    top:0;
    z-index:1020
  }

  .sticky-xl-bottom{
    position:sticky;
    bottom:0;
    z-index:1020
  }
}

@media(min-width: 1400px){
  .sticky-xxl-top{
    position:sticky;
    top:0;
    z-index:1020
  }

  .sticky-xxl-bottom{
    position:sticky;
    bottom:0;
    z-index:1020
  }
}

.hstack{
  display:flex;
  flex-direction:row;
  align-items:center;
  align-self:stretch
}

.vstack{
  display:flex;
  flex:1 1 auto;
  flex-direction:column;
  align-self:stretch
}

.visually-hidden,.visually-hidden-focusable:not(:focus):not(:focus-within){
  width:1px !important;
  height:1px !important;
  padding:0 !important;
  margin:-1px !important;
  overflow:hidden !important;
  clip:rect(0, 0, 0, 0) !important;
  white-space:nowrap !important;
  border:0 !important
}

.visually-hidden:not(caption),.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption){
  position:absolute !important
}

.stretched-link::after{
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  z-index:1;
  content:""
}

.text-truncate{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}

.vr{
  display:inline-block;
  align-self:stretch;
  width:var(--bs-border-width);
  min-height:1em;
  background-color:currentcolor;
  opacity:.25
}

.align-baseline{
  vertical-align:baseline !important
}

.align-top{
  vertical-align:top !important
}

.align-middle{
  vertical-align:middle !important
}

.align-bottom{
  vertical-align:bottom !important
}

.align-text-bottom{
  vertical-align:text-bottom !important
}

.align-text-top{
  vertical-align:text-top !important
}

.float-start{
  float:left !important
}

.float-end{
  float:right !important
}

.float-none{
  float:none !important
}

.object-fit-contain{
  object-fit:contain !important
}

.object-fit-cover{
  object-fit:cover !important
}

.object-fit-fill{
  object-fit:fill !important
}

.object-fit-scale{
  object-fit:scale-down !important
}

.object-fit-none{
  object-fit:none !important
}

.opacity-0{
  opacity:0 !important
}

.opacity-25{
  opacity:.25 !important
}

.opacity-50{
  opacity:.5 !important
}

.opacity-75{
  opacity:.75 !important
}

.opacity-100{
  opacity:1 !important
}

.overflow-auto{
  overflow:auto !important
}

.overflow-hidden{
  overflow:hidden !important
}

.overflow-visible{
  overflow:visible !important
}

.overflow-scroll{
  overflow:scroll !important
}

.overflow-x-auto{
  overflow-x:auto !important
}

.overflow-x-hidden{
  overflow-x:hidden !important
}

.overflow-x-visible{
  overflow-x:visible !important
}

.overflow-x-scroll{
  overflow-x:scroll !important
}

.overflow-y-auto{
  overflow-y:auto !important
}

.overflow-y-hidden{
  overflow-y:hidden !important
}

.overflow-y-visible{
  overflow-y:visible !important
}

.overflow-y-scroll{
  overflow-y:scroll !important
}

.d-inline{
  display:inline !important
}

.d-inline-block{
  display:inline-block !important
}

.d-block{
  display:block !important
}

.d-grid{
  display:grid !important
}

.d-inline-grid{
  display:inline-grid !important
}

.d-table{
  display:table !important
}

.d-table-row{
  display:table-row !important
}

.d-table-cell{
  display:table-cell !important
}

.d-flex{
  display:flex !important
}

.d-inline-flex{
  display:inline-flex !important
}

.d-none{
  display:none !important
}

.shadow{
  box-shadow:var(--bs-box-shadow) !important
}

.shadow-sm{
  box-shadow:var(--bs-box-shadow-sm) !important
}

.shadow-lg{
  box-shadow:var(--bs-box-shadow-lg) !important
}

.shadow-none{
  box-shadow:none !important
}

.focus-ring-primary{
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-secondary{
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-success{
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-info{
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-warning{
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-danger{
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-light{
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-dark{
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))
}

.focus-ring-dark-primary{
  --bs-focus-ring-color: rgba(var(--bs-dark-primary-rgb), var(--bs-focus-ring-opacity))
}

.position-static{
  position:static !important
}

.position-relative{
  position:relative !important
}

.position-absolute{
  position:absolute !important
}

.position-fixed{
  position:fixed !important
}

.position-sticky{
  position:sticky !important
}

.top-0{
  top:0 !important
}

.top-50{
  top:50% !important
}

.top-100{
  top:100% !important
}

.bottom-0{
  bottom:0 !important
}

.bottom-50{
  bottom:50% !important
}

.bottom-100{
  bottom:100% !important
}

.start-0{
  left:0 !important
}

.start-50{
  left:50% !important
}

.start-100{
  left:100% !important
}

.end-0{
  right:0 !important
}

.end-50{
  right:50% !important
}

.end-100{
  right:100% !important
}

.translate-middle{
  transform:translate(-50%, -50%) !important
}

.translate-middle-x{
  transform:translateX(-50%) !important
}

.translate-middle-y{
  transform:translateY(-50%) !important
}

.border{
  border:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-0{
  border:0 !important
}

.border-top{
  border-top:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-top-0{
  border-top:0 !important
}

.border-end{
  border-right:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-end-0{
  border-right:0 !important
}

.border-bottom{
  border-bottom:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-bottom-0{
  border-bottom:0 !important
}

.border-start{
  border-left:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important
}

.border-start-0{
  border-left:0 !important
}

.border-primary{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important
}

.border-secondary{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important
}

.border-success{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important
}

.border-info{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important
}

.border-warning{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important
}

.border-danger{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important
}

.border-light{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important
}

.border-dark{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important
}

.border-dark-primary{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-dark-primary-rgb), var(--bs-border-opacity)) !important
}

.border-black{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important
}

.border-white{
  --bs-border-opacity: 1;
  border-color:rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important
}

.border-primary-subtle{
  border-color:var(--bs-primary-border-subtle) !important
}

.border-secondary-subtle{
  border-color:var(--bs-secondary-border-subtle) !important
}

.border-success-subtle{
  border-color:var(--bs-success-border-subtle) !important
}

.border-info-subtle{
  border-color:var(--bs-info-border-subtle) !important
}

.border-warning-subtle{
  border-color:var(--bs-warning-border-subtle) !important
}

.border-danger-subtle{
  border-color:var(--bs-danger-border-subtle) !important
}

.border-light-subtle{
  border-color:var(--bs-light-border-subtle) !important
}

.border-dark-subtle{
  border-color:var(--bs-dark-border-subtle) !important
}

.border-1{
  border-width:1px !important
}

.border-2{
  border-width:2px !important
}

.border-3{
  border-width:3px !important
}

.border-4{
  border-width:4px !important
}

.border-5{
  border-width:5px !important
}

.border-opacity-10{
  --bs-border-opacity: 0.1
}

.border-opacity-25{
  --bs-border-opacity: 0.25
}

.border-opacity-50{
  --bs-border-opacity: 0.5
}

.border-opacity-75{
  --bs-border-opacity: 0.75
}

.border-opacity-100{
  --bs-border-opacity: 1
}

.w-25{
  width:25% !important
}

.w-50{
  width:50% !important
}

.w-75{
  width:75% !important
}

.w-100{
  width:100% !important
}

.w-auto{
  width:auto !important
}

.mw-100{
  max-width:100% !important
}

.vw-100{
  width:100vw !important
}

.min-vw-100{
  min-width:100vw !important
}

.h-25{
  height:25% !important
}

.h-50{
  height:50% !important
}

.h-75{
  height:75% !important
}

.h-100{
  height:100% !important
}

.h-auto{
  height:auto !important
}

.mh-100{
  max-height:100% !important
}

.vh-100{
  height:100vh !important
}

.min-vh-100{
  min-height:100vh !important
}

.flex-fill{
  flex:1 1 auto !important
}

.flex-row{
  flex-direction:row !important
}

.flex-column{
  flex-direction:column !important
}

.flex-row-reverse{
  flex-direction:row-reverse !important
}

.flex-column-reverse{
  flex-direction:column-reverse !important
}

.flex-grow-0{
  flex-grow:0 !important
}

.flex-grow-1{
  flex-grow:1 !important
}

.flex-shrink-0{
  flex-shrink:0 !important
}

.flex-shrink-1{
  flex-shrink:1 !important
}

.flex-wrap{
  flex-wrap:wrap !important
}

.flex-nowrap{
  flex-wrap:nowrap !important
}

.flex-wrap-reverse{
  flex-wrap:wrap-reverse !important
}

.justify-content-start{
  justify-content:flex-start !important
}

.justify-content-end{
  justify-content:flex-end !important
}

.justify-content-center{
  justify-content:center !important
}

.justify-content-between{
  justify-content:space-between !important
}

.justify-content-around{
  justify-content:space-around !important
}

.justify-content-evenly{
  justify-content:space-evenly !important
}

.align-items-start{
  align-items:flex-start !important
}

.align-items-end{
  align-items:flex-end !important
}

.align-items-center{
  align-items:center !important
}

.align-items-baseline{
  align-items:baseline !important
}

.align-items-stretch{
  align-items:stretch !important
}

.align-content-start{
  align-content:flex-start !important
}

.align-content-end{
  align-content:flex-end !important
}

.align-content-center{
  align-content:center !important
}

.align-content-between{
  align-content:space-between !important
}

.align-content-around{
  align-content:space-around !important
}

.align-content-stretch{
  align-content:stretch !important
}

.align-self-auto{
  align-self:auto !important
}

.align-self-start{
  align-self:flex-start !important
}

.align-self-end{
  align-self:flex-end !important
}

.align-self-center{
  align-self:center !important
}

.align-self-baseline{
  align-self:baseline !important
}

.align-self-stretch{
  align-self:stretch !important
}

.order-first{
  order:-1 !important
}

.order-0{
  order:0 !important
}

.order-1{
  order:1 !important
}

.order-2{
  order:2 !important
}

.order-3{
  order:3 !important
}

.order-4{
  order:4 !important
}

.order-5{
  order:5 !important
}

.order-last{
  order:6 !important
}

.m-0{
  margin:0 !important
}

.m-1{
  margin:.25rem !important
}

.m-2{
  margin:.5rem !important
}

.m-3{
  margin:1rem !important
}

.m-4{
  margin:1.5rem !important
}

.m-5{
  margin:3rem !important
}

.m-auto{
  margin:auto !important
}

.mx-0{
  margin-right:0 !important;
  margin-left:0 !important
}

.mx-1{
  margin-right:.25rem !important;
  margin-left:.25rem !important
}

.mx-2{
  margin-right:.5rem !important;
  margin-left:.5rem !important
}

.mx-3{
  margin-right:1rem !important;
  margin-left:1rem !important
}

.mx-4{
  margin-right:1.5rem !important;
  margin-left:1.5rem !important
}

.mx-5{
  margin-right:3rem !important;
  margin-left:3rem !important
}

.mx-auto{
  margin-right:auto !important;
  margin-left:auto !important
}

.my-0{
  margin-top:0 !important;
  margin-bottom:0 !important
}

.my-1{
  margin-top:.25rem !important;
  margin-bottom:.25rem !important
}

.my-2{
  margin-top:.5rem !important;
  margin-bottom:.5rem !important
}

.my-3{
  margin-top:1rem !important;
  margin-bottom:1rem !important
}

.my-4{
  margin-top:1.5rem !important;
  margin-bottom:1.5rem !important
}

.my-5{
  margin-top:3rem !important;
  margin-bottom:3rem !important
}

.my-auto{
  margin-top:auto !important;
  margin-bottom:auto !important
}

.mt-0{
  margin-top:0 !important
}

.mt-1{
  margin-top:.25rem !important
}

.mt-2{
  margin-top:.5rem !important
}

.mt-3{
  margin-top:1rem !important
}

.mt-4{
  margin-top:1.5rem !important
}

.mt-5{
  margin-top:3rem !important
}

.mt-auto{
  margin-top:auto !important
}

.me-0{
  margin-right:0 !important
}

.me-1{
  margin-right:.25rem !important
}

.me-2{
  margin-right:.5rem !important
}

.me-3{
  margin-right:1rem !important
}

.me-4{
  margin-right:1.5rem !important
}

.me-5{
  margin-right:3rem !important
}

.me-auto{
  margin-right:auto !important
}

.mb-0{
  margin-bottom:0 !important
}

.mb-1{
  margin-bottom:.25rem !important
}

.mb-2{
  margin-bottom:.5rem !important
}

.mb-3{
  margin-bottom:1rem !important
}

.mb-4{
  margin-bottom:1.5rem !important
}

.mb-5{
  margin-bottom:3rem !important
}

.mb-auto{
  margin-bottom:auto !important
}

.ms-0{
  margin-left:0 !important
}

.ms-1{
  margin-left:.25rem !important
}

.ms-2{
  margin-left:.5rem !important
}

.ms-3{
  margin-left:1rem !important
}

.ms-4{
  margin-left:1.5rem !important
}

.ms-5{
  margin-left:3rem !important
}

.ms-auto{
  margin-left:auto !important
}

.p-0{
  padding:0 !important
}

.p-1{
  padding:.25rem !important
}

.p-2{
  padding:.5rem !important
}

.p-3{
  padding:1rem !important
}

.p-4{
  padding:1.5rem !important
}

.p-5{
  padding:3rem !important
}

.px-0{
  padding-right:0 !important;
  padding-left:0 !important
}

.px-1{
  padding-right:.25rem !important;
  padding-left:.25rem !important
}

.px-2{
  padding-right:.5rem !important;
  padding-left:.5rem !important
}

.px-3{
  padding-right:1rem !important;
  padding-left:1rem !important
}

.px-4{
  padding-right:1.5rem !important;
  padding-left:1.5rem !important
}

.px-5{
  padding-right:3rem !important;
  padding-left:3rem !important
}

.py-0{
  padding-top:0 !important;
  padding-bottom:0 !important
}

.py-1{
  padding-top:.25rem !important;
  padding-bottom:.25rem !important
}

.py-2{
  padding-top:.5rem !important;
  padding-bottom:.5rem !important
}

.py-3{
  padding-top:1rem !important;
  padding-bottom:1rem !important
}

.py-4{
  padding-top:1.5rem !important;
  padding-bottom:1.5rem !important
}

.py-5{
  padding-top:3rem !important;
  padding-bottom:3rem !important
}

.pt-0{
  padding-top:0 !important
}

.pt-1{
  padding-top:.25rem !important
}

.pt-2{
  padding-top:.5rem !important
}

.pt-3{
  padding-top:1rem !important
}

.pt-4{
  padding-top:1.5rem !important
}

.pt-5{
  padding-top:3rem !important
}

.pe-0{
  padding-right:0 !important
}

.pe-1{
  padding-right:.25rem !important
}

.pe-2{
  padding-right:.5rem !important
}

.pe-3{
  padding-right:1rem !important
}

.pe-4{
  padding-right:1.5rem !important
}

.pe-5{
  padding-right:3rem !important
}

.pb-0{
  padding-bottom:0 !important
}

.pb-1{
  padding-bottom:.25rem !important
}

.pb-2{
  padding-bottom:.5rem !important
}

.pb-3{
  padding-bottom:1rem !important
}

.pb-4{
  padding-bottom:1.5rem !important
}

.pb-5{
  padding-bottom:3rem !important
}

.ps-0{
  padding-left:0 !important
}

.ps-1{
  padding-left:.25rem !important
}

.ps-2{
  padding-left:.5rem !important
}

.ps-3{
  padding-left:1rem !important
}

.ps-4{
  padding-left:1.5rem !important
}

.ps-5{
  padding-left:3rem !important
}

.gap-0{
  gap:0 !important
}

.gap-1{
  gap:.25rem !important
}

.gap-2{
  gap:.5rem !important
}

.gap-3{
  gap:1rem !important
}

.gap-4{
  gap:1.5rem !important
}

.gap-5{
  gap:3rem !important
}

.row-gap-0{
  row-gap:0 !important
}

.row-gap-1{
  row-gap:.25rem !important
}

.row-gap-2{
  row-gap:.5rem !important
}

.row-gap-3{
  row-gap:1rem !important
}

.row-gap-4{
  row-gap:1.5rem !important
}

.row-gap-5{
  row-gap:3rem !important
}

.column-gap-0{
  column-gap:0 !important
}

.column-gap-1{
  column-gap:.25rem !important
}

.column-gap-2{
  column-gap:.5rem !important
}

.column-gap-3{
  column-gap:1rem !important
}

.column-gap-4{
  column-gap:1.5rem !important
}

.column-gap-5{
  column-gap:3rem !important
}

.font-monospace{
  font-family:var(--bs-font-monospace) !important
}

.fs-1{
  font-size:calc(1.375rem + 1.5vw) !important
}

.fs-2{
  font-size:calc(1.325rem + 0.9vw) !important
}

.fs-3{
  font-size:calc(1.3rem + 0.6vw) !important
}

.fs-4{
  font-size:calc(1.275rem + 0.3vw) !important
}

.fs-5{
  font-size:1.25rem !important
}

.fs-6{
  font-size:1rem !important
}

.fst-italic{
  font-style:italic !important
}

.fst-normal{
  font-style:normal !important
}

.fw-lighter{
  font-weight:lighter !important
}

.fw-light{
  font-weight:300 !important
}

.fw-normal{
  font-weight:400 !important
}

.fw-medium{
  font-weight:500 !important
}

.fw-semibold{
  font-weight:600 !important
}

.fw-bold{
  font-weight:700 !important
}

.fw-bolder{
  font-weight:bolder !important
}

.lh-1{
  line-height:1 !important
}

.lh-sm{
  line-height:1.25 !important
}

.lh-base{
  line-height:1.5 !important
}

.lh-lg{
  line-height:2 !important
}

.text-start{
  text-align:left !important
}

.text-end{
  text-align:right !important
}

.text-center{
  text-align:center !important
}

.text-decoration-none{
  text-decoration:none !important
}

.text-decoration-underline{
  text-decoration:underline !important
}

.text-decoration-line-through{
  text-decoration:line-through !important
}

.text-lowercase{
  text-transform:lowercase !important
}

.text-uppercase{
  text-transform:uppercase !important
}

.text-capitalize{
  text-transform:capitalize !important
}

.text-wrap{
  white-space:normal !important
}

.text-nowrap{
  white-space:nowrap !important
}

.text-break{
  word-wrap:break-word !important;
  word-break:break-word !important
}

.text-primary{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important
}

.text-secondary{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important
}

.text-success{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important
}

.text-info{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important
}

.text-warning{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important
}

.text-danger{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important
}

.text-light{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important
}

.text-dark{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important
}

.text-dark-primary{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-dark-primary-rgb), var(--bs-text-opacity)) !important
}

.text-black{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important
}

.text-white{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important
}

.text-body{
  --bs-text-opacity: 1;
  color:rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important
}

.text-muted{
  --bs-text-opacity: 1;
  color:var(--bs-secondary-color) !important
}

.text-black-50{
  --bs-text-opacity: 1;
  color:rgba(0,0,0,.5) !important
}

.text-white-50{
  --bs-text-opacity: 1;
  color:rgba(255,255,255,.5) !important
}

.text-body-secondary{
  --bs-text-opacity: 1;
  color:var(--bs-secondary-color) !important
}

.text-body-tertiary{
  --bs-text-opacity: 1;
  color:var(--bs-tertiary-color) !important
}

.text-body-emphasis{
  --bs-text-opacity: 1;
  color:var(--bs-emphasis-color) !important
}

.text-reset{
  --bs-text-opacity: 1;
  color:inherit !important
}

.text-opacity-25{
  --bs-text-opacity: 0.25
}

.text-opacity-50{
  --bs-text-opacity: 0.5
}

.text-opacity-75{
  --bs-text-opacity: 0.75
}

.text-opacity-100{
  --bs-text-opacity: 1
}

.text-primary-emphasis{
  color:var(--bs-primary-text-emphasis) !important
}

.text-secondary-emphasis{
  color:var(--bs-secondary-text-emphasis) !important
}

.text-success-emphasis{
  color:var(--bs-success-text-emphasis) !important
}

.text-info-emphasis{
  color:var(--bs-info-text-emphasis) !important
}

.text-warning-emphasis{
  color:var(--bs-warning-text-emphasis) !important
}

.text-danger-emphasis{
  color:var(--bs-danger-text-emphasis) !important
}

.text-light-emphasis{
  color:var(--bs-light-text-emphasis) !important
}

.text-dark-emphasis{
  color:var(--bs-dark-text-emphasis) !important
}

.link-opacity-10{
  --bs-link-opacity: 0.1
}

.link-opacity-10-hover:hover{
  --bs-link-opacity: 0.1
}

.link-opacity-25{
  --bs-link-opacity: 0.25
}

.link-opacity-25-hover:hover{
  --bs-link-opacity: 0.25
}

.link-opacity-50{
  --bs-link-opacity: 0.5
}

.link-opacity-50-hover:hover{
  --bs-link-opacity: 0.5
}

.link-opacity-75{
  --bs-link-opacity: 0.75
}

.link-opacity-75-hover:hover{
  --bs-link-opacity: 0.75
}

.link-opacity-100{
  --bs-link-opacity: 1
}

.link-opacity-100-hover:hover{
  --bs-link-opacity: 1
}

.link-offset-1{
  text-underline-offset:.125em !important
}

.link-offset-1-hover:hover{
  text-underline-offset:.125em !important
}

.link-offset-2{
  text-underline-offset:.25em !important
}

.link-offset-2-hover:hover{
  text-underline-offset:.25em !important
}

.link-offset-3{
  text-underline-offset:.375em !important
}

.link-offset-3-hover:hover{
  text-underline-offset:.375em !important
}

.link-underline-primary{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-secondary{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-success{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-info{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-warning{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-danger{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-light{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-dark{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline-dark-primary{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-dark-primary-rgb), var(--bs-link-underline-opacity)) !important
}

.link-underline{
  --bs-link-underline-opacity: 1;
  text-decoration-color:rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important
}

.link-underline-opacity-0{
  --bs-link-underline-opacity: 0
}

.link-underline-opacity-0-hover:hover{
  --bs-link-underline-opacity: 0
}

.link-underline-opacity-10{
  --bs-link-underline-opacity: 0.1
}

.link-underline-opacity-10-hover:hover{
  --bs-link-underline-opacity: 0.1
}

.link-underline-opacity-25{
  --bs-link-underline-opacity: 0.25
}

.link-underline-opacity-25-hover:hover{
  --bs-link-underline-opacity: 0.25
}

.link-underline-opacity-50{
  --bs-link-underline-opacity: 0.5
}

.link-underline-opacity-50-hover:hover{
  --bs-link-underline-opacity: 0.5
}

.link-underline-opacity-75{
  --bs-link-underline-opacity: 0.75
}

.link-underline-opacity-75-hover:hover{
  --bs-link-underline-opacity: 0.75
}

.link-underline-opacity-100{
  --bs-link-underline-opacity: 1
}

.link-underline-opacity-100-hover:hover{
  --bs-link-underline-opacity: 1
}

.bg-primary{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important
}

.bg-secondary{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important
}

.bg-success{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important
}

.bg-info{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important
}

.bg-warning{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important
}

.bg-danger{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important
}

.bg-light{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important
}

.bg-dark{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important
}

.bg-dark-primary{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-dark-primary-rgb), var(--bs-bg-opacity)) !important
}

.bg-black{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important
}

.bg-white{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important
}

.bg-body{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-transparent{
  --bs-bg-opacity: 1;
  background-color:rgba(0,0,0,0) !important
}

.bg-body-secondary{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-body-tertiary{
  --bs-bg-opacity: 1;
  background-color:rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important
}

.bg-opacity-10{
  --bs-bg-opacity: 0.1
}

.bg-opacity-25{
  --bs-bg-opacity: 0.25
}

.bg-opacity-50{
  --bs-bg-opacity: 0.5
}

.bg-opacity-75{
  --bs-bg-opacity: 0.75
}

.bg-opacity-100{
  --bs-bg-opacity: 1
}

.bg-primary-subtle{
  background-color:var(--bs-primary-bg-subtle) !important
}

.bg-secondary-subtle{
  background-color:var(--bs-secondary-bg-subtle) !important
}

.bg-success-subtle{
  background-color:var(--bs-success-bg-subtle) !important
}

.bg-info-subtle{
  background-color:var(--bs-info-bg-subtle) !important
}

.bg-warning-subtle{
  background-color:var(--bs-warning-bg-subtle) !important
}

.bg-danger-subtle{
  background-color:var(--bs-danger-bg-subtle) !important
}

.bg-light-subtle{
  background-color:var(--bs-light-bg-subtle) !important
}

.bg-dark-subtle{
  background-color:var(--bs-dark-bg-subtle) !important
}

.bg-gradient{
  background-image:var(--bs-gradient) !important
}

.user-select-all{
  user-select:all !important
}

.user-select-auto{
  user-select:auto !important
}

.user-select-none{
  user-select:none !important
}

.pe-none{
  pointer-events:none !important
}

.pe-auto{
  pointer-events:auto !important
}

.rounded{
  border-radius:var(--bs-border-radius) !important
}

.rounded-0{
  border-radius:0 !important
}

.rounded-1{
  border-radius:var(--bs-border-radius-sm) !important
}

.rounded-2{
  border-radius:var(--bs-border-radius) !important
}

.rounded-3{
  border-radius:var(--bs-border-radius-lg) !important
}

.rounded-4{
  border-radius:var(--bs-border-radius-xl) !important
}

.rounded-5{
  border-radius:var(--bs-border-radius-xxl) !important
}

.rounded-circle{
  border-radius:50% !important
}

.rounded-pill{
  border-radius:var(--bs-border-radius-pill) !important
}

.rounded-top{
  border-top-left-radius:var(--bs-border-radius) !important;
  border-top-right-radius:var(--bs-border-radius) !important
}

.rounded-top-0{
  border-top-left-radius:0 !important;
  border-top-right-radius:0 !important
}

.rounded-top-1{
  border-top-left-radius:var(--bs-border-radius-sm) !important;
  border-top-right-radius:var(--bs-border-radius-sm) !important
}

.rounded-top-2{
  border-top-left-radius:var(--bs-border-radius) !important;
  border-top-right-radius:var(--bs-border-radius) !important
}

.rounded-top-3{
  border-top-left-radius:var(--bs-border-radius-lg) !important;
  border-top-right-radius:var(--bs-border-radius-lg) !important
}

.rounded-top-4{
  border-top-left-radius:var(--bs-border-radius-xl) !important;
  border-top-right-radius:var(--bs-border-radius-xl) !important
}

.rounded-top-5{
  border-top-left-radius:var(--bs-border-radius-xxl) !important;
  border-top-right-radius:var(--bs-border-radius-xxl) !important
}

.rounded-top-circle{
  border-top-left-radius:50% !important;
  border-top-right-radius:50% !important
}

.rounded-top-pill{
  border-top-left-radius:var(--bs-border-radius-pill) !important;
  border-top-right-radius:var(--bs-border-radius-pill) !important
}

.rounded-end{
  border-top-right-radius:var(--bs-border-radius) !important;
  border-bottom-right-radius:var(--bs-border-radius) !important
}

.rounded-end-0{
  border-top-right-radius:0 !important;
  border-bottom-right-radius:0 !important
}

.rounded-end-1{
  border-top-right-radius:var(--bs-border-radius-sm) !important;
  border-bottom-right-radius:var(--bs-border-radius-sm) !important
}

.rounded-end-2{
  border-top-right-radius:var(--bs-border-radius) !important;
  border-bottom-right-radius:var(--bs-border-radius) !important
}

.rounded-end-3{
  border-top-right-radius:var(--bs-border-radius-lg) !important;
  border-bottom-right-radius:var(--bs-border-radius-lg) !important
}

.rounded-end-4{
  border-top-right-radius:var(--bs-border-radius-xl) !important;
  border-bottom-right-radius:var(--bs-border-radius-xl) !important
}

.rounded-end-5{
  border-top-right-radius:var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius:var(--bs-border-radius-xxl) !important
}

.rounded-end-circle{
  border-top-right-radius:50% !important;
  border-bottom-right-radius:50% !important
}

.rounded-end-pill{
  border-top-right-radius:var(--bs-border-radius-pill) !important;
  border-bottom-right-radius:var(--bs-border-radius-pill) !important
}

.rounded-bottom{
  border-bottom-right-radius:var(--bs-border-radius) !important;
  border-bottom-left-radius:var(--bs-border-radius) !important
}

.rounded-bottom-0{
  border-bottom-right-radius:0 !important;
  border-bottom-left-radius:0 !important
}

.rounded-bottom-1{
  border-bottom-right-radius:var(--bs-border-radius-sm) !important;
  border-bottom-left-radius:var(--bs-border-radius-sm) !important
}

.rounded-bottom-2{
  border-bottom-right-radius:var(--bs-border-radius) !important;
  border-bottom-left-radius:var(--bs-border-radius) !important
}

.rounded-bottom-3{
  border-bottom-right-radius:var(--bs-border-radius-lg) !important;
  border-bottom-left-radius:var(--bs-border-radius-lg) !important
}

.rounded-bottom-4{
  border-bottom-right-radius:var(--bs-border-radius-xl) !important;
  border-bottom-left-radius:var(--bs-border-radius-xl) !important
}

.rounded-bottom-5{
  border-bottom-right-radius:var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius:var(--bs-border-radius-xxl) !important
}

.rounded-bottom-circle{
  border-bottom-right-radius:50% !important;
  border-bottom-left-radius:50% !important
}

.rounded-bottom-pill{
  border-bottom-right-radius:var(--bs-border-radius-pill) !important;
  border-bottom-left-radius:var(--bs-border-radius-pill) !important
}

.rounded-start{
  border-bottom-left-radius:var(--bs-border-radius) !important;
  border-top-left-radius:var(--bs-border-radius) !important
}

.rounded-start-0{
  border-bottom-left-radius:0 !important;
  border-top-left-radius:0 !important
}

.rounded-start-1{
  border-bottom-left-radius:var(--bs-border-radius-sm) !important;
  border-top-left-radius:var(--bs-border-radius-sm) !important
}

.rounded-start-2{
  border-bottom-left-radius:var(--bs-border-radius) !important;
  border-top-left-radius:var(--bs-border-radius) !important
}

.rounded-start-3{
  border-bottom-left-radius:var(--bs-border-radius-lg) !important;
  border-top-left-radius:var(--bs-border-radius-lg) !important
}

.rounded-start-4{
  border-bottom-left-radius:var(--bs-border-radius-xl) !important;
  border-top-left-radius:var(--bs-border-radius-xl) !important
}

.rounded-start-5{
  border-bottom-left-radius:var(--bs-border-radius-xxl) !important;
  border-top-left-radius:var(--bs-border-radius-xxl) !important
}

.rounded-start-circle{
  border-bottom-left-radius:50% !important;
  border-top-left-radius:50% !important
}

.rounded-start-pill{
  border-bottom-left-radius:var(--bs-border-radius-pill) !important;
  border-top-left-radius:var(--bs-border-radius-pill) !important
}

.visible{
  visibility:visible !important
}

.invisible{
  visibility:hidden !important
}

.z-n1{
  z-index:-1 !important
}

.z-0{
  z-index:0 !important
}

.z-1{
  z-index:1 !important
}

.z-2{
  z-index:2 !important
}

.z-3{
  z-index:3 !important
}

@media(min-width: 576px){
  .float-sm-start{
    float:left !important
  }

  .float-sm-end{
    float:right !important
  }

  .float-sm-none{
    float:none !important
  }

  .object-fit-sm-contain{
    object-fit:contain !important
  }

  .object-fit-sm-cover{
    object-fit:cover !important
  }

  .object-fit-sm-fill{
    object-fit:fill !important
  }

  .object-fit-sm-scale{
    object-fit:scale-down !important
  }

  .object-fit-sm-none{
    object-fit:none !important
  }

  .d-sm-inline{
    display:inline !important
  }

  .d-sm-inline-block{
    display:inline-block !important
  }

  .d-sm-block{
    display:block !important
  }

  .d-sm-grid{
    display:grid !important
  }

  .d-sm-inline-grid{
    display:inline-grid !important
  }

  .d-sm-table{
    display:table !important
  }

  .d-sm-table-row{
    display:table-row !important
  }

  .d-sm-table-cell{
    display:table-cell !important
  }

  .d-sm-flex{
    display:flex !important
  }

  .d-sm-inline-flex{
    display:inline-flex !important
  }

  .d-sm-none{
    display:none !important
  }

  .flex-sm-fill{
    flex:1 1 auto !important
  }

  .flex-sm-row{
    flex-direction:row !important
  }

  .flex-sm-column{
    flex-direction:column !important
  }

  .flex-sm-row-reverse{
    flex-direction:row-reverse !important
  }

  .flex-sm-column-reverse{
    flex-direction:column-reverse !important
  }

  .flex-sm-grow-0{
    flex-grow:0 !important
  }

  .flex-sm-grow-1{
    flex-grow:1 !important
  }

  .flex-sm-shrink-0{
    flex-shrink:0 !important
  }

  .flex-sm-shrink-1{
    flex-shrink:1 !important
  }

  .flex-sm-wrap{
    flex-wrap:wrap !important
  }

  .flex-sm-nowrap{
    flex-wrap:nowrap !important
  }

  .flex-sm-wrap-reverse{
    flex-wrap:wrap-reverse !important
  }

  .justify-content-sm-start{
    justify-content:flex-start !important
  }

  .justify-content-sm-end{
    justify-content:flex-end !important
  }

  .justify-content-sm-center{
    justify-content:center !important
  }

  .justify-content-sm-between{
    justify-content:space-between !important
  }

  .justify-content-sm-around{
    justify-content:space-around !important
  }

  .justify-content-sm-evenly{
    justify-content:space-evenly !important
  }

  .align-items-sm-start{
    align-items:flex-start !important
  }

  .align-items-sm-end{
    align-items:flex-end !important
  }

  .align-items-sm-center{
    align-items:center !important
  }

  .align-items-sm-baseline{
    align-items:baseline !important
  }

  .align-items-sm-stretch{
    align-items:stretch !important
  }

  .align-content-sm-start{
    align-content:flex-start !important
  }

  .align-content-sm-end{
    align-content:flex-end !important
  }

  .align-content-sm-center{
    align-content:center !important
  }

  .align-content-sm-between{
    align-content:space-between !important
  }

  .align-content-sm-around{
    align-content:space-around !important
  }

  .align-content-sm-stretch{
    align-content:stretch !important
  }

  .align-self-sm-auto{
    align-self:auto !important
  }

  .align-self-sm-start{
    align-self:flex-start !important
  }

  .align-self-sm-end{
    align-self:flex-end !important
  }

  .align-self-sm-center{
    align-self:center !important
  }

  .align-self-sm-baseline{
    align-self:baseline !important
  }

  .align-self-sm-stretch{
    align-self:stretch !important
  }

  .order-sm-first{
    order:-1 !important
  }

  .order-sm-0{
    order:0 !important
  }

  .order-sm-1{
    order:1 !important
  }

  .order-sm-2{
    order:2 !important
  }

  .order-sm-3{
    order:3 !important
  }

  .order-sm-4{
    order:4 !important
  }

  .order-sm-5{
    order:5 !important
  }

  .order-sm-last{
    order:6 !important
  }

  .m-sm-0{
    margin:0 !important
  }

  .m-sm-1{
    margin:.25rem !important
  }

  .m-sm-2{
    margin:.5rem !important
  }

  .m-sm-3{
    margin:1rem !important
  }

  .m-sm-4{
    margin:1.5rem !important
  }

  .m-sm-5{
    margin:3rem !important
  }

  .m-sm-auto{
    margin:auto !important
  }

  .mx-sm-0{
    margin-right:0 !important;
    margin-left:0 !important
  }

  .mx-sm-1{
    margin-right:.25rem !important;
    margin-left:.25rem !important
  }

  .mx-sm-2{
    margin-right:.5rem !important;
    margin-left:.5rem !important
  }

  .mx-sm-3{
    margin-right:1rem !important;
    margin-left:1rem !important
  }

  .mx-sm-4{
    margin-right:1.5rem !important;
    margin-left:1.5rem !important
  }

  .mx-sm-5{
    margin-right:3rem !important;
    margin-left:3rem !important
  }

  .mx-sm-auto{
    margin-right:auto !important;
    margin-left:auto !important
  }

  .my-sm-0{
    margin-top:0 !important;
    margin-bottom:0 !important
  }

  .my-sm-1{
    margin-top:.25rem !important;
    margin-bottom:.25rem !important
  }

  .my-sm-2{
    margin-top:.5rem !important;
    margin-bottom:.5rem !important
  }

  .my-sm-3{
    margin-top:1rem !important;
    margin-bottom:1rem !important
  }

  .my-sm-4{
    margin-top:1.5rem !important;
    margin-bottom:1.5rem !important
  }

  .my-sm-5{
    margin-top:3rem !important;
    margin-bottom:3rem !important
  }

  .my-sm-auto{
    margin-top:auto !important;
    margin-bottom:auto !important
  }

  .mt-sm-0{
    margin-top:0 !important
  }

  .mt-sm-1{
    margin-top:.25rem !important
  }

  .mt-sm-2{
    margin-top:.5rem !important
  }

  .mt-sm-3{
    margin-top:1rem !important
  }

  .mt-sm-4{
    margin-top:1.5rem !important
  }

  .mt-sm-5{
    margin-top:3rem !important
  }

  .mt-sm-auto{
    margin-top:auto !important
  }

  .me-sm-0{
    margin-right:0 !important
  }

  .me-sm-1{
    margin-right:.25rem !important
  }

  .me-sm-2{
    margin-right:.5rem !important
  }

  .me-sm-3{
    margin-right:1rem !important
  }

  .me-sm-4{
    margin-right:1.5rem !important
  }

  .me-sm-5{
    margin-right:3rem !important
  }

  .me-sm-auto{
    margin-right:auto !important
  }

  .mb-sm-0{
    margin-bottom:0 !important
  }

  .mb-sm-1{
    margin-bottom:.25rem !important
  }

  .mb-sm-2{
    margin-bottom:.5rem !important
  }

  .mb-sm-3{
    margin-bottom:1rem !important
  }

  .mb-sm-4{
    margin-bottom:1.5rem !important
  }

  .mb-sm-5{
    margin-bottom:3rem !important
  }

  .mb-sm-auto{
    margin-bottom:auto !important
  }

  .ms-sm-0{
    margin-left:0 !important
  }

  .ms-sm-1{
    margin-left:.25rem !important
  }

  .ms-sm-2{
    margin-left:.5rem !important
  }

  .ms-sm-3{
    margin-left:1rem !important
  }

  .ms-sm-4{
    margin-left:1.5rem !important
  }

  .ms-sm-5{
    margin-left:3rem !important
  }

  .ms-sm-auto{
    margin-left:auto !important
  }

  .p-sm-0{
    padding:0 !important
  }

  .p-sm-1{
    padding:.25rem !important
  }

  .p-sm-2{
    padding:.5rem !important
  }

  .p-sm-3{
    padding:1rem !important
  }

  .p-sm-4{
    padding:1.5rem !important
  }

  .p-sm-5{
    padding:3rem !important
  }

  .px-sm-0{
    padding-right:0 !important;
    padding-left:0 !important
  }

  .px-sm-1{
    padding-right:.25rem !important;
    padding-left:.25rem !important
  }

  .px-sm-2{
    padding-right:.5rem !important;
    padding-left:.5rem !important
  }

  .px-sm-3{
    padding-right:1rem !important;
    padding-left:1rem !important
  }

  .px-sm-4{
    padding-right:1.5rem !important;
    padding-left:1.5rem !important
  }

  .px-sm-5{
    padding-right:3rem !important;
    padding-left:3rem !important
  }

  .py-sm-0{
    padding-top:0 !important;
    padding-bottom:0 !important
  }

  .py-sm-1{
    padding-top:.25rem !important;
    padding-bottom:.25rem !important
  }

  .py-sm-2{
    padding-top:.5rem !important;
    padding-bottom:.5rem !important
  }

  .py-sm-3{
    padding-top:1rem !important;
    padding-bottom:1rem !important
  }

  .py-sm-4{
    padding-top:1.5rem !important;
    padding-bottom:1.5rem !important
  }

  .py-sm-5{
    padding-top:3rem !important;
    padding-bottom:3rem !important
  }

  .pt-sm-0{
    padding-top:0 !important
  }

  .pt-sm-1{
    padding-top:.25rem !important
  }

  .pt-sm-2{
    padding-top:.5rem !important
  }

  .pt-sm-3{
    padding-top:1rem !important
  }

  .pt-sm-4{
    padding-top:1.5rem !important
  }

  .pt-sm-5{
    padding-top:3rem !important
  }

  .pe-sm-0{
    padding-right:0 !important
  }

  .pe-sm-1{
    padding-right:.25rem !important
  }

  .pe-sm-2{
    padding-right:.5rem !important
  }

  .pe-sm-3{
    padding-right:1rem !important
  }

  .pe-sm-4{
    padding-right:1.5rem !important
  }

  .pe-sm-5{
    padding-right:3rem !important
  }

  .pb-sm-0{
    padding-bottom:0 !important
  }

  .pb-sm-1{
    padding-bottom:.25rem !important
  }

  .pb-sm-2{
    padding-bottom:.5rem !important
  }

  .pb-sm-3{
    padding-bottom:1rem !important
  }

  .pb-sm-4{
    padding-bottom:1.5rem !important
  }

  .pb-sm-5{
    padding-bottom:3rem !important
  }

  .ps-sm-0{
    padding-left:0 !important
  }

  .ps-sm-1{
    padding-left:.25rem !important
  }

  .ps-sm-2{
    padding-left:.5rem !important
  }

  .ps-sm-3{
    padding-left:1rem !important
  }

  .ps-sm-4{
    padding-left:1.5rem !important
  }

  .ps-sm-5{
    padding-left:3rem !important
  }

  .gap-sm-0{
    gap:0 !important
  }

  .gap-sm-1{
    gap:.25rem !important
  }

  .gap-sm-2{
    gap:.5rem !important
  }

  .gap-sm-3{
    gap:1rem !important
  }

  .gap-sm-4{
    gap:1.5rem !important
  }

  .gap-sm-5{
    gap:3rem !important
  }

  .row-gap-sm-0{
    row-gap:0 !important
  }

  .row-gap-sm-1{
    row-gap:.25rem !important
  }

  .row-gap-sm-2{
    row-gap:.5rem !important
  }

  .row-gap-sm-3{
    row-gap:1rem !important
  }

  .row-gap-sm-4{
    row-gap:1.5rem !important
  }

  .row-gap-sm-5{
    row-gap:3rem !important
  }

  .column-gap-sm-0{
    column-gap:0 !important
  }

  .column-gap-sm-1{
    column-gap:.25rem !important
  }

  .column-gap-sm-2{
    column-gap:.5rem !important
  }

  .column-gap-sm-3{
    column-gap:1rem !important
  }

  .column-gap-sm-4{
    column-gap:1.5rem !important
  }

  .column-gap-sm-5{
    column-gap:3rem !important
  }

  .text-sm-start{
    text-align:left !important
  }

  .text-sm-end{
    text-align:right !important
  }

  .text-sm-center{
    text-align:center !important
  }
}

@media(min-width: 768px){
  .float-md-start{
    float:left !important
  }

  .float-md-end{
    float:right !important
  }

  .float-md-none{
    float:none !important
  }

  .object-fit-md-contain{
    object-fit:contain !important
  }

  .object-fit-md-cover{
    object-fit:cover !important
  }

  .object-fit-md-fill{
    object-fit:fill !important
  }

  .object-fit-md-scale{
    object-fit:scale-down !important
  }

  .object-fit-md-none{
    object-fit:none !important
  }

  .d-md-inline{
    display:inline !important
  }

  .d-md-inline-block{
    display:inline-block !important
  }

  .d-md-block{
    display:block !important
  }

  .d-md-grid{
    display:grid !important
  }

  .d-md-inline-grid{
    display:inline-grid !important
  }

  .d-md-table{
    display:table !important
  }

  .d-md-table-row{
    display:table-row !important
  }

  .d-md-table-cell{
    display:table-cell !important
  }

  .d-md-flex{
    display:flex !important
  }

  .d-md-inline-flex{
    display:inline-flex !important
  }

  .d-md-none{
    display:none !important
  }

  .flex-md-fill{
    flex:1 1 auto !important
  }

  .flex-md-row{
    flex-direction:row !important
  }

  .flex-md-column{
    flex-direction:column !important
  }

  .flex-md-row-reverse{
    flex-direction:row-reverse !important
  }

  .flex-md-column-reverse{
    flex-direction:column-reverse !important
  }

  .flex-md-grow-0{
    flex-grow:0 !important
  }

  .flex-md-grow-1{
    flex-grow:1 !important
  }

  .flex-md-shrink-0{
    flex-shrink:0 !important
  }

  .flex-md-shrink-1{
    flex-shrink:1 !important
  }

  .flex-md-wrap{
    flex-wrap:wrap !important
  }

  .flex-md-nowrap{
    flex-wrap:nowrap !important
  }

  .flex-md-wrap-reverse{
    flex-wrap:wrap-reverse !important
  }

  .justify-content-md-start{
    justify-content:flex-start !important
  }

  .justify-content-md-end{
    justify-content:flex-end !important
  }

  .justify-content-md-center{
    justify-content:center !important
  }

  .justify-content-md-between{
    justify-content:space-between !important
  }

  .justify-content-md-around{
    justify-content:space-around !important
  }

  .justify-content-md-evenly{
    justify-content:space-evenly !important
  }

  .align-items-md-start{
    align-items:flex-start !important
  }

  .align-items-md-end{
    align-items:flex-end !important
  }

  .align-items-md-center{
    align-items:center !important
  }

  .align-items-md-baseline{
    align-items:baseline !important
  }

  .align-items-md-stretch{
    align-items:stretch !important
  }

  .align-content-md-start{
    align-content:flex-start !important
  }

  .align-content-md-end{
    align-content:flex-end !important
  }

  .align-content-md-center{
    align-content:center !important
  }

  .align-content-md-between{
    align-content:space-between !important
  }

  .align-content-md-around{
    align-content:space-around !important
  }

  .align-content-md-stretch{
    align-content:stretch !important
  }

  .align-self-md-auto{
    align-self:auto !important
  }

  .align-self-md-start{
    align-self:flex-start !important
  }

  .align-self-md-end{
    align-self:flex-end !important
  }

  .align-self-md-center{
    align-self:center !important
  }

  .align-self-md-baseline{
    align-self:baseline !important
  }

  .align-self-md-stretch{
    align-self:stretch !important
  }

  .order-md-first{
    order:-1 !important
  }

  .order-md-0{
    order:0 !important
  }

  .order-md-1{
    order:1 !important
  }

  .order-md-2{
    order:2 !important
  }

  .order-md-3{
    order:3 !important
  }

  .order-md-4{
    order:4 !important
  }

  .order-md-5{
    order:5 !important
  }

  .order-md-last{
    order:6 !important
  }

  .m-md-0{
    margin:0 !important
  }

  .m-md-1{
    margin:.25rem !important
  }

  .m-md-2{
    margin:.5rem !important
  }

  .m-md-3{
    margin:1rem !important
  }

  .m-md-4{
    margin:1.5rem !important
  }

  .m-md-5{
    margin:3rem !important
  }

  .m-md-auto{
    margin:auto !important
  }

  .mx-md-0{
    margin-right:0 !important;
    margin-left:0 !important
  }

  .mx-md-1{
    margin-right:.25rem !important;
    margin-left:.25rem !important
  }

  .mx-md-2{
    margin-right:.5rem !important;
    margin-left:.5rem !important
  }

  .mx-md-3{
    margin-right:1rem !important;
    margin-left:1rem !important
  }

  .mx-md-4{
    margin-right:1.5rem !important;
    margin-left:1.5rem !important
  }

  .mx-md-5{
    margin-right:3rem !important;
    margin-left:3rem !important
  }

  .mx-md-auto{
    margin-right:auto !important;
    margin-left:auto !important
  }

  .my-md-0{
    margin-top:0 !important;
    margin-bottom:0 !important
  }

  .my-md-1{
    margin-top:.25rem !important;
    margin-bottom:.25rem !important
  }

  .my-md-2{
    margin-top:.5rem !important;
    margin-bottom:.5rem !important
  }

  .my-md-3{
    margin-top:1rem !important;
    margin-bottom:1rem !important
  }

  .my-md-4{
    margin-top:1.5rem !important;
    margin-bottom:1.5rem !important
  }

  .my-md-5{
    margin-top:3rem !important;
    margin-bottom:3rem !important
  }

  .my-md-auto{
    margin-top:auto !important;
    margin-bottom:auto !important
  }

  .mt-md-0{
    margin-top:0 !important
  }

  .mt-md-1{
    margin-top:.25rem !important
  }

  .mt-md-2{
    margin-top:.5rem !important
  }

  .mt-md-3{
    margin-top:1rem !important
  }

  .mt-md-4{
    margin-top:1.5rem !important
  }

  .mt-md-5{
    margin-top:3rem !important
  }

  .mt-md-auto{
    margin-top:auto !important
  }

  .me-md-0{
    margin-right:0 !important
  }

  .me-md-1{
    margin-right:.25rem !important
  }

  .me-md-2{
    margin-right:.5rem !important
  }

  .me-md-3{
    margin-right:1rem !important
  }

  .me-md-4{
    margin-right:1.5rem !important
  }

  .me-md-5{
    margin-right:3rem !important
  }

  .me-md-auto{
    margin-right:auto !important
  }

  .mb-md-0{
    margin-bottom:0 !important
  }

  .mb-md-1{
    margin-bottom:.25rem !important
  }

  .mb-md-2{
    margin-bottom:.5rem !important
  }

  .mb-md-3{
    margin-bottom:1rem !important
  }

  .mb-md-4{
    margin-bottom:1.5rem !important
  }

  .mb-md-5{
    margin-bottom:3rem !important
  }

  .mb-md-auto{
    margin-bottom:auto !important
  }

  .ms-md-0{
    margin-left:0 !important
  }

  .ms-md-1{
    margin-left:.25rem !important
  }

  .ms-md-2{
    margin-left:.5rem !important
  }

  .ms-md-3{
    margin-left:1rem !important
  }

  .ms-md-4{
    margin-left:1.5rem !important
  }

  .ms-md-5{
    margin-left:3rem !important
  }

  .ms-md-auto{
    margin-left:auto !important
  }

  .p-md-0{
    padding:0 !important
  }

  .p-md-1{
    padding:.25rem !important
  }

  .p-md-2{
    padding:.5rem !important
  }

  .p-md-3{
    padding:1rem !important
  }

  .p-md-4{
    padding:1.5rem !important
  }

  .p-md-5{
    padding:3rem !important
  }

  .px-md-0{
    padding-right:0 !important;
    padding-left:0 !important
  }

  .px-md-1{
    padding-right:.25rem !important;
    padding-left:.25rem !important
  }

  .px-md-2{
    padding-right:.5rem !important;
    padding-left:.5rem !important
  }

  .px-md-3{
    padding-right:1rem !important;
    padding-left:1rem !important
  }

  .px-md-4{
    padding-right:1.5rem !important;
    padding-left:1.5rem !important
  }

  .px-md-5{
    padding-right:3rem !important;
    padding-left:3rem !important
  }

  .py-md-0{
    padding-top:0 !important;
    padding-bottom:0 !important
  }

  .py-md-1{
    padding-top:.25rem !important;
    padding-bottom:.25rem !important
  }

  .py-md-2{
    padding-top:.5rem !important;
    padding-bottom:.5rem !important
  }

  .py-md-3{
    padding-top:1rem !important;
    padding-bottom:1rem !important
  }

  .py-md-4{
    padding-top:1.5rem !important;
    padding-bottom:1.5rem !important
  }

  .py-md-5{
    padding-top:3rem !important;
    padding-bottom:3rem !important
  }

  .pt-md-0{
    padding-top:0 !important
  }

  .pt-md-1{
    padding-top:.25rem !important
  }

  .pt-md-2{
    padding-top:.5rem !important
  }

  .pt-md-3{
    padding-top:1rem !important
  }

  .pt-md-4{
    padding-top:1.5rem !important
  }

  .pt-md-5{
    padding-top:3rem !important
  }

  .pe-md-0{
    padding-right:0 !important
  }

  .pe-md-1{
    padding-right:.25rem !important
  }

  .pe-md-2{
    padding-right:.5rem !important
  }

  .pe-md-3{
    padding-right:1rem !important
  }

  .pe-md-4{
    padding-right:1.5rem !important
  }

  .pe-md-5{
    padding-right:3rem !important
  }

  .pb-md-0{
    padding-bottom:0 !important
  }

  .pb-md-1{
    padding-bottom:.25rem !important
  }

  .pb-md-2{
    padding-bottom:.5rem !important
  }

  .pb-md-3{
    padding-bottom:1rem !important
  }

  .pb-md-4{
    padding-bottom:1.5rem !important
  }

  .pb-md-5{
    padding-bottom:3rem !important
  }

  .ps-md-0{
    padding-left:0 !important
  }

  .ps-md-1{
    padding-left:.25rem !important
  }

  .ps-md-2{
    padding-left:.5rem !important
  }

  .ps-md-3{
    padding-left:1rem !important
  }

  .ps-md-4{
    padding-left:1.5rem !important
  }

  .ps-md-5{
    padding-left:3rem !important
  }

  .gap-md-0{
    gap:0 !important
  }

  .gap-md-1{
    gap:.25rem !important
  }

  .gap-md-2{
    gap:.5rem !important
  }

  .gap-md-3{
    gap:1rem !important
  }

  .gap-md-4{
    gap:1.5rem !important
  }

  .gap-md-5{
    gap:3rem !important
  }

  .row-gap-md-0{
    row-gap:0 !important
  }

  .row-gap-md-1{
    row-gap:.25rem !important
  }

  .row-gap-md-2{
    row-gap:.5rem !important
  }

  .row-gap-md-3{
    row-gap:1rem !important
  }

  .row-gap-md-4{
    row-gap:1.5rem !important
  }

  .row-gap-md-5{
    row-gap:3rem !important
  }

  .column-gap-md-0{
    column-gap:0 !important
  }

  .column-gap-md-1{
    column-gap:.25rem !important
  }

  .column-gap-md-2{
    column-gap:.5rem !important
  }

  .column-gap-md-3{
    column-gap:1rem !important
  }

  .column-gap-md-4{
    column-gap:1.5rem !important
  }

  .column-gap-md-5{
    column-gap:3rem !important
  }

  .text-md-start{
    text-align:left !important
  }

  .text-md-end{
    text-align:right !important
  }

  .text-md-center{
    text-align:center !important
  }
}

@media(min-width: 992px){
  .float-lg-start{
    float:left !important
  }

  .float-lg-end{
    float:right !important
  }

  .float-lg-none{
    float:none !important
  }

  .object-fit-lg-contain{
    object-fit:contain !important
  }

  .object-fit-lg-cover{
    object-fit:cover !important
  }

  .object-fit-lg-fill{
    object-fit:fill !important
  }

  .object-fit-lg-scale{
    object-fit:scale-down !important
  }

  .object-fit-lg-none{
    object-fit:none !important
  }

  .d-lg-inline{
    display:inline !important
  }

  .d-lg-inline-block{
    display:inline-block !important
  }

  .d-lg-block{
    display:block !important
  }

  .d-lg-grid{
    display:grid !important
  }

  .d-lg-inline-grid{
    display:inline-grid !important
  }

  .d-lg-table{
    display:table !important
  }

  .d-lg-table-row{
    display:table-row !important
  }

  .d-lg-table-cell{
    display:table-cell !important
  }

  .d-lg-flex{
    display:flex !important
  }

  .d-lg-inline-flex{
    display:inline-flex !important
  }

  .d-lg-none{
    display:none !important
  }

  .flex-lg-fill{
    flex:1 1 auto !important
  }

  .flex-lg-row{
    flex-direction:row !important
  }

  .flex-lg-column{
    flex-direction:column !important
  }

  .flex-lg-row-reverse{
    flex-direction:row-reverse !important
  }

  .flex-lg-column-reverse{
    flex-direction:column-reverse !important
  }

  .flex-lg-grow-0{
    flex-grow:0 !important
  }

  .flex-lg-grow-1{
    flex-grow:1 !important
  }

  .flex-lg-shrink-0{
    flex-shrink:0 !important
  }

  .flex-lg-shrink-1{
    flex-shrink:1 !important
  }

  .flex-lg-wrap{
    flex-wrap:wrap !important
  }

  .flex-lg-nowrap{
    flex-wrap:nowrap !important
  }

  .flex-lg-wrap-reverse{
    flex-wrap:wrap-reverse !important
  }

  .justify-content-lg-start{
    justify-content:flex-start !important
  }

  .justify-content-lg-end{
    justify-content:flex-end !important
  }

  .justify-content-lg-center{
    justify-content:center !important
  }

  .justify-content-lg-between{
    justify-content:space-between !important
  }

  .justify-content-lg-around{
    justify-content:space-around !important
  }

  .justify-content-lg-evenly{
    justify-content:space-evenly !important
  }

  .align-items-lg-start{
    align-items:flex-start !important
  }

  .align-items-lg-end{
    align-items:flex-end !important
  }

  .align-items-lg-center{
    align-items:center !important
  }

  .align-items-lg-baseline{
    align-items:baseline !important
  }

  .align-items-lg-stretch{
    align-items:stretch !important
  }

  .align-content-lg-start{
    align-content:flex-start !important
  }

  .align-content-lg-end{
    align-content:flex-end !important
  }

  .align-content-lg-center{
    align-content:center !important
  }

  .align-content-lg-between{
    align-content:space-between !important
  }

  .align-content-lg-around{
    align-content:space-around !important
  }

  .align-content-lg-stretch{
    align-content:stretch !important
  }

  .align-self-lg-auto{
    align-self:auto !important
  }

  .align-self-lg-start{
    align-self:flex-start !important
  }

  .align-self-lg-end{
    align-self:flex-end !important
  }

  .align-self-lg-center{
    align-self:center !important
  }

  .align-self-lg-baseline{
    align-self:baseline !important
  }

  .align-self-lg-stretch{
    align-self:stretch !important
  }

  .order-lg-first{
    order:-1 !important
  }

  .order-lg-0{
    order:0 !important
  }

  .order-lg-1{
    order:1 !important
  }

  .order-lg-2{
    order:2 !important
  }

  .order-lg-3{
    order:3 !important
  }

  .order-lg-4{
    order:4 !important
  }

  .order-lg-5{
    order:5 !important
  }

  .order-lg-last{
    order:6 !important
  }

  .m-lg-0{
    margin:0 !important
  }

  .m-lg-1{
    margin:.25rem !important
  }

  .m-lg-2{
    margin:.5rem !important
  }

  .m-lg-3{
    margin:1rem !important
  }

  .m-lg-4{
    margin:1.5rem !important
  }

  .m-lg-5{
    margin:3rem !important
  }

  .m-lg-auto{
    margin:auto !important
  }

  .mx-lg-0{
    margin-right:0 !important;
    margin-left:0 !important
  }

  .mx-lg-1{
    margin-right:.25rem !important;
    margin-left:.25rem !important
  }

  .mx-lg-2{
    margin-right:.5rem !important;
    margin-left:.5rem !important
  }

  .mx-lg-3{
    margin-right:1rem !important;
    margin-left:1rem !important
  }

  .mx-lg-4{
    margin-right:1.5rem !important;
    margin-left:1.5rem !important
  }

  .mx-lg-5{
    margin-right:3rem !important;
    margin-left:3rem !important
  }

  .mx-lg-auto{
    margin-right:auto !important;
    margin-left:auto !important
  }

  .my-lg-0{
    margin-top:0 !important;
    margin-bottom:0 !important
  }

  .my-lg-1{
    margin-top:.25rem !important;
    margin-bottom:.25rem !important
  }

  .my-lg-2{
    margin-top:.5rem !important;
    margin-bottom:.5rem !important
  }

  .my-lg-3{
    margin-top:1rem !important;
    margin-bottom:1rem !important
  }

  .my-lg-4{
    margin-top:1.5rem !important;
    margin-bottom:1.5rem !important
  }

  .my-lg-5{
    margin-top:3rem !important;
    margin-bottom:3rem !important
  }

  .my-lg-auto{
    margin-top:auto !important;
    margin-bottom:auto !important
  }

  .mt-lg-0{
    margin-top:0 !important
  }

  .mt-lg-1{
    margin-top:.25rem !important
  }

  .mt-lg-2{
    margin-top:.5rem !important
  }

  .mt-lg-3{
    margin-top:1rem !important
  }

  .mt-lg-4{
    margin-top:1.5rem !important
  }

  .mt-lg-5{
    margin-top:3rem !important
  }

  .mt-lg-auto{
    margin-top:auto !important
  }

  .me-lg-0{
    margin-right:0 !important
  }

  .me-lg-1{
    margin-right:.25rem !important
  }

  .me-lg-2{
    margin-right:.5rem !important
  }

  .me-lg-3{
    margin-right:1rem !important
  }

  .me-lg-4{
    margin-right:1.5rem !important
  }

  .me-lg-5{
    margin-right:3rem !important
  }

  .me-lg-auto{
    margin-right:auto !important
  }

  .mb-lg-0{
    margin-bottom:0 !important
  }

  .mb-lg-1{
    margin-bottom:.25rem !important
  }

  .mb-lg-2{
    margin-bottom:.5rem !important
  }

  .mb-lg-3{
    margin-bottom:1rem !important
  }

  .mb-lg-4{
    margin-bottom:1.5rem !important
  }

  .mb-lg-5{
    margin-bottom:3rem !important
  }

  .mb-lg-auto{
    margin-bottom:auto !important
  }

  .ms-lg-0{
    margin-left:0 !important
  }

  .ms-lg-1{
    margin-left:.25rem !important
  }

  .ms-lg-2{
    margin-left:.5rem !important
  }

  .ms-lg-3{
    margin-left:1rem !important
  }

  .ms-lg-4{
    margin-left:1.5rem !important
  }

  .ms-lg-5{
    margin-left:3rem !important
  }

  .ms-lg-auto{
    margin-left:auto !important
  }

  .p-lg-0{
    padding:0 !important
  }

  .p-lg-1{
    padding:.25rem !important
  }

  .p-lg-2{
    padding:.5rem !important
  }

  .p-lg-3{
    padding:1rem !important
  }

  .p-lg-4{
    padding:1.5rem !important
  }

  .p-lg-5{
    padding:3rem !important
  }

  .px-lg-0{
    padding-right:0 !important;
    padding-left:0 !important
  }

  .px-lg-1{
    padding-right:.25rem !important;
    padding-left:.25rem !important
  }

  .px-lg-2{
    padding-right:.5rem !important;
    padding-left:.5rem !important
  }

  .px-lg-3{
    padding-right:1rem !important;
    padding-left:1rem !important
  }

  .px-lg-4{
    padding-right:1.5rem !important;
    padding-left:1.5rem !important
  }

  .px-lg-5{
    padding-right:3rem !important;
    padding-left:3rem !important
  }

  .py-lg-0{
    padding-top:0 !important;
    padding-bottom:0 !important
  }

  .py-lg-1{
    padding-top:.25rem !important;
    padding-bottom:.25rem !important
  }

  .py-lg-2{
    padding-top:.5rem !important;
    padding-bottom:.5rem !important
  }

  .py-lg-3{
    padding-top:1rem !important;
    padding-bottom:1rem !important
  }

  .py-lg-4{
    padding-top:1.5rem !important;
    padding-bottom:1.5rem !important
  }

  .py-lg-5{
    padding-top:3rem !important;
    padding-bottom:3rem !important
  }

  .pt-lg-0{
    padding-top:0 !important
  }

  .pt-lg-1{
    padding-top:.25rem !important
  }

  .pt-lg-2{
    padding-top:.5rem !important
  }

  .pt-lg-3{
    padding-top:1rem !important
  }

  .pt-lg-4{
    padding-top:1.5rem !important
  }

  .pt-lg-5{
    padding-top:3rem !important
  }

  .pe-lg-0{
    padding-right:0 !important
  }

  .pe-lg-1{
    padding-right:.25rem !important
  }

  .pe-lg-2{
    padding-right:.5rem !important
  }

  .pe-lg-3{
    padding-right:1rem !important
  }

  .pe-lg-4{
    padding-right:1.5rem !important
  }

  .pe-lg-5{
    padding-right:3rem !important
  }

  .pb-lg-0{
    padding-bottom:0 !important
  }

  .pb-lg-1{
    padding-bottom:.25rem !important
  }

  .pb-lg-2{
    padding-bottom:.5rem !important
  }

  .pb-lg-3{
    padding-bottom:1rem !important
  }

  .pb-lg-4{
    padding-bottom:1.5rem !important
  }

  .pb-lg-5{
    padding-bottom:3rem !important
  }

  .ps-lg-0{
    padding-left:0 !important
  }

  .ps-lg-1{
    padding-left:.25rem !important
  }

  .ps-lg-2{
    padding-left:.5rem !important
  }

  .ps-lg-3{
    padding-left:1rem !important
  }

  .ps-lg-4{
    padding-left:1.5rem !important
  }

  .ps-lg-5{
    padding-left:3rem !important
  }

  .gap-lg-0{
    gap:0 !important
  }

  .gap-lg-1{
    gap:.25rem !important
  }

  .gap-lg-2{
    gap:.5rem !important
  }

  .gap-lg-3{
    gap:1rem !important
  }

  .gap-lg-4{
    gap:1.5rem !important
  }

  .gap-lg-5{
    gap:3rem !important
  }

  .row-gap-lg-0{
    row-gap:0 !important
  }

  .row-gap-lg-1{
    row-gap:.25rem !important
  }

  .row-gap-lg-2{
    row-gap:.5rem !important
  }

  .row-gap-lg-3{
    row-gap:1rem !important
  }

  .row-gap-lg-4{
    row-gap:1.5rem !important
  }

  .row-gap-lg-5{
    row-gap:3rem !important
  }

  .column-gap-lg-0{
    column-gap:0 !important
  }

  .column-gap-lg-1{
    column-gap:.25rem !important
  }

  .column-gap-lg-2{
    column-gap:.5rem !important
  }

  .column-gap-lg-3{
    column-gap:1rem !important
  }

  .column-gap-lg-4{
    column-gap:1.5rem !important
  }

  .column-gap-lg-5{
    column-gap:3rem !important
  }

  .text-lg-start{
    text-align:left !important
  }

  .text-lg-end{
    text-align:right !important
  }

  .text-lg-center{
    text-align:center !important
  }
}

@media(min-width: 1200px){
  .float-xl-start{
    float:left !important
  }

  .float-xl-end{
    float:right !important
  }

  .float-xl-none{
    float:none !important
  }

  .object-fit-xl-contain{
    object-fit:contain !important
  }

  .object-fit-xl-cover{
    object-fit:cover !important
  }

  .object-fit-xl-fill{
    object-fit:fill !important
  }

  .object-fit-xl-scale{
    object-fit:scale-down !important
  }

  .object-fit-xl-none{
    object-fit:none !important
  }

  .d-xl-inline{
    display:inline !important
  }

  .d-xl-inline-block{
    display:inline-block !important
  }

  .d-xl-block{
    display:block !important
  }

  .d-xl-grid{
    display:grid !important
  }

  .d-xl-inline-grid{
    display:inline-grid !important
  }

  .d-xl-table{
    display:table !important
  }

  .d-xl-table-row{
    display:table-row !important
  }

  .d-xl-table-cell{
    display:table-cell !important
  }

  .d-xl-flex{
    display:flex !important
  }

  .d-xl-inline-flex{
    display:inline-flex !important
  }

  .d-xl-none{
    display:none !important
  }

  .flex-xl-fill{
    flex:1 1 auto !important
  }

  .flex-xl-row{
    flex-direction:row !important
  }

  .flex-xl-column{
    flex-direction:column !important
  }

  .flex-xl-row-reverse{
    flex-direction:row-reverse !important
  }

  .flex-xl-column-reverse{
    flex-direction:column-reverse !important
  }

  .flex-xl-grow-0{
    flex-grow:0 !important
  }

  .flex-xl-grow-1{
    flex-grow:1 !important
  }

  .flex-xl-shrink-0{
    flex-shrink:0 !important
  }

  .flex-xl-shrink-1{
    flex-shrink:1 !important
  }

  .flex-xl-wrap{
    flex-wrap:wrap !important
  }

  .flex-xl-nowrap{
    flex-wrap:nowrap !important
  }

  .flex-xl-wrap-reverse{
    flex-wrap:wrap-reverse !important
  }

  .justify-content-xl-start{
    justify-content:flex-start !important
  }

  .justify-content-xl-end{
    justify-content:flex-end !important
  }

  .justify-content-xl-center{
    justify-content:center !important
  }

  .justify-content-xl-between{
    justify-content:space-between !important
  }

  .justify-content-xl-around{
    justify-content:space-around !important
  }

  .justify-content-xl-evenly{
    justify-content:space-evenly !important
  }

  .align-items-xl-start{
    align-items:flex-start !important
  }

  .align-items-xl-end{
    align-items:flex-end !important
  }

  .align-items-xl-center{
    align-items:center !important
  }

  .align-items-xl-baseline{
    align-items:baseline !important
  }

  .align-items-xl-stretch{
    align-items:stretch !important
  }

  .align-content-xl-start{
    align-content:flex-start !important
  }

  .align-content-xl-end{
    align-content:flex-end !important
  }

  .align-content-xl-center{
    align-content:center !important
  }

  .align-content-xl-between{
    align-content:space-between !important
  }

  .align-content-xl-around{
    align-content:space-around !important
  }

  .align-content-xl-stretch{
    align-content:stretch !important
  }

  .align-self-xl-auto{
    align-self:auto !important
  }

  .align-self-xl-start{
    align-self:flex-start !important
  }

  .align-self-xl-end{
    align-self:flex-end !important
  }

  .align-self-xl-center{
    align-self:center !important
  }

  .align-self-xl-baseline{
    align-self:baseline !important
  }

  .align-self-xl-stretch{
    align-self:stretch !important
  }

  .order-xl-first{
    order:-1 !important
  }

  .order-xl-0{
    order:0 !important
  }

  .order-xl-1{
    order:1 !important
  }

  .order-xl-2{
    order:2 !important
  }

  .order-xl-3{
    order:3 !important
  }

  .order-xl-4{
    order:4 !important
  }

  .order-xl-5{
    order:5 !important
  }

  .order-xl-last{
    order:6 !important
  }

  .m-xl-0{
    margin:0 !important
  }

  .m-xl-1{
    margin:.25rem !important
  }

  .m-xl-2{
    margin:.5rem !important
  }

  .m-xl-3{
    margin:1rem !important
  }

  .m-xl-4{
    margin:1.5rem !important
  }

  .m-xl-5{
    margin:3rem !important
  }

  .m-xl-auto{
    margin:auto !important
  }

  .mx-xl-0{
    margin-right:0 !important;
    margin-left:0 !important
  }

  .mx-xl-1{
    margin-right:.25rem !important;
    margin-left:.25rem !important
  }

  .mx-xl-2{
    margin-right:.5rem !important;
    margin-left:.5rem !important
  }

  .mx-xl-3{
    margin-right:1rem !important;
    margin-left:1rem !important
  }

  .mx-xl-4{
    margin-right:1.5rem !important;
    margin-left:1.5rem !important
  }

  .mx-xl-5{
    margin-right:3rem !important;
    margin-left:3rem !important
  }

  .mx-xl-auto{
    margin-right:auto !important;
    margin-left:auto !important
  }

  .my-xl-0{
    margin-top:0 !important;
    margin-bottom:0 !important
  }

  .my-xl-1{
    margin-top:.25rem !important;
    margin-bottom:.25rem !important
  }

  .my-xl-2{
    margin-top:.5rem !important;
    margin-bottom:.5rem !important
  }

  .my-xl-3{
    margin-top:1rem !important;
    margin-bottom:1rem !important
  }

  .my-xl-4{
    margin-top:1.5rem !important;
    margin-bottom:1.5rem !important
  }

  .my-xl-5{
    margin-top:3rem !important;
    margin-bottom:3rem !important
  }

  .my-xl-auto{
    margin-top:auto !important;
    margin-bottom:auto !important
  }

  .mt-xl-0{
    margin-top:0 !important
  }

  .mt-xl-1{
    margin-top:.25rem !important
  }

  .mt-xl-2{
    margin-top:.5rem !important
  }

  .mt-xl-3{
    margin-top:1rem !important
  }

  .mt-xl-4{
    margin-top:1.5rem !important
  }

  .mt-xl-5{
    margin-top:3rem !important
  }

  .mt-xl-auto{
    margin-top:auto !important
  }

  .me-xl-0{
    margin-right:0 !important
  }

  .me-xl-1{
    margin-right:.25rem !important
  }

  .me-xl-2{
    margin-right:.5rem !important
  }

  .me-xl-3{
    margin-right:1rem !important
  }

  .me-xl-4{
    margin-right:1.5rem !important
  }

  .me-xl-5{
    margin-right:3rem !important
  }

  .me-xl-auto{
    margin-right:auto !important
  }

  .mb-xl-0{
    margin-bottom:0 !important
  }

  .mb-xl-1{
    margin-bottom:.25rem !important
  }

  .mb-xl-2{
    margin-bottom:.5rem !important
  }

  .mb-xl-3{
    margin-bottom:1rem !important
  }

  .mb-xl-4{
    margin-bottom:1.5rem !important
  }

  .mb-xl-5{
    margin-bottom:3rem !important
  }

  .mb-xl-auto{
    margin-bottom:auto !important
  }

  .ms-xl-0{
    margin-left:0 !important
  }

  .ms-xl-1{
    margin-left:.25rem !important
  }

  .ms-xl-2{
    margin-left:.5rem !important
  }

  .ms-xl-3{
    margin-left:1rem !important
  }

  .ms-xl-4{
    margin-left:1.5rem !important
  }

  .ms-xl-5{
    margin-left:3rem !important
  }

  .ms-xl-auto{
    margin-left:auto !important
  }

  .p-xl-0{
    padding:0 !important
  }

  .p-xl-1{
    padding:.25rem !important
  }

  .p-xl-2{
    padding:.5rem !important
  }

  .p-xl-3{
    padding:1rem !important
  }

  .p-xl-4{
    padding:1.5rem !important
  }

  .p-xl-5{
    padding:3rem !important
  }

  .px-xl-0{
    padding-right:0 !important;
    padding-left:0 !important
  }

  .px-xl-1{
    padding-right:.25rem !important;
    padding-left:.25rem !important
  }

  .px-xl-2{
    padding-right:.5rem !important;
    padding-left:.5rem !important
  }

  .px-xl-3{
    padding-right:1rem !important;
    padding-left:1rem !important
  }

  .px-xl-4{
    padding-right:1.5rem !important;
    padding-left:1.5rem !important
  }

  .px-xl-5{
    padding-right:3rem !important;
    padding-left:3rem !important
  }

  .py-xl-0{
    padding-top:0 !important;
    padding-bottom:0 !important
  }

  .py-xl-1{
    padding-top:.25rem !important;
    padding-bottom:.25rem !important
  }

  .py-xl-2{
    padding-top:.5rem !important;
    padding-bottom:.5rem !important
  }

  .py-xl-3{
    padding-top:1rem !important;
    padding-bottom:1rem !important
  }

  .py-xl-4{
    padding-top:1.5rem !important;
    padding-bottom:1.5rem !important
  }

  .py-xl-5{
    padding-top:3rem !important;
    padding-bottom:3rem !important
  }

  .pt-xl-0{
    padding-top:0 !important
  }

  .pt-xl-1{
    padding-top:.25rem !important
  }

  .pt-xl-2{
    padding-top:.5rem !important
  }

  .pt-xl-3{
    padding-top:1rem !important
  }

  .pt-xl-4{
    padding-top:1.5rem !important
  }

  .pt-xl-5{
    padding-top:3rem !important
  }

  .pe-xl-0{
    padding-right:0 !important
  }

  .pe-xl-1{
    padding-right:.25rem !important
  }

  .pe-xl-2{
    padding-right:.5rem !important
  }

  .pe-xl-3{
    padding-right:1rem !important
  }

  .pe-xl-4{
    padding-right:1.5rem !important
  }

  .pe-xl-5{
    padding-right:3rem !important
  }

  .pb-xl-0{
    padding-bottom:0 !important
  }

  .pb-xl-1{
    padding-bottom:.25rem !important
  }

  .pb-xl-2{
    padding-bottom:.5rem !important
  }

  .pb-xl-3{
    padding-bottom:1rem !important
  }

  .pb-xl-4{
    padding-bottom:1.5rem !important
  }

  .pb-xl-5{
    padding-bottom:3rem !important
  }

  .ps-xl-0{
    padding-left:0 !important
  }

  .ps-xl-1{
    padding-left:.25rem !important
  }

  .ps-xl-2{
    padding-left:.5rem !important
  }

  .ps-xl-3{
    padding-left:1rem !important
  }

  .ps-xl-4{
    padding-left:1.5rem !important
  }

  .ps-xl-5{
    padding-left:3rem !important
  }

  .gap-xl-0{
    gap:0 !important
  }

  .gap-xl-1{
    gap:.25rem !important
  }

  .gap-xl-2{
    gap:.5rem !important
  }

  .gap-xl-3{
    gap:1rem !important
  }

  .gap-xl-4{
    gap:1.5rem !important
  }

  .gap-xl-5{
    gap:3rem !important
  }

  .row-gap-xl-0{
    row-gap:0 !important
  }

  .row-gap-xl-1{
    row-gap:.25rem !important
  }

  .row-gap-xl-2{
    row-gap:.5rem !important
  }

  .row-gap-xl-3{
    row-gap:1rem !important
  }

  .row-gap-xl-4{
    row-gap:1.5rem !important
  }

  .row-gap-xl-5{
    row-gap:3rem !important
  }

  .column-gap-xl-0{
    column-gap:0 !important
  }

  .column-gap-xl-1{
    column-gap:.25rem !important
  }

  .column-gap-xl-2{
    column-gap:.5rem !important
  }

  .column-gap-xl-3{
    column-gap:1rem !important
  }

  .column-gap-xl-4{
    column-gap:1.5rem !important
  }

  .column-gap-xl-5{
    column-gap:3rem !important
  }

  .text-xl-start{
    text-align:left !important
  }

  .text-xl-end{
    text-align:right !important
  }

  .text-xl-center{
    text-align:center !important
  }
}

@media(min-width: 1400px){
  .float-xxl-start{
    float:left !important
  }

  .float-xxl-end{
    float:right !important
  }

  .float-xxl-none{
    float:none !important
  }

  .object-fit-xxl-contain{
    object-fit:contain !important
  }

  .object-fit-xxl-cover{
    object-fit:cover !important
  }

  .object-fit-xxl-fill{
    object-fit:fill !important
  }

  .object-fit-xxl-scale{
    object-fit:scale-down !important
  }

  .object-fit-xxl-none{
    object-fit:none !important
  }

  .d-xxl-inline{
    display:inline !important
  }

  .d-xxl-inline-block{
    display:inline-block !important
  }

  .d-xxl-block{
    display:block !important
  }

  .d-xxl-grid{
    display:grid !important
  }

  .d-xxl-inline-grid{
    display:inline-grid !important
  }

  .d-xxl-table{
    display:table !important
  }

  .d-xxl-table-row{
    display:table-row !important
  }

  .d-xxl-table-cell{
    display:table-cell !important
  }

  .d-xxl-flex{
    display:flex !important
  }

  .d-xxl-inline-flex{
    display:inline-flex !important
  }

  .d-xxl-none{
    display:none !important
  }

  .flex-xxl-fill{
    flex:1 1 auto !important
  }

  .flex-xxl-row{
    flex-direction:row !important
  }

  .flex-xxl-column{
    flex-direction:column !important
  }

  .flex-xxl-row-reverse{
    flex-direction:row-reverse !important
  }

  .flex-xxl-column-reverse{
    flex-direction:column-reverse !important
  }

  .flex-xxl-grow-0{
    flex-grow:0 !important
  }

  .flex-xxl-grow-1{
    flex-grow:1 !important
  }

  .flex-xxl-shrink-0{
    flex-shrink:0 !important
  }

  .flex-xxl-shrink-1{
    flex-shrink:1 !important
  }

  .flex-xxl-wrap{
    flex-wrap:wrap !important
  }

  .flex-xxl-nowrap{
    flex-wrap:nowrap !important
  }

  .flex-xxl-wrap-reverse{
    flex-wrap:wrap-reverse !important
  }

  .justify-content-xxl-start{
    justify-content:flex-start !important
  }

  .justify-content-xxl-end{
    justify-content:flex-end !important
  }

  .justify-content-xxl-center{
    justify-content:center !important
  }

  .justify-content-xxl-between{
    justify-content:space-between !important
  }

  .justify-content-xxl-around{
    justify-content:space-around !important
  }

  .justify-content-xxl-evenly{
    justify-content:space-evenly !important
  }

  .align-items-xxl-start{
    align-items:flex-start !important
  }

  .align-items-xxl-end{
    align-items:flex-end !important
  }

  .align-items-xxl-center{
    align-items:center !important
  }

  .align-items-xxl-baseline{
    align-items:baseline !important
  }

  .align-items-xxl-stretch{
    align-items:stretch !important
  }

  .align-content-xxl-start{
    align-content:flex-start !important
  }

  .align-content-xxl-end{
    align-content:flex-end !important
  }

  .align-content-xxl-center{
    align-content:center !important
  }

  .align-content-xxl-between{
    align-content:space-between !important
  }

  .align-content-xxl-around{
    align-content:space-around !important
  }

  .align-content-xxl-stretch{
    align-content:stretch !important
  }

  .align-self-xxl-auto{
    align-self:auto !important
  }

  .align-self-xxl-start{
    align-self:flex-start !important
  }

  .align-self-xxl-end{
    align-self:flex-end !important
  }

  .align-self-xxl-center{
    align-self:center !important
  }

  .align-self-xxl-baseline{
    align-self:baseline !important
  }

  .align-self-xxl-stretch{
    align-self:stretch !important
  }

  .order-xxl-first{
    order:-1 !important
  }

  .order-xxl-0{
    order:0 !important
  }

  .order-xxl-1{
    order:1 !important
  }

  .order-xxl-2{
    order:2 !important
  }

  .order-xxl-3{
    order:3 !important
  }

  .order-xxl-4{
    order:4 !important
  }

  .order-xxl-5{
    order:5 !important
  }

  .order-xxl-last{
    order:6 !important
  }

  .m-xxl-0{
    margin:0 !important
  }

  .m-xxl-1{
    margin:.25rem !important
  }

  .m-xxl-2{
    margin:.5rem !important
  }

  .m-xxl-3{
    margin:1rem !important
  }

  .m-xxl-4{
    margin:1.5rem !important
  }

  .m-xxl-5{
    margin:3rem !important
  }

  .m-xxl-auto{
    margin:auto !important
  }

  .mx-xxl-0{
    margin-right:0 !important;
    margin-left:0 !important
  }

  .mx-xxl-1{
    margin-right:.25rem !important;
    margin-left:.25rem !important
  }

  .mx-xxl-2{
    margin-right:.5rem !important;
    margin-left:.5rem !important
  }

  .mx-xxl-3{
    margin-right:1rem !important;
    margin-left:1rem !important
  }

  .mx-xxl-4{
    margin-right:1.5rem !important;
    margin-left:1.5rem !important
  }

  .mx-xxl-5{
    margin-right:3rem !important;
    margin-left:3rem !important
  }

  .mx-xxl-auto{
    margin-right:auto !important;
    margin-left:auto !important
  }

  .my-xxl-0{
    margin-top:0 !important;
    margin-bottom:0 !important
  }

  .my-xxl-1{
    margin-top:.25rem !important;
    margin-bottom:.25rem !important
  }

  .my-xxl-2{
    margin-top:.5rem !important;
    margin-bottom:.5rem !important
  }

  .my-xxl-3{
    margin-top:1rem !important;
    margin-bottom:1rem !important
  }

  .my-xxl-4{
    margin-top:1.5rem !important;
    margin-bottom:1.5rem !important
  }

  .my-xxl-5{
    margin-top:3rem !important;
    margin-bottom:3rem !important
  }

  .my-xxl-auto{
    margin-top:auto !important;
    margin-bottom:auto !important
  }

  .mt-xxl-0{
    margin-top:0 !important
  }

  .mt-xxl-1{
    margin-top:.25rem !important
  }

  .mt-xxl-2{
    margin-top:.5rem !important
  }

  .mt-xxl-3{
    margin-top:1rem !important
  }

  .mt-xxl-4{
    margin-top:1.5rem !important
  }

  .mt-xxl-5{
    margin-top:3rem !important
  }

  .mt-xxl-auto{
    margin-top:auto !important
  }

  .me-xxl-0{
    margin-right:0 !important
  }

  .me-xxl-1{
    margin-right:.25rem !important
  }

  .me-xxl-2{
    margin-right:.5rem !important
  }

  .me-xxl-3{
    margin-right:1rem !important
  }

  .me-xxl-4{
    margin-right:1.5rem !important
  }

  .me-xxl-5{
    margin-right:3rem !important
  }

  .me-xxl-auto{
    margin-right:auto !important
  }

  .mb-xxl-0{
    margin-bottom:0 !important
  }

  .mb-xxl-1{
    margin-bottom:.25rem !important
  }

  .mb-xxl-2{
    margin-bottom:.5rem !important
  }

  .mb-xxl-3{
    margin-bottom:1rem !important
  }

  .mb-xxl-4{
    margin-bottom:1.5rem !important
  }

  .mb-xxl-5{
    margin-bottom:3rem !important
  }

  .mb-xxl-auto{
    margin-bottom:auto !important
  }

  .ms-xxl-0{
    margin-left:0 !important
  }

  .ms-xxl-1{
    margin-left:.25rem !important
  }

  .ms-xxl-2{
    margin-left:.5rem !important
  }

  .ms-xxl-3{
    margin-left:1rem !important
  }

  .ms-xxl-4{
    margin-left:1.5rem !important
  }

  .ms-xxl-5{
    margin-left:3rem !important
  }

  .ms-xxl-auto{
    margin-left:auto !important
  }

  .p-xxl-0{
    padding:0 !important
  }

  .p-xxl-1{
    padding:.25rem !important
  }

  .p-xxl-2{
    padding:.5rem !important
  }

  .p-xxl-3{
    padding:1rem !important
  }

  .p-xxl-4{
    padding:1.5rem !important
  }

  .p-xxl-5{
    padding:3rem !important
  }

  .px-xxl-0{
    padding-right:0 !important;
    padding-left:0 !important
  }

  .px-xxl-1{
    padding-right:.25rem !important;
    padding-left:.25rem !important
  }

  .px-xxl-2{
    padding-right:.5rem !important;
    padding-left:.5rem !important
  }

  .px-xxl-3{
    padding-right:1rem !important;
    padding-left:1rem !important
  }

  .px-xxl-4{
    padding-right:1.5rem !important;
    padding-left:1.5rem !important
  }

  .px-xxl-5{
    padding-right:3rem !important;
    padding-left:3rem !important
  }

  .py-xxl-0{
    padding-top:0 !important;
    padding-bottom:0 !important
  }

  .py-xxl-1{
    padding-top:.25rem !important;
    padding-bottom:.25rem !important
  }

  .py-xxl-2{
    padding-top:.5rem !important;
    padding-bottom:.5rem !important
  }

  .py-xxl-3{
    padding-top:1rem !important;
    padding-bottom:1rem !important
  }

  .py-xxl-4{
    padding-top:1.5rem !important;
    padding-bottom:1.5rem !important
  }

  .py-xxl-5{
    padding-top:3rem !important;
    padding-bottom:3rem !important
  }

  .pt-xxl-0{
    padding-top:0 !important
  }

  .pt-xxl-1{
    padding-top:.25rem !important
  }

  .pt-xxl-2{
    padding-top:.5rem !important
  }

  .pt-xxl-3{
    padding-top:1rem !important
  }

  .pt-xxl-4{
    padding-top:1.5rem !important
  }

  .pt-xxl-5{
    padding-top:3rem !important
  }

  .pe-xxl-0{
    padding-right:0 !important
  }

  .pe-xxl-1{
    padding-right:.25rem !important
  }

  .pe-xxl-2{
    padding-right:.5rem !important
  }

  .pe-xxl-3{
    padding-right:1rem !important
  }

  .pe-xxl-4{
    padding-right:1.5rem !important
  }

  .pe-xxl-5{
    padding-right:3rem !important
  }

  .pb-xxl-0{
    padding-bottom:0 !important
  }

  .pb-xxl-1{
    padding-bottom:.25rem !important
  }

  .pb-xxl-2{
    padding-bottom:.5rem !important
  }

  .pb-xxl-3{
    padding-bottom:1rem !important
  }

  .pb-xxl-4{
    padding-bottom:1.5rem !important
  }

  .pb-xxl-5{
    padding-bottom:3rem !important
  }

  .ps-xxl-0{
    padding-left:0 !important
  }

  .ps-xxl-1{
    padding-left:.25rem !important
  }

  .ps-xxl-2{
    padding-left:.5rem !important
  }

  .ps-xxl-3{
    padding-left:1rem !important
  }

  .ps-xxl-4{
    padding-left:1.5rem !important
  }

  .ps-xxl-5{
    padding-left:3rem !important
  }

  .gap-xxl-0{
    gap:0 !important
  }

  .gap-xxl-1{
    gap:.25rem !important
  }

  .gap-xxl-2{
    gap:.5rem !important
  }

  .gap-xxl-3{
    gap:1rem !important
  }

  .gap-xxl-4{
    gap:1.5rem !important
  }

  .gap-xxl-5{
    gap:3rem !important
  }

  .row-gap-xxl-0{
    row-gap:0 !important
  }

  .row-gap-xxl-1{
    row-gap:.25rem !important
  }

  .row-gap-xxl-2{
    row-gap:.5rem !important
  }

  .row-gap-xxl-3{
    row-gap:1rem !important
  }

  .row-gap-xxl-4{
    row-gap:1.5rem !important
  }

  .row-gap-xxl-5{
    row-gap:3rem !important
  }

  .column-gap-xxl-0{
    column-gap:0 !important
  }

  .column-gap-xxl-1{
    column-gap:.25rem !important
  }

  .column-gap-xxl-2{
    column-gap:.5rem !important
  }

  .column-gap-xxl-3{
    column-gap:1rem !important
  }

  .column-gap-xxl-4{
    column-gap:1.5rem !important
  }

  .column-gap-xxl-5{
    column-gap:3rem !important
  }

  .text-xxl-start{
    text-align:left !important
  }

  .text-xxl-end{
    text-align:right !important
  }

  .text-xxl-center{
    text-align:center !important
  }
}

@media(min-width: 1200px){
  .fs-1{
    font-size:2.5rem !important
  }

  .fs-2{
    font-size:2rem !important
  }

  .fs-3{
    font-size:1.75rem !important
  }

  .fs-4{
    font-size:1.5rem !important
  }
}

@media print{
  .d-print-inline{
    display:inline !important
  }

  .d-print-inline-block{
    display:inline-block !important
  }

  .d-print-block{
    display:block !important
  }

  .d-print-grid{
    display:grid !important
  }

  .d-print-inline-grid{
    display:inline-grid !important
  }

  .d-print-table{
    display:table !important
  }

  .d-print-table-row{
    display:table-row !important
  }

  .d-print-table-cell{
    display:table-cell !important
  }

  .d-print-flex{
    display:flex !important
  }

  .d-print-inline-flex{
    display:inline-flex !important
  }

  .d-print-none{
    display:none !important
  }
}

pre{
  margin-bottom:0
}

.c-sidebar-menu-item{
  padding-top:.75rem;
  padding-bottom:.75rem
}

.c-sidebar-menu-item.active{
  background-color:#495057
}

/* purgecss end ignore */`, "",{"version":3,"sources":["<no source>","webpack://./scss/debugger.scss","webpack://./../../../../../node_modules/bootstrap/scss/_root.scss","webpack://./../../../../../node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./../../../../../node_modules/bootstrap/scss/_reboot.scss","webpack://./../../../../../node_modules/bootstrap/scss/_variables.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../../../../../node_modules/bootstrap/scss/_type.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../../../../../node_modules/bootstrap/scss/_images.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../../../../../node_modules/bootstrap/scss/_containers.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_container.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../../../../../node_modules/bootstrap/scss/_grid.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../../../../../node_modules/bootstrap/scss/_tables.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./../../../../../node_modules/bootstrap/scss/_buttons.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../../../../../node_modules/bootstrap/scss/_transitions.scss","webpack://./../../../../../node_modules/bootstrap/scss/_button-group.scss","webpack://./../../../../../node_modules/bootstrap/scss/_nav.scss","webpack://./../../../../../node_modules/bootstrap/scss/_navbar.scss","webpack://./../../../../../node_modules/bootstrap/scss/_card.scss","webpack://./../../../../../node_modules/bootstrap/scss/_badge.scss","webpack://./../../../../../node_modules/bootstrap/scss/_alert.scss","webpack://./../../../../../node_modules/bootstrap/scss/_list-group.scss","webpack://./../../../../../node_modules/bootstrap/scss/_close.scss","webpack://./../../../../../node_modules/bootstrap/scss/_modal.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./../../../../../node_modules/bootstrap/scss/_tooltip.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_position.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../../../../../node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./../../../../../node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./../../../../../node_modules/bootstrap/scss/utilities/_api.scss","webpack://./scss/base/_typography.scss","webpack://./scss/layout/_sidebar.scss"],"names":[],"mappings":"AAAA,2BAAA;;ACAA;ECAA,kBASI;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAAA,sBAIA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,qBAIA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,8BAIA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,iCAAA;EAAA,mCAIA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,+BAIA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,mCAIA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,6BAGF;EAAA,uBACA;EAAA,qNAMA;EAAA,yGACA;EAAA,yFACA;EAAA,gDAOA;EAAA,wBCsOQ;EAAA,0BDpOR;EAAA,0BACA;EAAA,wBAKA;EAAA,+BACA;EAAA,kBACA;EAAA,+BACA;EAAA,yBAEA;EAAA,gCACA;EAAA,4CAEA;EAAA,oCACA;EAAA,0BACA;EAAA,oCACA;EAAA,0CAEA;EAAA,mCACA;EAAA,yBACA;EAAA,mCACA;EAAA,2BAGA;EAAA,wBAEA;EAAA,iCACA;EAAA,+BACA;EAAA,8BAEA;EAAA,sCACA;EAAA,wBAMA;EAAA,6BACA;EAAA,0BACA;EAAA,sBAGA;EAAA,wBACA;EAAA,0BACA;EAAA,mDACA;EAAA,4BAEA;EAAA,8BACA;EAAA,6BACA;EAAA,2BACA;EAAA,4BACA;EAAA,mDACA;EAAA,8BACA;EAAA,kDAGA;EAAA,2DACA;EAAA,oDACA;EAAA,2DACA;EAAA,8BAIA;EAAA,6BACA;EAAA,+CACA;EAAA,8BAIA;EAAA,qCACA;EAAA,gCACA;EAAA;AACA;;AAAA;EEhHE,iBFsHA;EAAA,wBAGA;EAAA,kCACA;EAAA,qBACA;EAAA,4BACA;EAAA,yBAEA;EAAA,sCACA;EAAA,+CAEA;EAAA,uCACA;EAAA,0BACA;EAAA,iCACA;EAAA,6CAEA;EAAA,sCACA;EAAA,yBACA;EAAA,gCACA;EAAA,mCAGE;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,+BAIA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,mCAIA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,2BAGF;EAAA,wBAEA;EAAA,8BACA;EAAA,kCACA;EAAA,wCACA;EAAA,wBAEA;EAAA,6BACA;EAAA,0BACA;EAAA,0BAEA;EAAA,wDACA;EAAA,8BAEA;EAAA,qCACA;EAAA,gCACA;EAAA;AACA;;AAAA;EGxKJ;AAGE;;AAAA;EAeE;IANJ;EAOM;AAAA;;AAAA;EAcN,QACE;EAAA,sCACA;EAAA,kCFwOQ;EAAA,sCEtOR;EAAA,sCACA;EAAA,0BACA;EAAA,oCACA;EAAA,kCACA;EAAA,6BACA;EAAA;AACA;;AAAA;EASF,aACE;EAAA,aConB4B;EAAA,QDlnB5B;EAAA,uCACA;EAAA;AC0nB4B;;AAAA;ED/mB9B,YACE;EAAA,mBCyjB4B;EAAA,eAGA;EAAA,eACA;EAAA;ADvjB5B;;AAAA;EAGF;AFuMQ;;AAAA;EA5JJ;IE3CJ;EF8MQ;AAAA;;AAAA;EEzMR;AFkMQ;;AAAA;EA5JJ;IEtCJ;EFyMQ;AAAA;;AAAA;EEpMR;AF6LQ;;AAAA;EA5JJ;IEjCJ;EFoMQ;AAAA;;AAAA;EE/LR;AFwLQ;;AAAA;EA5JJ;IE5BJ;EF+LQ;AAAA;;AAAA;EE1LR;AF0KU;;AAAA;EErKV;AFqKU;;AAAA;EE1JV,YACE;EAAA;ACyV0B;;AAAA;ED9U5B,gCACE;EAAA,WACA;EAAA;AACA;;AAAA;EAMF,kBACE;EAAA,iBACA;EAAA;AACA;;AAAA;EAMF;AAEE;;AAAA;EAGF,YAGE;EAAA;AACA;;AAAA;EAGF;AAIE;;AAAA;EAGF;AC8b8B;;AAAA;EDxb9B,mBACE;EAAA;AACA;;AAAA;EAMF;AACE;;AAAA;EAQF;ACwa8B;;AAAA;ED9Z9B;AFwEU;;AAAA;EEjEV,eCsf8B;EAAA,+BDpf5B;EAAA;AACA;;AAAA;EASF,iBAEE;EAAA,gBFmDQ;EAAA,aEjDR;EAAA;AACA;;AAAA;EAGF;AAAA;;AAAA;EACA;AAAA;;AAAA;EAKA,+DACE;EAAA;ACiNwC;;AAAA;ED9MxC;AACE;;AAAA;EAWF,aAEE;EAAA;AACA;;AAAA;EAOJ,oCCoV8B;EAAA;AHvUpB;;AAAA;EEDV,aACE;EAAA,YACA;EAAA,kBACA;EAAA,aACA;EAAA;AFHQ;;AAAA;EEQR,iBFRQ;EAAA,aEUN;EAAA;AACA;;AAAA;EAIJ,iBFfU;EAAA,0BEiBR;EAAA;AACA;;AAAA;EAGA;AACE;;AAAA;EAIJ,wBACE;EAAA,iBF3BQ;EAAA,uBGo7C0B;EAAA,qCACA;EAAA;AC5rDhC;;AAAA;EFwSF,SACE;EAAA;AFlCM;;AAAA;EE6CV;AACE;;AAAA;EAMF;AAEE;;AAAA;EAQF,mBACE;EAAA;AACA;;AAAA;EAGF,iBC6X8B;EAAA,oBAAA;EAAA,+BAkCA;EAAA;AD3Z5B;;AAAA;EAOF,kBAEE;EAAA;AACA;;AAAA;EAGF,oBAME;EAAA,kBACA;EAAA;AACA;;AAAA;EAQF;AACE;;AAAA;EAMF;AAEE;;AAAA;EAQF;AACE;;AAAA;EAKF,QAKE;EAAA,mBACA;EAAA,iBFjIQ;EAAA;AEmIR;;AAAA;EAIF;AAEE;;AAAA;EAKF;AACE;;AAAA;EAGF;AAGE;;AAAA;EAGA;AACE;;AAAA;EAOJ;AACE;;AAAA;EAQF;AAIE;;AAAA;EAGE;AACE;;AAAA;EAON,SACE;EAAA;AACA;;AAAA;EAKF;AACE;;AAAA;EAUF,WACE;EAAA,SACA;EAAA,QACA;EAAA;AACA;;AAAA;EAQF,UACE;EAAA,UACA;EAAA,SACA;EAAA,mBCoN4B;EAAA,gCHpatB;EAAA;AEoNN;;AAAA;EFhXE;IEyWJ;EFtMQ;AAAA;;AAAA;EE+MN;AACE;;AAAA;EAOJ;AAOE;;AAAA;EAGF;AACE;;AAAA;EASF,4BACE;EAAA;AACA;;AAAA;EAmBF;AACE;;AAAA;EAKF;AACE;;AAAA;EAOF,YACE;EAAA;AACA;;AAAA;EAKF;AACE;;AAAA;EAKF;AACE;;AAAA;EAOF,iBACE;EAAA;AACA;;AAAA;EAQF;AACE;;AAAA;EAQF;AACE;;AAAA;EGrkBF,iBL8PU;EAAA;AG4YoB;;AAAA;EEnoB5B,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EKvQN,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EKvQN,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EKvQN,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EKvQN,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EKvQN,gCLgQM;EAAA,eG6Xc;EAAA;AAhBQ;;AAAA;EHzgB1B;IKpGF;ELuQM;AAAA;;AAAA;EK/OR,cCvDE;EAAA;AACA;;AAAA;ED2DF,cC5DE;EAAA;AACA;;AAAA;ED8DF;AACE;;AAAA;EAEA;AFuoB4B;;AAAA;EE5nB9B,iBLyMU;EAAA;AKvMR;;AAAA;EAIF,kBFkUS;EAAA;AH/HC;;AAAA;EK/LR;AACE;;AAAA;EAIJ,gBACE;EAAA,kBFwTO;EAAA,iBH/HC;EAAA;AG5QC;;AAAA;EEwFT;AACE;;AAAA;EEhGJ,cCIE;EAAA;AAGA;;AAAA;EDDF,cJ8jDoC;EAAA,kCACA;EAAA,0DI5jDlC;EAAA,qCHGE;EAAA,cIRF;EAAA;AAGA;;AAAA;EDcF;AAEE;;AAAA;EAGF,mBACE;EAAA;AACA;;AAAA;EAGF,iBPoPU;EAAA;AG8zC0B;;AAAA;EMllDlC,qBCHA;EAAA,gBACA;EAAA,UACA;EAAA,yCACA;EAAA,wCACA;EAAA,iBACA;EAAA;AACA;;AAAA;ECsDE;IF5CE;ENmeiB;AAAA;;AAAA;EQvbnB;IF5CE;ENmeiB;AAAA;;AAAA;EQvbnB;IF5CE;ENmeiB;AAAA;;AAAA;EQvbnB;IF5CE;ENmeiB;AAAA;;AAAA;EQvbnB;IF5CE;ENmeiB;AAAA;;AAAA;ESlfvB,qBAEI;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA;AAAA;;AAAA;EAKF,qBCNA;EAAA,gBACA;EAAA,YACA;EAAA,cACA;EAAA,sCAEA;EAAA,0CACA;EAAA;AACA;;AAAA;EDEE,aCOF;EAAA,UACA;EAAA,cACA;EAAA,yCACA;EAAA,wCACA;EAAA;AACA;;AAAA;EA+CI;AACE;;AAAA;EAGF,aApCJ;EAAA;AACA;;AAAA;EAcA,aACE;EAAA;AACA;;AAAA;EAFF,aACE;EAAA;AACA;;AAAA;EAFF,aACE;EAAA;AACA;;AAAA;EAFF,aACE;EAAA;AACA;;AAAA;EAFF,aACE;EAAA;AACA;;AAAA;EAFF,aACE;EAAA;AACA;;AAAA;EA+BE,aAhDJ;EAAA;AACA;;AAAA;EAqDQ,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EA+DM,aAhEN;EAAA;AACA;;AAAA;EAuEQ;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAwDU;AAxDV;;AAAA;EAmEM;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAPF;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAPF;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAPF;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAPF;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAPF;AAEE;;AAAA;EAGF;AAEE;;AAAA;EF1DN;IEUE;EACE;;EAAA;IAGF,aApCJ;IAAA;EACA;;EAAA;IAcA,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IA+BE,aAhDJ;IAAA;EACA;;EAAA;IAqDQ,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IAuEQ;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAmEM;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;AAAA;;AAAA;EF1DN;IEUE;EACE;;EAAA;IAGF,aApCJ;IAAA;EACA;;EAAA;IAcA,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IA+BE,aAhDJ;IAAA;EACA;;EAAA;IAqDQ,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IAuEQ;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAmEM;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;AAAA;;AAAA;EF1DN;IEUE;EACE;;EAAA;IAGF,aApCJ;IAAA;EACA;;EAAA;IAcA,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IA+BE,aAhDJ;IAAA;EACA;;EAAA;IAqDQ,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IAuEQ;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAmEM;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;AAAA;;AAAA;EF1DN;IEUE;EACE;;EAAA;IAGF,aApCJ;IAAA;EACA;;EAAA;IAcA,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IA+BE,aAhDJ;IAAA;EACA;;EAAA;IAqDQ,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IAuEQ;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAmEM;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;AAAA;;AAAA;EF1DN;IEUE;EACE;;EAAA;IAGF,aApCJ;IAAA;EACA;;EAAA;IAcA,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IAFF,aACE;IAAA;EACA;;EAAA;IA+BE,aAhDJ;IAAA;EACA;;EAAA;IAqDQ,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IA+DM,aAhEN;IAAA;EACA;;EAAA;IAuEQ;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAwDU;EAxDV;;EAAA;IAmEM;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;;EAAA;IAPF;EAEE;;EAAA;IAGF;EAEE;AAAA;;AAAA;ECrHV,8BAEE;EAAA,2BACA;EAAA,+BACA;EAAA,4BACA;EAAA,0CAEA;EAAA,gCACA;EAAA,+CACA;EAAA,iCACA;EAAA,kDACA;EAAA,+DACA;EAAA,iDACA;EAAA,6DACA;EAAA,gDACA;EAAA,8DACA;EAAA,UAEA;EAAA,kBXmYO;EAAA,kBAsUqB;EAAA;AWtsB5B;;AAAA;EAOA,mBACE;EAAA,oFAEA;EAAA,mCACA;EAAA,0CXgtB0B;EAAA;AW9sB1B;;AAAA;EAGF;AACE;;AAAA;EAGF;AACE;;AAAA;EAIJ;AACE;;AAAA;EAOF;AACE;;AAAA;EAUA;AACE;;AAAA;EAeF;AACE;;AAAA;EAGA;AACE;;AAAA;EAOJ;AACE;;AAAA;EAGF;AACE;;AAAA;EAUF,oDACE;EAAA;AACA;;AAAA;EAMF,oDACE;EAAA;AACA;;AAAA;EAQJ,oDACE;EAAA;AACA;;AAAA;EAQA,mDACE;EAAA;AACA;;AAAA;EC5IF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EAlBF,sBAOE;EAAA,sBACA;EAAA,gCACA;EAAA,8BACA;EAAA,8BACA;EAAA,6BACA;EAAA,6BACA;EAAA,4BACA;EAAA,4BACA;EAAA,2BAEA;EAAA;AACA;;AAAA;EDiJA,eACE;EAAA;AACA;;AAAA;EH3FF;IGyFA,eACE;IAAA;EACA;AAAA;;AAAA;EH3FF;IGyFA,eACE;IAAA;EACA;AAAA;;AAAA;EH3FF;IGyFA,eACE;IAAA;EACA;AAAA;;AAAA;EH3FF;IGyFA,eACE;IAAA;EACA;AAAA;;AAAA;EH3FF;IGyFA,eACE;IAAA;EACA;AAAA;;AAAA;EEnKN,2BAEE;EAAA,4BACA;EAAA,sBACA;EAAA,uBhBkRQ;EAAA,yBgBhRR;EAAA,yBACA;EAAA,oCACA;EAAA,wBACA;EAAA,6CACA;EAAA,kCACA;EAAA,+CACA;EAAA,wCACA;EAAA,4FACA;EAAA,+BACA;EAAA,iFACA;EAAA,oBAGA;EAAA,uDACA;EAAA,qCACA;EAAA,iChBiQQ;EAAA,qCgB/PR;EAAA,qCACA;EAAA,yBACA;EAAA,iBACA;EAAA,oBACA;EAAA,qBAEA;EAAA,cACA;EAAA,gBACA;EAAA,kEACA;EAAA,yCZjBE;EAAA,iCYmBmB;EAAA;AAErB;;AAAA;ECpBI;IDhBN;ECiBQ;AAAA;;AAAA;EDqBN,+BACE;EAAA,uCAEA;EAAA;AACA;;AAAA;EAGF,yBAEE;EAAA,iCACA;EAAA;AACA;;AAAA;EAGF,+BACE;EAAA,uCACqB;EAAA,6CACrB;EAAA,SACA;EAAA;AAKE;;AAAA;EAIJ,6CACE;EAAA,SACA;EAAA;AAKE;;AAAA;EAIJ,gCAKE;EAAA,wCACA;EAAA;AAGA;;AAAA;EAGA;AAKI;;AAAA;EAKN,kCAGE;EAAA,mBACA;EAAA,0CACA;EAAA,gDAEA;EAAA;AACA;;AAAA;EAYF,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,uCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,wCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,uCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,uCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,sCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,sCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,wCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,qCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFyFA,oBEtGA;EAAA,oBACA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,qCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,6BACA;EAAA,6BACA;EAAA;AACA;;AAAA;EFmHA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,uCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,wCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,sCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,uCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,sCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,sCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,wCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,qCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EF0FA,uBEvGA;EAAA,8BACA;EAAA,0BACA;EAAA,0BACA;EAAA,oCACA;EAAA,qCACA;EAAA,2BACA;EAAA,2BACA;EAAA,qCACA;EAAA,4DACA;EAAA,gCACA;EAAA,iCACA;EAAA,uCACA;EAAA;AACA;;AAAA;EFsGF,yBACE;EAAA,oCACA;EAAA,wBACA;EAAA,kCACA;EAAA,gDACA;EAAA,wCACA;EAAA,iDACA;EAAA,yCACA;EAAA,gCACA;EAAA,2CACA;EAAA,+BACA;EAAA,uCACA;EAAA;AbyRwC;;AAAA;Ea7QxC;AACE;;AAAA;EAGF;AACE;;AAAA;EAWJ,0BExIE;EAAA,wBACA;EAAA,0BlByNQ;EAAA;AkBvNR;;AAAA;EFyIF,2BE5IE;EAAA,0BACA;EAAA,2BlByNQ;EAAA;AkBvNR;;AAAA;ECnEF;AACE;;AAAA;EFmBI;IEpBN;EFqBQ;AAAA;;AAAA;EElBN;AACE;;AAAA;EAMF;AACE;;AAAA;EAIJ,QACE;EAAA,eACA;EAAA;AACA;;AAAA;EFEI;IELN;EFMQ;AAAA;;AAAA;EEDN,OACE;EAAA,WACA;EAAA;AACA;;AAAA;EFHE;IAAA;EACE;AAAA;;AAAA;EGpBR,iBAEE;EAAA,mBACA;EAAA;AACA;;AAAA;EAEA,iBACE;EAAA;AACA;;AAAA;EAKF;AAME;;AAAA;EAKJ,YACE;EAAA,cACA;EAAA;AACA;;AAAA;EAEA;AACE;;AAAA;EAIJ;AhBhBI;;AAAA;EgBoBF;AAEE;;AAAA;EAIF,yBhBVE;EAAA;AACA;;AAAA;EgBmBF,wBhBNE;EAAA;AACA;;AAAA;EgBwBJ,sBACE;EAAA;AACA;;AAAA;EAEA;AAGE;;AAAA;EAGF;AACE;;AAAA;EAIJ,qBACE;EAAA;AACA;;AAAA;EAGF,oBACE;EAAA;AACA;;AAAA;EAoBF,qBACE;EAAA,sBACA;EAAA;AACA;;AAAA;EAEA;AAEE;;AAAA;EAGF;AAEE;;AAAA;EAIF,4BhB1FE;EAAA;AACA;;AAAA;EgB8FF,wBhB7GE;EAAA;AACA;;AAAA;EiBxBJ,6BAEE;EAAA,+BACA;EAAA,2BAEA;EAAA,yCACA;EAAA,qDACA;EAAA,uDACA;EAAA,YAGA;EAAA,cACA;EAAA,cACA;EAAA,eACA;EAAA;AACA;;AAAA;EAGF,aACE;EAAA,iEACA;EAAA,sCrBiQQ;EAAA,0CqB/PR;EAAA,8BACA;EAAA,oBACA;EAAA,eACA;EAAA,QACA;EAAA;AACA;;AAAA;EJZI;IIGN;EJFQ;AAAA;;AAAA;EIaN;AAEE;;AAAA;EAIF,SACE;EAAA;AlBmhBoB;;AAAA;EkB9gBtB,uCAEE;EAAA,mBACA;EAAA;AACA;;AAAA;EAQJ,kDAEE;EAAA,kDACA;EAAA,oDACA;EAAA,2GACA;EAAA,yDACA;EAAA,+CACA;EAAA,uGACA;EAAA;AAGA;;AAAA;EAEA,sDACE;EAAA,0DACA;EAAA,uDjB7CA;EAAA;AACA;;AAAA;EiB+CA,iBAGE;EAAA;AACA;;AAAA;EAIJ,0CAEE;EAAA,kDACA;EAAA;AACA;;AAAA;EAGF,mDAEE;EAAA,wBjBjEA;EAAA;AACA;;AAAA;EiB2EJ,qDAEE;EAAA,sCACA;EAAA;AACA;;AAAA;EAGA;AjB5FE;;AAAA;EiBgGF,2CAEE;EAAA;AACqB;;AAAA;EASzB,4BAEE;EAAA,yCACA;EAAA,8DACA;EAAA;AAGA;;AAAA;EAEA,eACE;EAAA,cACA;EAAA;AACA;;AAAA;EAEA;AAEE;;AAAA;EAIJ,elB4d4B;EAAA,+CkBzd1B;EAAA;AACA;;AAAA;EAUF,aAEE;EAAA;AACA;;AAAA;EAKF,YAEE;EAAA,WACA;EAAA;AACA;;AAAA;EAMF;AACE;;AAAA;EAUF;AACE;;AAAA;EAEF;AACE;;AAAA;EC7LJ,wBAEE;EAAA,6BACA;EAAA,2DACA;EAAA,gEACA;EAAA,mEACA;EAAA,+DACA;EAAA,sCACA;EAAA,kCACA;EAAA,oCACA;EAAA,8DACA;EAAA,oEACA;EAAA,sCACA;EAAA,sCACA;EAAA,sCACA;EAAA,sCACA;EAAA,oEACA;EAAA,0EACA;EAAA,0DACA;EAAA,wCACA;EAAA,4DACA;EAAA,iBAGA;EAAA,YACA;EAAA,cACA;EAAA,kBACA;EAAA,6BACA;EAAA;AACA;;AAAA;EAMA,YACE;EAAA,iBACA;EAAA,kBACA;EAAA;AACA;;AAAA;EAoBJ,4CACE;EAAA,+CACA;EAAA,8CACA;EAAA,0CtBuNQ;EAAA,kCsBrNR;EAAA,oBACA;EAAA;AACA;;AAAA;EAEA;AAEE;;AAAA;EAUJ,0BAEE;EAAA,+BACA;EAAA,2BAEA;EAAA,2CACA;EAAA,uDACA;EAAA,6DACA;EAAA,YAGA;EAAA,qBACA;EAAA,cACA;EAAA,eACA;EAAA;AACA;;AAAA;EAGE;AAEE;;AAAA;EAIJ;AACE;;AAAA;EASJ,iBnB+gCoC;EAAA,oBAAA;EAAA;AmB5gClC;;AAAA;EAEA;AAGE;;AAAA;EAaJ,eACE;EAAA,WACA;EAAA;AAGA;;AAAA;EAIF,6EACE;EAAA,4CtBoIQ;EAAA,asBlIR;EAAA,4BACA;EAAA,8BACA;EAAA,yEACA;EAAA,oDlBxIE;EAAA;AkB0IF;;AAAA;ELzII;IKiIN;ELhIQ;AAAA;;AAAA;EK0IN;AACE;;AAAA;EAGF,oBACE;EAAA,SACA;EAAA;AACA;;AAAA;EAMJ,oBACE;EAAA,WACA;EAAA,YACA;EAAA,qBACA;EAAA,iDACA;EAAA,2BACA;EAAA,0BACA;EAAA;AACA;;AAAA;EAGF,wCACE;EAAA;AACA;;AAAA;EX1HE;IWsIA,gBAEI;IAAA;EACA;;EAAA;IAEA;EACE;;EAAA;IAEA;EACE;;EAAA;IAGF,iDACE;IAAA;EACA;;EAAA;IAIJ;EACE;;EAAA;IAGF,uBACE;IAAA;EACA;;EAAA;IAGF;EACE;;EAAA;IAGF,eAEE;IAAA,YACA;IAAA,WACA;IAAA,qBACA;IAAA,sBACA;IAAA,6BACA;IAAA,yCACA;IAAA,mBACA;IAAA,yBACA;IAAA;EAEA;;EAAA;IAGA;EACE;;EAAA;IAGF,YACE;IAAA,WACA;IAAA,SACA;IAAA;EACA;AAAA;;AAAA;EX5LR;IWsIA,gBAEI;IAAA;EACA;;EAAA;IAEA;EACE;;EAAA;IAEA;EACE;;EAAA;IAGF,iDACE;IAAA;EACA;;EAAA;IAIJ;EACE;;EAAA;IAGF,uBACE;IAAA;EACA;;EAAA;IAGF;EACE;;EAAA;IAGF,eAEE;IAAA,YACA;IAAA,WACA;IAAA,qBACA;IAAA,sBACA;IAAA,6BACA;IAAA,yCACA;IAAA,mBACA;IAAA,yBACA;IAAA;EAEA;;EAAA;IAGA;EACE;;EAAA;IAGF,YACE;IAAA,WACA;IAAA,SACA;IAAA;EACA;AAAA;;AAAA;EX5LR;IWsIA,gBAEI;IAAA;EACA;;EAAA;IAEA;EACE;;EAAA;IAEA;EACE;;EAAA;IAGF,iDACE;IAAA;EACA;;EAAA;IAIJ;EACE;;EAAA;IAGF,uBACE;IAAA;EACA;;EAAA;IAGF;EACE;;EAAA;IAGF,eAEE;IAAA,YACA;IAAA,WACA;IAAA,qBACA;IAAA,sBACA;IAAA,6BACA;IAAA,yCACA;IAAA,mBACA;IAAA,yBACA;IAAA;EAEA;;EAAA;IAGA;EACE;;EAAA;IAGF,YACE;IAAA,WACA;IAAA,SACA;IAAA;EACA;AAAA;;AAAA;EX5LR;IWsIA,gBAEI;IAAA;EACA;;EAAA;IAEA;EACE;;EAAA;IAEA;EACE;;EAAA;IAGF,iDACE;IAAA;EACA;;EAAA;IAIJ;EACE;;EAAA;IAGF,uBACE;IAAA;EACA;;EAAA;IAGF;EACE;;EAAA;IAGF,eAEE;IAAA,YACA;IAAA,WACA;IAAA,qBACA;IAAA,sBACA;IAAA,6BACA;IAAA,yCACA;IAAA,mBACA;IAAA,yBACA;IAAA;EAEA;;EAAA;IAGA;EACE;;EAAA;IAGF,YACE;IAAA,WACA;IAAA,SACA;IAAA;EACA;AAAA;;AAAA;EX5LR;IWsIA,gBAEI;IAAA;EACA;;EAAA;IAEA;EACE;;EAAA;IAEA;EACE;;EAAA;IAGF,iDACE;IAAA;EACA;;EAAA;IAIJ;EACE;;EAAA;IAGF,uBACE;IAAA;EACA;;EAAA;IAGF;EACE;;EAAA;IAGF,eAEE;IAAA,YACA;IAAA,WACA;IAAA,qBACA;IAAA,sBACA;IAAA,6BACA;IAAA,yCACA;IAAA,mBACA;IAAA,yBACA;IAAA;EAEA;;EAAA;IAGA;EACE;;EAAA;IAGF,YACE;IAAA,WACA;IAAA,SACA;IAAA;EACA;AAAA;;AAAA;EAtDR,gBAEI;EAAA;AACA;;AAAA;EAEA;AACE;;AAAA;EAEA;AACE;;AAAA;EAGF,iDACE;EAAA;AACA;;AAAA;EAIJ;AACE;;AAAA;EAGF,uBACE;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAGF,eAEE;EAAA,YACA;EAAA,WACA;EAAA,qBACA;EAAA,sBACA;EAAA,6BACA;EAAA,yCACA;EAAA,mBACA;EAAA,yBACA;EAAA;AAEA;;AAAA;EAGA;AACE;;AAAA;EAGF,YACE;EAAA,WACA;EAAA,SACA;EAAA;AACA;;AAAA;EAiBZ,4CAGE;EAAA,kDACA;EAAA,qDACA;EAAA,8BACA;EAAA,6BACA;EAAA,mCACA;EAAA,0DACA;EAAA;AACA;;AAAA;EAME;AACE;;AAAA;ECzRN,wBAEE;EAAA,wBACA;EAAA,gCACA;EAAA,uBACA;EAAA,0BACA;EAAA,8CACA;EAAA,0DACA;EAAA,gDACA;EAAA,sBACA;EAAA,uFACA;EAAA,+BACA;EAAA,6BACA;EAAA,sDACA;EAAA,qBACA;EAAA,kBACA;EAAA,iBACA;EAAA,+BACA;EAAA,mCACA;EAAA,+BACA;EAAA,iBAGA;EAAA,YACA;EAAA,qBACA;EAAA,WACA;EAAA,4BACA;EAAA,0BACA;EAAA,oBACA;EAAA,kCACA;EAAA,0BACA;EAAA,oEACA;EAAA;AnBjBE;;AAAA;EmBqBF,cACE;EAAA;AACA;;AAAA;EAGF,kBACE;EAAA;AACA;;AAAA;EAEA,kBACE;EAAA,yDnBtBF;EAAA;AACA;;AAAA;EmByBA,qBACE;EAAA,6DnBbF;EAAA;AACA;;AAAA;EmBmBF;AAEE;;AAAA;EAIJ,aAGE;EAAA,uDACA;EAAA;AACA;;AAAA;EAGF,2CACE;EAAA;AACA;;AAAA;EAGF,mDACE;EAAA,eACA;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAQA;AACE;;AAAA;EAQJ,iEACE;EAAA,eACA;EAAA,8BACA;EAAA,sCACA;EAAA;AACA;;AAAA;EAEA;AnB7FE;;AAAA;EmBkGJ,iEACE;EAAA,8BACA;EAAA,sCACA;EAAA;AACA;;AAAA;EAEA;AnBxGE;;AAAA;EmBkHJ,oDACE;EAAA,mDACA;EAAA,mDACA;EAAA;AACA;;AAAA;EAEA,kCACE;EAAA;AACA;;AAAA;EAIJ,oDACE;EAAA;AACA;;AAAA;EAIF,iBACE;EAAA,KACA;EAAA,OACA;EAAA,QACA;EAAA,MACA;EAAA,0CACA;EAAA;AnB1IE;;AAAA;EmB8IJ;AAGE;;AAAA;EAGF,yDnB3II;EAAA;AACA;;AAAA;EmB+IJ,6DnBlII;EAAA;AACA;;AAAA;EmB8IF;AACE;;AAAA;EZ3HA;IYuHJ,YAQI;IAAA;EACA;;EAAA;IAGA,WAEE;IAAA;EACA;;EAAA;IAEA,aACE;IAAA;EACA;;EAAA;IAKA,yBnB3KJ;IAAA;EACA;;EAAA;ImB6KM;EAGE;;EAAA;IAEF;EAGE;;EAAA;IAIJ,wBnB5KJ;IAAA;EACA;;EAAA;ImB8KM;EAGE;;EAAA;IAEF;EAGE;AAAA;;AAAA;ECnOZ,4BAEE;EAAA,4BACA;EAAA,2BxBkRQ;EAAA,2BwBhRR;EAAA,sBACA;EAAA,iDACA;EAAA,oBAGA;EAAA,2DACA;EAAA,mCxB0QQ;EAAA,uCwBxQR;EAAA,aACA;EAAA,2BACA;EAAA,iBACA;EAAA,kBACA;EAAA,uBACA;EAAA;ApBJE;;AAAA;EoBSF;AACE;;AAAA;EAKJ,iBACE;EAAA;AACA;;AAAA;EChCF,0BAEE;EAAA,0BACA;EAAA,0BACA;EAAA,8BACA;EAAA,yBACA;EAAA,oCACA;EAAA,4EACA;EAAA,iDACA;EAAA,8BACA;EAAA,iBAGA;EAAA,2DACA;EAAA,2CACA;EAAA,2BACA;EAAA,mCACA;EAAA,6BACA;EAAA;ArBHE;;AAAA;EqBQJ;AAEE;;AAAA;EAIF,etB8kB8B;EAAA;AsB5kB5B;;AAAA;EAQF;AtBq+CgC;;AAAA;EsBj+C9B,iBACE;EAAA,KACA;EAAA,OACA;EAAA,SACA;EAAA;AACA;;AAAA;EAQF,iDACE;EAAA,0CACA;EAAA,wDACA;EAAA;AACA;;AAAA;EAJF,mDACE;EAAA,4CACA;EAAA,0DACA;EAAA;AACA;;AAAA;EAJF,iDACE;EAAA,0CACA;EAAA,wDACA;EAAA;AACA;;AAAA;EAJF,8CACE;EAAA,uCACA;EAAA,qDACA;EAAA;AACA;;AAAA;EAJF,iDACE;EAAA,0CACA;EAAA,wDACA;EAAA;AACA;;AAAA;EAJF,gDACE;EAAA,yCACA;EAAA,uDACA;EAAA;AACA;;AAAA;EAJF,+CACE;EAAA,wCACA;EAAA,sDACA;EAAA;AACA;;AAAA;EAJF,8CACE;EAAA,uCACA;EAAA,qDACA;EAAA;AACA;;AAAA;EAJF,sDACE;EAAA,+CACA;EAAA,6DACA;EAAA;AACA;;AAAA;EC5DJ,2CAEE;EAAA,qCACA;EAAA,oDACA;EAAA,oDACA;EAAA,sDACA;EAAA,oCACA;EAAA,sCACA;EAAA,uDACA;EAAA,4DACA;EAAA,sDACA;EAAA,yDACA;EAAA,wDACA;EAAA,yDACA;EAAA,8CACA;EAAA,kCACA;EAAA,kCACA;EAAA,4CACA;EAAA,YAGA;EAAA,qBACA;EAAA,cAGA;EAAA,eACA;EAAA;AtBXE;;AAAA;EsBeJ,oBACE;EAAA;AACA;;AAAA;EAEA,mCAEE;EAAA;AACA;;AAAA;EASJ,UACE;EAAA,uCACA;EAAA;AACA;;AAAA;EAGA,SAEE;EAAA,6CACA;EAAA,oBACA;EAAA;AACA;;AAAA;EAGF,8CACE;EAAA;AACA;;AAAA;EAQJ,iBACE;EAAA,aACA;EAAA,+EACA;EAAA,gCACA;EAAA,oBACA;EAAA,wCACA;EAAA;AACA;;AAAA;EAEA,8BtBvDE;EAAA;AACA;;AAAA;EsB0DF,kCtB7CE;EAAA;AACA;;AAAA;EsBgDF,yCAEE;EAAA,mBACA;EAAA;AACA;;AAAA;EAIF,SACE;EAAA,uCACA;EAAA,+CACA;EAAA;AACA;;AAAA;EAIF;AACE;;AAAA;EAEA,qDACE;EAAA;AACA;;AAAA;EAaF;AACE;;AAAA;EAGE,4DtBvDJ;EAAA;AAZA;;AAAA;EsBwEI,0DtBxEJ;EAAA;AAYA;;AAAA;EsBiEI;AACE;;AAAA;EAGF,kDACE;EAAA;AACA;;AAAA;EAEA,sDACE;EAAA;AACA;;AAAA;EftFR;Ie8DA;EACE;;EAAA;IAGE,4DtBvDJ;IAAA;EAZA;;EAAA;IsBwEI,0DtBxEJ;IAAA;EAYA;;EAAA;IsBiEI;EACE;;EAAA;IAGF,kDACE;IAAA;EACA;;EAAA;IAEA,sDACE;IAAA;EACA;AAAA;;AAAA;EftFR;Ie8DA;EACE;;EAAA;IAGE,4DtBvDJ;IAAA;EAZA;;EAAA;IsBwEI,0DtBxEJ;IAAA;EAYA;;EAAA;IsBiEI;EACE;;EAAA;IAGF,kDACE;IAAA;EACA;;EAAA;IAEA,sDACE;IAAA;EACA;AAAA;;AAAA;EftFR;Ie8DA;EACE;;EAAA;IAGE,4DtBvDJ;IAAA;EAZA;;EAAA;IsBwEI,0DtBxEJ;IAAA;EAYA;;EAAA;IsBiEI;EACE;;EAAA;IAGF,kDACE;IAAA;EACA;;EAAA;IAEA,sDACE;IAAA;EACA;AAAA;;AAAA;EftFR;Ie8DA;EACE;;EAAA;IAGE,4DtBvDJ;IAAA;EAZA;;EAAA;IsBwEI,0DtBxEJ;IAAA;EAYA;;EAAA;IsBiEI;EACE;;EAAA;IAGF,kDACE;IAAA;EACA;;EAAA;IAEA,sDACE;IAAA;EACA;AAAA;;AAAA;EftFR;Ie8DA;EACE;;EAAA;IAGE,4DtBvDJ;IAAA;EAZA;;EAAA;IsBwEI,0DtBxEJ;IAAA;EAYA;;EAAA;IsBiEI;EACE;;EAAA;IAGF,kDACE;IAAA;EACA;;EAAA;IAEA,sDACE;IAAA;EACA;AAAA;;AAAA;EAcZ;AtBhJI;;AAAA;EsBmJF;AACE;;AAAA;EAEA;AACE;;AAAA;EAaJ,sDACE;EAAA,+CACA;EAAA,6DACA;EAAA,4DACA;EAAA,gEACA;EAAA,6DACA;EAAA,iEACA;EAAA,yDACA;EAAA,0DACA;EAAA;AACA;;AAAA;EAVF,wDACE;EAAA,iDACA;EAAA,+DACA;EAAA,4DACA;EAAA,kEACA;EAAA,6DACA;EAAA,mEACA;EAAA,2DACA;EAAA,4DACA;EAAA;AACA;;AAAA;EAVF,sDACE;EAAA,+CACA;EAAA,6DACA;EAAA,4DACA;EAAA,gEACA;EAAA,6DACA;EAAA,iEACA;EAAA,yDACA;EAAA,0DACA;EAAA;AACA;;AAAA;EAVF,mDACE;EAAA,4CACA;EAAA,0DACA;EAAA,4DACA;EAAA,6DACA;EAAA,6DACA;EAAA,8DACA;EAAA,sDACA;EAAA,uDACA;EAAA;AACA;;AAAA;EAVF,sDACE;EAAA,+CACA;EAAA,6DACA;EAAA,4DACA;EAAA,gEACA;EAAA,6DACA;EAAA,iEACA;EAAA,yDACA;EAAA,0DACA;EAAA;AACA;;AAAA;EAVF,qDACE;EAAA,8CACA;EAAA,4DACA;EAAA,4DACA;EAAA,+DACA;EAAA,6DACA;EAAA,gEACA;EAAA,wDACA;EAAA,yDACA;EAAA;AACA;;AAAA;EAVF,oDACE;EAAA,6CACA;EAAA,2DACA;EAAA,4DACA;EAAA,8DACA;EAAA,6DACA;EAAA,+DACA;EAAA,uDACA;EAAA,wDACA;EAAA;AACA;;AAAA;EAVF,mDACE;EAAA,4CACA;EAAA,0DACA;EAAA,4DACA;EAAA,6DACA;EAAA,6DACA;EAAA,8DACA;EAAA,sDACA;EAAA,uDACA;EAAA;AACA;;AAAA;EAVF,2DACE;EAAA,oDACA;EAAA,kEACA;EAAA,4DACA;EAAA,qEACA;EAAA,6DACA;EAAA,sEACA;EAAA,8DACA;EAAA,+DACA;EAAA;AACA;;AAAA;EC5LJ,0BAEE;EAAA,0DACA;EAAA,2BACA;EAAA,kCACA;EAAA,mEACA;EAAA,+BACA;EAAA,qCACA;EAAA,uEACA;EAAA,sBAGA;EAAA,SxBopD2B;EAAA,UAAA;EAAA,mBwBjpD3B;EAAA,+BACA;EAAA,yEACA;EAAA,QACA;EAAA,qBvBJE;EAAA;AuBMF;;AAAA;EAGA,+BACE;EAAA,oBACA;EAAA;AACA;;AAAA;EAGF,SACE;EAAA,2CACA;EAAA;AACA;;AAAA;EAGF,mBAEE;EAAA,gBACA;EAAA;AACA;;AAAA;EAQJ;AAHE;;AAAA;EASE;AATF;;AAAA;ECxCF,uBAEE;EAAA,uBACA;EAAA,wBACA;EAAA,yBACA;EAAA,kBACA;EAAA,gCACA;EAAA,2DACA;EAAA,+CACA;EAAA,oDACA;EAAA,8CACA;EAAA,2FACA;EAAA,iCACA;EAAA,iCACA;EAAA,oCACA;EAAA,sDACA;EAAA,sDACA;EAAA,iCACA;EAAA,6BACA;EAAA,sBACA;EAAA,sDACA;EAAA,sDACA;EAAA,cAGA;EAAA,KACA;EAAA,MACA;EAAA,8BACA;EAAA,YACA;EAAA,UACA;EAAA,WACA;EAAA,iBACA;EAAA,eACA;EAAA;AAGA;;AAAA;EAOF,iBACE;EAAA,UACA;EAAA,6BACA;EAAA;AAEA;;AAAA;EAGA,iCACE;EAAA;AzBi8CgC;;AAAA;Ec1+C9B;IWwCJ;EXvCM;AAAA;;AAAA;EW2CN;AzB+7CkC;;AAAA;EyB17ClC;AzB47CkC;;AAAA;EyBv7CpC;AACE;;AAAA;EAEA,eACE;EAAA;AACA;;AAAA;EAGF;AACE;;AAAA;EAIJ,YACE;EAAA,kBACA;EAAA;AACA;;AAAA;EAIF,iBACE;EAAA,YACA;EAAA,qBACA;EAAA,UACA;EAAA,2BAEA;EAAA,mBACA;EAAA,mCACA;EAAA,2BACA;EAAA,sEACA;EAAA,2CxBrFE;EAAA;AwByFF;;AAAA;EAIF,0BAEE;EAAA,sBACA;EAAA,0BACA;EAAA,cClHA;EAAA,KACA;EAAA,MACA;EAAA,iCDmH0B;EAAA,WCjH1B;EAAA,YACA;EAAA;ADgH4D;;AAAA;EC5G5D;AAAA;;AAAA;EACA;AD2G0F;;AAAA;EAK5F,YACE;EAAA,aACA;EAAA,kBACA;EAAA,6BACA;EAAA,sCACA;EAAA,2FACA;EAAA,0DxBtGE;EAAA;AACA;;AAAA;EwBwGF,2FACE;EAAA;AACA;;AAAA;EAKJ,eACE;EAAA;AACA;;AAAA;EAKF,iBACE;EAAA,aAGA;EAAA;AACA;;AAAA;EAIF,YACE;EAAA,aACA;EAAA,cACA;EAAA,kBACA;EAAA,wBACA;EAAA,qEACA;EAAA,0CACA;EAAA,wFACA;EAAA,8DxB1HE;EAAA;AACA;;AAAA;EwB+HF;AACE;;AAAA;EjB5GA;IiBkHF,0BACE;IAAA;EACA;;EAAA;IAIF,+BACE;IAAA,iBACA;IAAA;EACA;;EAAA;IAGF;EACE;AAAA;;AAAA;EjB/HA;IiBoIF;EAEE;AAAA;;AAAA;EjBtIA;IiB2IF;EACE;AAAA;;AAAA;EAUA,WACE;EAAA,cACA;EAAA,WACA;EAAA;AACA;;AAAA;EAEA,WACE;EAAA,QACA;EAAA;AxB1MJ;;AAAA;EwB8ME;AxB9MF;;AAAA;EwBmNE;AACE;;AAAA;EjB3JJ;IiByIA,WACE;IAAA,cACA;IAAA,WACA;IAAA;EACA;;EAAA;IAEA,WACE;IAAA,QACA;IAAA;ExB1MJ;;EAAA;IwB8ME;ExB9MF;;EAAA;IwBmNE;EACE;AAAA;;AAAA;EjB3JJ;IiByIA,WACE;IAAA,cACA;IAAA,WACA;IAAA;EACA;;EAAA;IAEA,WACE;IAAA,QACA;IAAA;ExB1MJ;;EAAA;IwB8ME;ExB9MF;;EAAA;IwBmNE;EACE;AAAA;;AAAA;EjB3JJ;IiByIA,WACE;IAAA,cACA;IAAA,WACA;IAAA;EACA;;EAAA;IAEA,WACE;IAAA,QACA;IAAA;ExB1MJ;;EAAA;IwB8ME;ExB9MF;;EAAA;IwBmNE;EACE;AAAA;;AAAA;EjB3JJ;IiByIA,WACE;IAAA,cACA;IAAA,WACA;IAAA;EACA;;EAAA;IAEA,WACE;IAAA,QACA;IAAA;ExB1MJ;;EAAA;IwB8ME;ExB9MF;;EAAA;IwBmNE;EACE;AAAA;;AAAA;EjB3JJ;IiByIA,WACE;IAAA,cACA;IAAA,WACA;IAAA;EACA;;EAAA;IAEA,WACE;IAAA,QACA;IAAA;ExB1MJ;;EAAA;IwB8ME;ExB9MF;;EAAA;IwBmNE;EACE;AAAA;;AAAA;EEtOR,yBAEE;EAAA,6BACA;EAAA,8BACA;EAAA,+BACA;EAAA,qBACA;EAAA,+B9BmRQ;EAAA,qC8BjRR;EAAA,yCACA;EAAA,mDACA;EAAA,yBACA;EAAA,gCACA;EAAA,iCACA;EAAA,gCAGA;EAAA,aACA;EAAA,+BACA;EAAA,qC3B6kB4B;EAAA,iB4B7lB5B;EAAA,e5BymB4B;EAAA,eAQA;EAAA,e4B9mB5B;EAAA,gBACA;EAAA,oBACA;EAAA,gBACA;EAAA,mBACA;EAAA,qBACA;EAAA,iBACA;EAAA,kBACA;EAAA,mBACA;EAAA,eACA;EAAA,qC/B2QQ;EAAA,oB8BhQR;EAAA;AACA;;AAAA;EAEA;AAAA;;AAAA;EAEA,aACE;EAAA,mCACA;EAAA;AACA;;AAAA;EAEA,iBACE;EAAA,UACA;EAAA,0BACA;EAAA;AACA;;AAAA;EAKN;AACE;;AAAA;EAEA,QACE;EAAA,oFACA;EAAA;AACA;;AAAA;EAKJ,4CACE;EAAA,oCACA;EAAA;AACA;;AAAA;EAEA,UACE;EAAA,2HACA;EAAA;AACA;;AAAA;EAMJ;AACE;;AAAA;EAEA,WACE;EAAA,oFACA;EAAA;AACA;;AAAA;EAKJ,6CACE;EAAA,oCACA;EAAA;AACA;;AAAA;EAEA,SACE;EAAA,2HACA;EAAA;AACA;;AAAA;EAsBJ,qCACE;EAAA,+DACA;EAAA,6BACA;EAAA,iBACA;EAAA,qCACA;EAAA;A1BjGE;;AAAA;E4BjBF,aACE;EAAA,UACA;EAAA;AACA;;AAAA;ECHF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;EAFF,qBACE;EAAA;AACA;;AAAA;ECFF,uEACE;EAAA;AACA;;AAAA;EAGE,6DAGE;EAAA;AACA;;AAAA;EATN,yEACE;EAAA;AACA;;AAAA;EAGE,6DAGE;EAAA;AACA;;AAAA;EATN,uEACE;EAAA;AACA;;AAAA;EAGE,6DAGE;EAAA;AACA;;AAAA;EATN,oEACE;EAAA;AACA;;AAAA;EAGE,8DAGE;EAAA;AACA;;AAAA;EATN,uEACE;EAAA;AACA;;AAAA;EAGE,8DAGE;EAAA;AACA;;AAAA;EATN,sEACE;EAAA;AACA;;AAAA;EAGE,6DAGE;EAAA;AACA;;AAAA;EATN,qEACE;EAAA;AACA;;AAAA;EAGE,+DAGE;EAAA;AACA;;AAAA;EATN,oEACE;EAAA;AACA;;AAAA;EAGE,4DAGE;EAAA;AACA;;AAAA;EATN,4EACE;EAAA;AACA;;AAAA;EAGE,4DAGE;EAAA;AACA;;AAAA;EAOR,8EACE;EAAA;AACA;;AAAA;EAGE,iFAEE;EAAA;AACA;;AAAA;EC1BN,SACE;EAAA;AAEA;;AAAA;ECHF,mBACE;EAAA,WjC8c4B;EAAA,kBiC5c5B;EAAA,iFACA;EAAA,2BjC4c4B;EAAA;AiC1c5B;;AAAA;EAEA,aACE;EAAA,SjCwc0B;EAAA,UAAA;EAAA,iBiCrc1B;EAAA;AACA;;AAAA;EnBOE;ImBZJ;EnBaM;AAAA;;AAAA;EmBDJ;AACE;;AAAA;ECnBN,iBACE;EAAA;AACA;;AAAA;EAEA,aACE;EAAA,kCACA;EAAA;AACA;;AAAA;EAGF,iBACE;EAAA,KACA;EAAA,MACA;EAAA,UACA;EAAA;AACA;;AAAA;EAKF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;ECrBJ,cACE;EAAA,KACA;EAAA,OACA;EAAA,MACA;EAAA;AnCwmCkC;;AAAA;EmCpmCpC,cACE;EAAA,OACA;EAAA,QACA;EAAA,MACA;EAAA;AnCgmCkC;;AAAA;EmCvlChC,eACE;EAAA,KACA;EAAA;AnColC8B;;AAAA;EmChlChC,eACE;EAAA,QACA;EAAA;AnC8kC8B;;AAAA;EQ9iChC;I2BxCA,eACE;IAAA,KACA;IAAA;EnColC8B;;EAAA;ImChlChC,eACE;IAAA,QACA;IAAA;EnC8kC8B;AAAA;;AAAA;EQ9iChC;I2BxCA,eACE;IAAA,KACA;IAAA;EnColC8B;;EAAA;ImChlChC,eACE;IAAA,QACA;IAAA;EnC8kC8B;AAAA;;AAAA;EQ9iChC;I2BxCA,eACE;IAAA,KACA;IAAA;EnColC8B;;EAAA;ImChlChC,eACE;IAAA,QACA;IAAA;EnC8kC8B;AAAA;;AAAA;EQ9iChC;I2BxCA,eACE;IAAA,KACA;IAAA;EnColC8B;;EAAA;ImChlChC,eACE;IAAA,QACA;IAAA;EnC8kC8B;AAAA;;AAAA;EQ9iChC;I2BxCA,eACE;IAAA,KACA;IAAA;EnColC8B;;EAAA;ImChlChC,eACE;IAAA,QACA;IAAA;EnC8kC8B;AAAA;;AAAA;EoC5mCpC,YACE;EAAA,kBACA;EAAA,kBACA;EAAA;AACA;;AAAA;EAGF,YACE;EAAA,aACA;EAAA,qBACA;EAAA;AACA;;AAAA;ECRF,oBCIE;EAAA,qBACA;EAAA,oBACA;EAAA,sBACA;EAAA,0BACA;EAAA,gCACA;EAAA,6BACA;EAAA;AACA;;AAAA;EAGA;AACE;;AAAA;ECdF,iBACE;EAAA,KACA;EAAA,OACA;EAAA,QACA;EAAA,MACA;EAAA,SvCicsC;EAAA;AuC/btC;;AAAA;ECRJ,eAAA;EAAA,sBCCE;EAAA;AACA;;AAAA;ECNF,oBACE;EAAA,kBACA;EAAA,4B1CksB4B;EAAA,c0ChsB5B;EAAA,6BACA;EAAA;A1C4rB4B;;AAAA;E2C/nBtB;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAjBJ;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EASF;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ,sBAIQ;EAAA;AAGJ;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAjBJ;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EASF;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ,yBAOI;EAAA;AAAA;;AAAA;EAPJ,8BAOI;EAAA;AAAA;;AAAA;EAPJ,6BAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,8BAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,uBAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,2BAOI;EAAA;AAAA;;AAAA;EAPJ,0BAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,0BAOI;EAAA;AAAA;;AAAA;EAPJ,0BAOI;EAAA;AAAA;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ,0BAOI;EAAA;AAAA;;AAAA;EAPJ,+BAOI;EAAA;AAAA;;AAAA;EAPJ,8BAOI;EAAA;AAAA;;AAAA;EAPJ,6BAOI;EAAA;AAAA;;AAAA;EAPJ,+BAOI;EAAA;AAAA;;AAAA;EAPJ,6BAOI;EAAA;AAAA;;AAAA;EAPJ,wBAOI;EAAA;AAAA;;AAAA;EAPJ,6BAOI;EAAA;AAAA;;AAAA;EAPJ,4BAOI;EAAA;AAAA;;AAAA;EAPJ,2BAOI;EAAA;AAAA;;AAAA;EAPJ,6BAOI;EAAA;AAAA;;AAAA;EAPJ,2BAOI;EAAA;AAAA;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ,+BAOI;EAAA;AAAA;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAPJ,oBAIQ;EAAA;AAGJ;;AAAA;EAjBJ;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EASF;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAjBJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EAIJ;AAOI;;AAAA;EAKF;AAOI;;AAAA;EAnBN;AAOI;;AAAA;EAKF;AAOI;;AAAA;EAnBN;AAOI;;AAAA;EAKF;AAOI;;AAAA;EAnBN,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAPJ,8BAIQ;EAAA;AAGJ;;AAAA;EAjBJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EANJ;AACE;;AAAA;EAIA;AACE;;AAAA;EAIJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAPJ,kBAIQ;EAAA;AAGJ;;AAAA;EAjBJ;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EADF;AACE;;AAAA;EASF;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ,yDAOI;EAAA;AAAA;;AAAA;EAPJ,mCAOI;EAAA;AAAA;;AAAA;EAPJ,4DAOI;EAAA;AAAA;;AAAA;EAPJ,yDAOI;EAAA;AAAA;;AAAA;EAPJ,4DAOI;EAAA;AAAA;;AAAA;EAPJ,4DAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,qCAOI;EAAA;AAAA;;AAAA;EAPJ,8DAOI;EAAA;AAAA;;AAAA;EAPJ,0DAOI;EAAA;AAAA;;AAAA;EAPJ,oCAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,0DAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,8DAOI;EAAA;AAAA;;AAAA;EAPJ,sCAOI;EAAA;AAAA;;AAAA;EAPJ,+DAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,uCAOI;EAAA;AAAA;;AAAA;EAPJ,gEAOI;EAAA;AAAA;;AAAA;EAPJ,6DAOI;EAAA;AAAA;;AAAA;EAPJ,gEAOI;EAAA;AAAA;;AAAA;EAPJ,gEAOI;EAAA;AAAA;;AAAA;EAPJ,iEAOI;EAAA;AAAA;;AAAA;EAPJ,yCAOI;EAAA;AAAA;;AAAA;EAPJ,kEAOI;EAAA;AAAA;;AAAA;EAPJ,4DAOI;EAAA;AAAA;;AAAA;EAPJ,sCAOI;EAAA;AAAA;;AAAA;EAPJ,+DAOI;EAAA;AAAA;;AAAA;EAPJ,4DAOI;EAAA;AAAA;;AAAA;EAPJ,+DAOI;EAAA;AAAA;;AAAA;EAPJ,+DAOI;EAAA;AAAA;;AAAA;EAPJ,gEAOI;EAAA;AAAA;;AAAA;EAPJ,wCAOI;EAAA;AAAA;;AAAA;EAPJ,iEAOI;EAAA;AAAA;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EAPJ;AAOI;;AAAA;EnCVR;ImCGI;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,yBAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,uBAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,wBAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;EnCVR;ImCGI;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,yBAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,uBAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,wBAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;EnCVR;ImCGI;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,yBAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,uBAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,wBAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;EnCVR;ImCGI;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,yBAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,uBAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,wBAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;EnCVR;ImCGI;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,yBAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,uBAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ,0BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,8BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,+BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,wBAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,4BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ,6BAOI;IAAA;EAAA;;EAAA;IAPJ,2BAOI;IAAA;EAAA;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;ECtDZ;ID+CQ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;ECnCZ;ID4BQ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;;EAAA;IAPJ;EAOI;AAAA;;AAAA;EEvEZ;AACE;;AAAA;ECDF,kBACE;EAAA;AACA;;AAAA;EAGF;A9CQW;;ANfX,yBAAA","sourcesContent":[null,":root,[data-bs-theme=light]{--bs-blue: #0d6efd;--bs-indigo: #6610f2;--bs-purple: #6f42c1;--bs-pink: #d63384;--bs-red: #dc3545;--bs-orange: #fd7e14;--bs-yellow: #ffc107;--bs-green: #198754;--bs-teal: #20c997;--bs-cyan: #0dcaf0;--bs-black: #000;--bs-white: #fff;--bs-gray: #6c757d;--bs-gray-dark: #343a40;--bs-gray-100: #f8f9fa;--bs-gray-200: #e9ecef;--bs-gray-300: #dee2e6;--bs-gray-400: #ced4da;--bs-gray-500: #adb5bd;--bs-gray-600: #6c757d;--bs-gray-700: #495057;--bs-gray-800: #343a40;--bs-gray-900: #212529;--bs-primary: #0d6efd;--bs-secondary: #6c757d;--bs-success: #198754;--bs-info: #0dcaf0;--bs-warning: #ffc107;--bs-danger: #dc3545;--bs-light: #f8f9fa;--bs-dark: #212529;--bs-dark-primary: #252f3f;--bs-primary-rgb: 13, 110, 253;--bs-secondary-rgb: 108, 117, 125;--bs-success-rgb: 25, 135, 84;--bs-info-rgb: 13, 202, 240;--bs-warning-rgb: 255, 193, 7;--bs-danger-rgb: 220, 53, 69;--bs-light-rgb: 248, 249, 250;--bs-dark-rgb: 33, 37, 41;--bs-dark-primary-rgb: 37, 47, 63;--bs-primary-text-emphasis: #052c65;--bs-secondary-text-emphasis: #2b2f32;--bs-success-text-emphasis: #0a3622;--bs-info-text-emphasis: #055160;--bs-warning-text-emphasis: #664d03;--bs-danger-text-emphasis: #58151c;--bs-light-text-emphasis: #495057;--bs-dark-text-emphasis: #495057;--bs-primary-bg-subtle: #cfe2ff;--bs-secondary-bg-subtle: #e2e3e5;--bs-success-bg-subtle: #d1e7dd;--bs-info-bg-subtle: #cff4fc;--bs-warning-bg-subtle: #fff3cd;--bs-danger-bg-subtle: #f8d7da;--bs-light-bg-subtle: #fcfcfd;--bs-dark-bg-subtle: #ced4da;--bs-primary-border-subtle: #9ec5fe;--bs-secondary-border-subtle: #c4c8cb;--bs-success-border-subtle: #a3cfbb;--bs-info-border-subtle: #9eeaf9;--bs-warning-border-subtle: #ffe69c;--bs-danger-border-subtle: #f1aeb5;--bs-light-border-subtle: #e9ecef;--bs-dark-border-subtle: #adb5bd;--bs-white-rgb: 255, 255, 255;--bs-black-rgb: 0, 0, 0;--bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";--bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;--bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));--bs-body-font-family: var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight: 400;--bs-body-line-height: 1.5;--bs-body-color: #212529;--bs-body-color-rgb: 33, 37, 41;--bs-body-bg: #fff;--bs-body-bg-rgb: 255, 255, 255;--bs-emphasis-color: #000;--bs-emphasis-color-rgb: 0, 0, 0;--bs-secondary-color: rgba(33, 37, 41, 0.75);--bs-secondary-color-rgb: 33, 37, 41;--bs-secondary-bg: #e9ecef;--bs-secondary-bg-rgb: 233, 236, 239;--bs-tertiary-color: rgba(33, 37, 41, 0.5);--bs-tertiary-color-rgb: 33, 37, 41;--bs-tertiary-bg: #f8f9fa;--bs-tertiary-bg-rgb: 248, 249, 250;--bs-heading-color: inherit;--bs-link-color: #0d6efd;--bs-link-color-rgb: 13, 110, 253;--bs-link-decoration: underline;--bs-link-hover-color: #0a58ca;--bs-link-hover-color-rgb: 10, 88, 202;--bs-code-color: #d63384;--bs-highlight-color: #212529;--bs-highlight-bg: #fff3cd;--bs-border-width: 1px;--bs-border-style: solid;--bs-border-color: #dee2e6;--bs-border-color-translucent: rgba(0, 0, 0, 0.175);--bs-border-radius: 0.375rem;--bs-border-radius-sm: 0.25rem;--bs-border-radius-lg: 0.5rem;--bs-border-radius-xl: 1rem;--bs-border-radius-xxl: 2rem;--bs-border-radius-2xl: var(--bs-border-radius-xxl);--bs-border-radius-pill: 50rem;--bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);--bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);--bs-focus-ring-width: 0.25rem;--bs-focus-ring-opacity: 0.25;--bs-focus-ring-color: rgba(13, 110, 253, 0.25);--bs-form-valid-color: #198754;--bs-form-valid-border-color: #198754;--bs-form-invalid-color: #dc3545;--bs-form-invalid-border-color: #dc3545}[data-bs-theme=dark]{color-scheme:dark;--bs-body-color: #dee2e6;--bs-body-color-rgb: 222, 226, 230;--bs-body-bg: #212529;--bs-body-bg-rgb: 33, 37, 41;--bs-emphasis-color: #fff;--bs-emphasis-color-rgb: 255, 255, 255;--bs-secondary-color: rgba(222, 226, 230, 0.75);--bs-secondary-color-rgb: 222, 226, 230;--bs-secondary-bg: #343a40;--bs-secondary-bg-rgb: 52, 58, 64;--bs-tertiary-color: rgba(222, 226, 230, 0.5);--bs-tertiary-color-rgb: 222, 226, 230;--bs-tertiary-bg: #2b3035;--bs-tertiary-bg-rgb: 43, 48, 53;--bs-primary-text-emphasis: #6ea8fe;--bs-secondary-text-emphasis: #a7acb1;--bs-success-text-emphasis: #75b798;--bs-info-text-emphasis: #6edff6;--bs-warning-text-emphasis: #ffda6a;--bs-danger-text-emphasis: #ea868f;--bs-light-text-emphasis: #f8f9fa;--bs-dark-text-emphasis: #dee2e6;--bs-primary-bg-subtle: #031633;--bs-secondary-bg-subtle: #161719;--bs-success-bg-subtle: #051b11;--bs-info-bg-subtle: #032830;--bs-warning-bg-subtle: #332701;--bs-danger-bg-subtle: #2c0b0e;--bs-light-bg-subtle: #343a40;--bs-dark-bg-subtle: #1a1d20;--bs-primary-border-subtle: #084298;--bs-secondary-border-subtle: #41464b;--bs-success-border-subtle: #0f5132;--bs-info-border-subtle: #087990;--bs-warning-border-subtle: #997404;--bs-danger-border-subtle: #842029;--bs-light-border-subtle: #495057;--bs-dark-border-subtle: #343a40;--bs-heading-color: inherit;--bs-link-color: #6ea8fe;--bs-link-hover-color: #8bb9fe;--bs-link-color-rgb: 110, 168, 254;--bs-link-hover-color-rgb: 139, 185, 254;--bs-code-color: #e685b5;--bs-highlight-color: #dee2e6;--bs-highlight-bg: #664d03;--bs-border-color: #495057;--bs-border-color-translucent: rgba(255, 255, 255, 0.15);--bs-form-valid-color: #75b798;--bs-form-valid-border-color: #75b798;--bs-form-invalid-color: #ea868f;--bs-form-invalid-border-color: #ea868f}*,*::before,*::after{box-sizing:border-box}@media(prefers-reduced-motion: no-preference){:root{scroll-behavior:smooth}}body{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}hr{margin:1rem 0;color:inherit;border:0;border-top:var(--bs-border-width) solid;opacity:.25}h6,.h6,h5,.h5,h4,.h4,h3,.h3,h2,.h2,h1,.h1{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;color:var(--bs-heading-color)}h1,.h1{font-size:calc(1.375rem + 1.5vw)}@media(min-width: 1200px){h1,.h1{font-size:2.5rem}}h2,.h2{font-size:calc(1.325rem + 0.9vw)}@media(min-width: 1200px){h2,.h2{font-size:2rem}}h3,.h3{font-size:calc(1.3rem + 0.6vw)}@media(min-width: 1200px){h3,.h3{font-size:1.75rem}}h4,.h4{font-size:calc(1.275rem + 0.3vw)}@media(min-width: 1200px){h4,.h4{font-size:1.5rem}}h5,.h5{font-size:1.25rem}h6,.h6{font-size:1rem}p{margin-top:0;margin-bottom:1rem}abbr[title]{text-decoration:underline dotted;cursor:help;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul{padding-left:2rem}ol,ul,dl{margin-top:0;margin-bottom:1rem}ol ol,ul ul,ol ul,ul ol{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small,.small{font-size:0.875em}mark,.mark{padding:.1875em;color:var(--bs-highlight-color);background-color:var(--bs-highlight-bg)}sub,sup{position:relative;font-size:0.75em;line-height:0;vertical-align:baseline}sub{bottom:-0.25em}sup{top:-0.5em}a{color:rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));text-decoration:underline}a:hover{--bs-link-color-rgb: var(--bs-link-hover-color-rgb)}a:not([href]):not([class]),a:not([href]):not([class]):hover{color:inherit;text-decoration:none}pre,code,kbd,samp{font-family:var(--bs-font-monospace);font-size:1em}pre{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:0.875em}pre code{font-size:inherit;color:inherit;word-break:normal}code{font-size:0.875em;color:var(--bs-code-color);word-wrap:break-word}a>code{color:inherit}kbd{padding:.1875rem .375rem;font-size:0.875em;color:var(--bs-body-bg);background-color:var(--bs-body-color);border-radius:.25rem}kbd kbd{padding:0;font-size:1em}figure{margin:0 0 1rem}img,svg{vertical-align:middle}table{caption-side:bottom;border-collapse:collapse}caption{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-secondary-color);text-align:left}th{text-align:inherit;text-align:-webkit-match-parent}thead,tbody,tfoot,tr,td,th{border-color:inherit;border-style:solid;border-width:0}label{display:inline-block}button{border-radius:0}button:focus:not(:focus-visible){outline:0}input,button,select,optgroup,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}select:disabled{opacity:1}[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator{display:none !important}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button:not(:disabled),[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled){cursor:pointer}::-moz-focus-inner{padding:0;border-style:none}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + 0.3vw);line-height:inherit}@media(min-width: 1200px){legend{font-size:1.5rem}}legend+*{clear:left}::-webkit-datetime-edit-fields-wrapper,::-webkit-datetime-edit-text,::-webkit-datetime-edit-minute,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-year-field{padding:0}::-webkit-inner-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-color-swatch-wrapper{padding:0}::file-selector-button{font:inherit;-webkit-appearance:button}output{display:inline-block}iframe{border:0}summary{display:list-item;cursor:pointer}progress{vertical-align:baseline}[hidden]{display:none !important}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-1{font-size:5rem}}.display-2{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-2{font-size:4.5rem}}.display-3{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-3{font-size:4rem}}.display-4{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-4{font-size:3.5rem}}.display-5{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-5{font-size:3rem}}.display-6{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media(min-width: 1200px){.display-6{font-size:2.5rem}}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:0.875em;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote>:last-child{margin-bottom:0}.blockquote-footer{margin-top:-1rem;margin-bottom:1rem;font-size:0.875em;color:#6c757d}.blockquote-footer::before{content:\"— \"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:var(--bs-body-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:0.875em;color:var(--bs-secondary-color)}.container,.container-fluid,.container-xxl,.container-xl,.container-lg,.container-md,.container-sm{--bs-gutter-x: 1.5rem;--bs-gutter-y: 0;width:100%;padding-right:calc(var(--bs-gutter-x)*.5);padding-left:calc(var(--bs-gutter-x)*.5);margin-right:auto;margin-left:auto}@media(min-width: 576px){.container-sm,.container{max-width:540px}}@media(min-width: 768px){.container-md,.container-sm,.container{max-width:720px}}@media(min-width: 992px){.container-lg,.container-md,.container-sm,.container{max-width:960px}}@media(min-width: 1200px){.container-xl,.container-lg,.container-md,.container-sm,.container{max-width:1140px}}@media(min-width: 1400px){.container-xxl,.container-xl,.container-lg,.container-md,.container-sm,.container{max-width:1320px}}:root{--bs-breakpoint-xs: 0;--bs-breakpoint-sm: 576px;--bs-breakpoint-md: 768px;--bs-breakpoint-lg: 992px;--bs-breakpoint-xl: 1200px;--bs-breakpoint-xxl: 1400px}.row{--bs-gutter-x: 1.5rem;--bs-gutter-y: 0;display:flex;flex-wrap:wrap;margin-top:calc(-1*var(--bs-gutter-y));margin-right:calc(-0.5*var(--bs-gutter-x));margin-left:calc(-0.5*var(--bs-gutter-x))}.row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x)*.5);padding-left:calc(var(--bs-gutter-x)*.5);margin-top:var(--bs-gutter-y)}.col{flex:1 0 0%}.row-cols-auto>*{flex:0 0 auto;width:auto}.row-cols-1>*{flex:0 0 auto;width:100%}.row-cols-2>*{flex:0 0 auto;width:50%}.row-cols-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-4>*{flex:0 0 auto;width:25%}.row-cols-5>*{flex:0 0 auto;width:20%}.row-cols-6>*{flex:0 0 auto;width:16.66666667%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 auto;width:8.33333333%}.col-2{flex:0 0 auto;width:16.66666667%}.col-3{flex:0 0 auto;width:25%}.col-4{flex:0 0 auto;width:33.33333333%}.col-5{flex:0 0 auto;width:41.66666667%}.col-6{flex:0 0 auto;width:50%}.col-7{flex:0 0 auto;width:58.33333333%}.col-8{flex:0 0 auto;width:66.66666667%}.col-9{flex:0 0 auto;width:75%}.col-10{flex:0 0 auto;width:83.33333333%}.col-11{flex:0 0 auto;width:91.66666667%}.col-12{flex:0 0 auto;width:100%}.offset-1{margin-left:8.33333333%}.offset-2{margin-left:16.66666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333333%}.offset-5{margin-left:41.66666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333333%}.offset-8{margin-left:66.66666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333333%}.offset-11{margin-left:91.66666667%}.g-0,.gx-0{--bs-gutter-x: 0}.g-0,.gy-0{--bs-gutter-y: 0}.g-1,.gx-1{--bs-gutter-x: 0.25rem}.g-1,.gy-1{--bs-gutter-y: 0.25rem}.g-2,.gx-2{--bs-gutter-x: 0.5rem}.g-2,.gy-2{--bs-gutter-y: 0.5rem}.g-3,.gx-3{--bs-gutter-x: 1rem}.g-3,.gy-3{--bs-gutter-y: 1rem}.g-4,.gx-4{--bs-gutter-x: 1.5rem}.g-4,.gy-4{--bs-gutter-y: 1.5rem}.g-5,.gx-5{--bs-gutter-x: 3rem}.g-5,.gy-5{--bs-gutter-y: 3rem}@media(min-width: 576px){.col-sm{flex:1 0 0%}.row-cols-sm-auto>*{flex:0 0 auto;width:auto}.row-cols-sm-1>*{flex:0 0 auto;width:100%}.row-cols-sm-2>*{flex:0 0 auto;width:50%}.row-cols-sm-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-sm-4>*{flex:0 0 auto;width:25%}.row-cols-sm-5>*{flex:0 0 auto;width:20%}.row-cols-sm-6>*{flex:0 0 auto;width:16.66666667%}.col-sm-auto{flex:0 0 auto;width:auto}.col-sm-1{flex:0 0 auto;width:8.33333333%}.col-sm-2{flex:0 0 auto;width:16.66666667%}.col-sm-3{flex:0 0 auto;width:25%}.col-sm-4{flex:0 0 auto;width:33.33333333%}.col-sm-5{flex:0 0 auto;width:41.66666667%}.col-sm-6{flex:0 0 auto;width:50%}.col-sm-7{flex:0 0 auto;width:58.33333333%}.col-sm-8{flex:0 0 auto;width:66.66666667%}.col-sm-9{flex:0 0 auto;width:75%}.col-sm-10{flex:0 0 auto;width:83.33333333%}.col-sm-11{flex:0 0 auto;width:91.66666667%}.col-sm-12{flex:0 0 auto;width:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333333%}.offset-sm-2{margin-left:16.66666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333333%}.offset-sm-5{margin-left:41.66666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333333%}.offset-sm-8{margin-left:66.66666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333333%}.offset-sm-11{margin-left:91.66666667%}.g-sm-0,.gx-sm-0{--bs-gutter-x: 0}.g-sm-0,.gy-sm-0{--bs-gutter-y: 0}.g-sm-1,.gx-sm-1{--bs-gutter-x: 0.25rem}.g-sm-1,.gy-sm-1{--bs-gutter-y: 0.25rem}.g-sm-2,.gx-sm-2{--bs-gutter-x: 0.5rem}.g-sm-2,.gy-sm-2{--bs-gutter-y: 0.5rem}.g-sm-3,.gx-sm-3{--bs-gutter-x: 1rem}.g-sm-3,.gy-sm-3{--bs-gutter-y: 1rem}.g-sm-4,.gx-sm-4{--bs-gutter-x: 1.5rem}.g-sm-4,.gy-sm-4{--bs-gutter-y: 1.5rem}.g-sm-5,.gx-sm-5{--bs-gutter-x: 3rem}.g-sm-5,.gy-sm-5{--bs-gutter-y: 3rem}}@media(min-width: 768px){.col-md{flex:1 0 0%}.row-cols-md-auto>*{flex:0 0 auto;width:auto}.row-cols-md-1>*{flex:0 0 auto;width:100%}.row-cols-md-2>*{flex:0 0 auto;width:50%}.row-cols-md-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-md-4>*{flex:0 0 auto;width:25%}.row-cols-md-5>*{flex:0 0 auto;width:20%}.row-cols-md-6>*{flex:0 0 auto;width:16.66666667%}.col-md-auto{flex:0 0 auto;width:auto}.col-md-1{flex:0 0 auto;width:8.33333333%}.col-md-2{flex:0 0 auto;width:16.66666667%}.col-md-3{flex:0 0 auto;width:25%}.col-md-4{flex:0 0 auto;width:33.33333333%}.col-md-5{flex:0 0 auto;width:41.66666667%}.col-md-6{flex:0 0 auto;width:50%}.col-md-7{flex:0 0 auto;width:58.33333333%}.col-md-8{flex:0 0 auto;width:66.66666667%}.col-md-9{flex:0 0 auto;width:75%}.col-md-10{flex:0 0 auto;width:83.33333333%}.col-md-11{flex:0 0 auto;width:91.66666667%}.col-md-12{flex:0 0 auto;width:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333333%}.offset-md-2{margin-left:16.66666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333333%}.offset-md-5{margin-left:41.66666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333333%}.offset-md-8{margin-left:66.66666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333333%}.offset-md-11{margin-left:91.66666667%}.g-md-0,.gx-md-0{--bs-gutter-x: 0}.g-md-0,.gy-md-0{--bs-gutter-y: 0}.g-md-1,.gx-md-1{--bs-gutter-x: 0.25rem}.g-md-1,.gy-md-1{--bs-gutter-y: 0.25rem}.g-md-2,.gx-md-2{--bs-gutter-x: 0.5rem}.g-md-2,.gy-md-2{--bs-gutter-y: 0.5rem}.g-md-3,.gx-md-3{--bs-gutter-x: 1rem}.g-md-3,.gy-md-3{--bs-gutter-y: 1rem}.g-md-4,.gx-md-4{--bs-gutter-x: 1.5rem}.g-md-4,.gy-md-4{--bs-gutter-y: 1.5rem}.g-md-5,.gx-md-5{--bs-gutter-x: 3rem}.g-md-5,.gy-md-5{--bs-gutter-y: 3rem}}@media(min-width: 992px){.col-lg{flex:1 0 0%}.row-cols-lg-auto>*{flex:0 0 auto;width:auto}.row-cols-lg-1>*{flex:0 0 auto;width:100%}.row-cols-lg-2>*{flex:0 0 auto;width:50%}.row-cols-lg-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-lg-4>*{flex:0 0 auto;width:25%}.row-cols-lg-5>*{flex:0 0 auto;width:20%}.row-cols-lg-6>*{flex:0 0 auto;width:16.66666667%}.col-lg-auto{flex:0 0 auto;width:auto}.col-lg-1{flex:0 0 auto;width:8.33333333%}.col-lg-2{flex:0 0 auto;width:16.66666667%}.col-lg-3{flex:0 0 auto;width:25%}.col-lg-4{flex:0 0 auto;width:33.33333333%}.col-lg-5{flex:0 0 auto;width:41.66666667%}.col-lg-6{flex:0 0 auto;width:50%}.col-lg-7{flex:0 0 auto;width:58.33333333%}.col-lg-8{flex:0 0 auto;width:66.66666667%}.col-lg-9{flex:0 0 auto;width:75%}.col-lg-10{flex:0 0 auto;width:83.33333333%}.col-lg-11{flex:0 0 auto;width:91.66666667%}.col-lg-12{flex:0 0 auto;width:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333333%}.offset-lg-2{margin-left:16.66666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333333%}.offset-lg-5{margin-left:41.66666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333333%}.offset-lg-8{margin-left:66.66666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333333%}.offset-lg-11{margin-left:91.66666667%}.g-lg-0,.gx-lg-0{--bs-gutter-x: 0}.g-lg-0,.gy-lg-0{--bs-gutter-y: 0}.g-lg-1,.gx-lg-1{--bs-gutter-x: 0.25rem}.g-lg-1,.gy-lg-1{--bs-gutter-y: 0.25rem}.g-lg-2,.gx-lg-2{--bs-gutter-x: 0.5rem}.g-lg-2,.gy-lg-2{--bs-gutter-y: 0.5rem}.g-lg-3,.gx-lg-3{--bs-gutter-x: 1rem}.g-lg-3,.gy-lg-3{--bs-gutter-y: 1rem}.g-lg-4,.gx-lg-4{--bs-gutter-x: 1.5rem}.g-lg-4,.gy-lg-4{--bs-gutter-y: 1.5rem}.g-lg-5,.gx-lg-5{--bs-gutter-x: 3rem}.g-lg-5,.gy-lg-5{--bs-gutter-y: 3rem}}@media(min-width: 1200px){.col-xl{flex:1 0 0%}.row-cols-xl-auto>*{flex:0 0 auto;width:auto}.row-cols-xl-1>*{flex:0 0 auto;width:100%}.row-cols-xl-2>*{flex:0 0 auto;width:50%}.row-cols-xl-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-xl-4>*{flex:0 0 auto;width:25%}.row-cols-xl-5>*{flex:0 0 auto;width:20%}.row-cols-xl-6>*{flex:0 0 auto;width:16.66666667%}.col-xl-auto{flex:0 0 auto;width:auto}.col-xl-1{flex:0 0 auto;width:8.33333333%}.col-xl-2{flex:0 0 auto;width:16.66666667%}.col-xl-3{flex:0 0 auto;width:25%}.col-xl-4{flex:0 0 auto;width:33.33333333%}.col-xl-5{flex:0 0 auto;width:41.66666667%}.col-xl-6{flex:0 0 auto;width:50%}.col-xl-7{flex:0 0 auto;width:58.33333333%}.col-xl-8{flex:0 0 auto;width:66.66666667%}.col-xl-9{flex:0 0 auto;width:75%}.col-xl-10{flex:0 0 auto;width:83.33333333%}.col-xl-11{flex:0 0 auto;width:91.66666667%}.col-xl-12{flex:0 0 auto;width:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333333%}.offset-xl-2{margin-left:16.66666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333333%}.offset-xl-5{margin-left:41.66666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333333%}.offset-xl-8{margin-left:66.66666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333333%}.offset-xl-11{margin-left:91.66666667%}.g-xl-0,.gx-xl-0{--bs-gutter-x: 0}.g-xl-0,.gy-xl-0{--bs-gutter-y: 0}.g-xl-1,.gx-xl-1{--bs-gutter-x: 0.25rem}.g-xl-1,.gy-xl-1{--bs-gutter-y: 0.25rem}.g-xl-2,.gx-xl-2{--bs-gutter-x: 0.5rem}.g-xl-2,.gy-xl-2{--bs-gutter-y: 0.5rem}.g-xl-3,.gx-xl-3{--bs-gutter-x: 1rem}.g-xl-3,.gy-xl-3{--bs-gutter-y: 1rem}.g-xl-4,.gx-xl-4{--bs-gutter-x: 1.5rem}.g-xl-4,.gy-xl-4{--bs-gutter-y: 1.5rem}.g-xl-5,.gx-xl-5{--bs-gutter-x: 3rem}.g-xl-5,.gy-xl-5{--bs-gutter-y: 3rem}}@media(min-width: 1400px){.col-xxl{flex:1 0 0%}.row-cols-xxl-auto>*{flex:0 0 auto;width:auto}.row-cols-xxl-1>*{flex:0 0 auto;width:100%}.row-cols-xxl-2>*{flex:0 0 auto;width:50%}.row-cols-xxl-3>*{flex:0 0 auto;width:33.33333333%}.row-cols-xxl-4>*{flex:0 0 auto;width:25%}.row-cols-xxl-5>*{flex:0 0 auto;width:20%}.row-cols-xxl-6>*{flex:0 0 auto;width:16.66666667%}.col-xxl-auto{flex:0 0 auto;width:auto}.col-xxl-1{flex:0 0 auto;width:8.33333333%}.col-xxl-2{flex:0 0 auto;width:16.66666667%}.col-xxl-3{flex:0 0 auto;width:25%}.col-xxl-4{flex:0 0 auto;width:33.33333333%}.col-xxl-5{flex:0 0 auto;width:41.66666667%}.col-xxl-6{flex:0 0 auto;width:50%}.col-xxl-7{flex:0 0 auto;width:58.33333333%}.col-xxl-8{flex:0 0 auto;width:66.66666667%}.col-xxl-9{flex:0 0 auto;width:75%}.col-xxl-10{flex:0 0 auto;width:83.33333333%}.col-xxl-11{flex:0 0 auto;width:91.66666667%}.col-xxl-12{flex:0 0 auto;width:100%}.offset-xxl-0{margin-left:0}.offset-xxl-1{margin-left:8.33333333%}.offset-xxl-2{margin-left:16.66666667%}.offset-xxl-3{margin-left:25%}.offset-xxl-4{margin-left:33.33333333%}.offset-xxl-5{margin-left:41.66666667%}.offset-xxl-6{margin-left:50%}.offset-xxl-7{margin-left:58.33333333%}.offset-xxl-8{margin-left:66.66666667%}.offset-xxl-9{margin-left:75%}.offset-xxl-10{margin-left:83.33333333%}.offset-xxl-11{margin-left:91.66666667%}.g-xxl-0,.gx-xxl-0{--bs-gutter-x: 0}.g-xxl-0,.gy-xxl-0{--bs-gutter-y: 0}.g-xxl-1,.gx-xxl-1{--bs-gutter-x: 0.25rem}.g-xxl-1,.gy-xxl-1{--bs-gutter-y: 0.25rem}.g-xxl-2,.gx-xxl-2{--bs-gutter-x: 0.5rem}.g-xxl-2,.gy-xxl-2{--bs-gutter-y: 0.5rem}.g-xxl-3,.gx-xxl-3{--bs-gutter-x: 1rem}.g-xxl-3,.gy-xxl-3{--bs-gutter-y: 1rem}.g-xxl-4,.gx-xxl-4{--bs-gutter-x: 1.5rem}.g-xxl-4,.gy-xxl-4{--bs-gutter-y: 1.5rem}.g-xxl-5,.gx-xxl-5{--bs-gutter-x: 3rem}.g-xxl-5,.gy-xxl-5{--bs-gutter-y: 3rem}}.table{--bs-table-color-type: initial;--bs-table-bg-type: initial;--bs-table-color-state: initial;--bs-table-bg-state: initial;--bs-table-color: var(--bs-emphasis-color);--bs-table-bg: var(--bs-body-bg);--bs-table-border-color: var(--bs-border-color);--bs-table-accent-bg: transparent;--bs-table-striped-color: var(--bs-emphasis-color);--bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);--bs-table-active-color: var(--bs-emphasis-color);--bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);--bs-table-hover-color: var(--bs-emphasis-color);--bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);width:100%;margin-bottom:1rem;vertical-align:top;border-color:var(--bs-table-border-color)}.table>:not(caption)>*>*{padding:.5rem .5rem;color:var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));background-color:var(--bs-table-bg);border-bottom-width:var(--bs-border-width);box-shadow:inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)))}.table>tbody{vertical-align:inherit}.table>thead{vertical-align:bottom}.table-group-divider{border-top:calc(var(--bs-border-width)*2) solid currentcolor}.caption-top{caption-side:top}.table-sm>:not(caption)>*>*{padding:.25rem .25rem}.table-bordered>:not(caption)>*{border-width:var(--bs-border-width) 0}.table-bordered>:not(caption)>*>*{border-width:0 var(--bs-border-width)}.table-borderless>:not(caption)>*>*{border-bottom-width:0}.table-borderless>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>*{--bs-table-color-type: var(--bs-table-striped-color);--bs-table-bg-type: var(--bs-table-striped-bg)}.table-striped-columns>:not(caption)>tr>:nth-child(even){--bs-table-color-type: var(--bs-table-striped-color);--bs-table-bg-type: var(--bs-table-striped-bg)}.table-active{--bs-table-color-state: var(--bs-table-active-color);--bs-table-bg-state: var(--bs-table-active-bg)}.table-hover>tbody>tr:hover>*{--bs-table-color-state: var(--bs-table-hover-color);--bs-table-bg-state: var(--bs-table-hover-bg)}.table-primary{--bs-table-color: #000;--bs-table-bg: #cfe2ff;--bs-table-border-color: #a6b5cc;--bs-table-striped-bg: #c5d7f2;--bs-table-striped-color: #000;--bs-table-active-bg: #bacbe6;--bs-table-active-color: #000;--bs-table-hover-bg: #bfd1ec;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-secondary{--bs-table-color: #000;--bs-table-bg: #e2e3e5;--bs-table-border-color: #b5b6b7;--bs-table-striped-bg: #d7d8da;--bs-table-striped-color: #000;--bs-table-active-bg: #cbccce;--bs-table-active-color: #000;--bs-table-hover-bg: #d1d2d4;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-success{--bs-table-color: #000;--bs-table-bg: #d1e7dd;--bs-table-border-color: #a7b9b1;--bs-table-striped-bg: #c7dbd2;--bs-table-striped-color: #000;--bs-table-active-bg: #bcd0c7;--bs-table-active-color: #000;--bs-table-hover-bg: #c1d6cc;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-info{--bs-table-color: #000;--bs-table-bg: #cff4fc;--bs-table-border-color: #a6c3ca;--bs-table-striped-bg: #c5e8ef;--bs-table-striped-color: #000;--bs-table-active-bg: #badce3;--bs-table-active-color: #000;--bs-table-hover-bg: #bfe2e9;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-warning{--bs-table-color: #000;--bs-table-bg: #fff3cd;--bs-table-border-color: #ccc2a4;--bs-table-striped-bg: #f2e7c3;--bs-table-striped-color: #000;--bs-table-active-bg: #e6dbb9;--bs-table-active-color: #000;--bs-table-hover-bg: #ece1be;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-danger{--bs-table-color: #000;--bs-table-bg: #f8d7da;--bs-table-border-color: #c6acae;--bs-table-striped-bg: #eccccf;--bs-table-striped-color: #000;--bs-table-active-bg: #dfc2c4;--bs-table-active-color: #000;--bs-table-hover-bg: #e5c7ca;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-light{--bs-table-color: #000;--bs-table-bg: #f8f9fa;--bs-table-border-color: #c6c7c8;--bs-table-striped-bg: #ecedee;--bs-table-striped-color: #000;--bs-table-active-bg: #dfe0e1;--bs-table-active-color: #000;--bs-table-hover-bg: #e5e6e7;--bs-table-hover-color: #000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-dark{--bs-table-color: #fff;--bs-table-bg: #212529;--bs-table-border-color: #4d5154;--bs-table-striped-bg: #2c3034;--bs-table-striped-color: #fff;--bs-table-active-bg: #373b3e;--bs-table-active-color: #fff;--bs-table-hover-bg: #323539;--bs-table-hover-color: #fff;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-responsive{overflow-x:auto;-webkit-overflow-scrolling:touch}@media(max-width: 575.98px){.table-responsive-sm{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media(max-width: 767.98px){.table-responsive-md{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media(max-width: 991.98px){.table-responsive-lg{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media(max-width: 1199.98px){.table-responsive-xl{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media(max-width: 1399.98px){.table-responsive-xxl{overflow-x:auto;-webkit-overflow-scrolling:touch}}.btn{--bs-btn-padding-x: 0.75rem;--bs-btn-padding-y: 0.375rem;--bs-btn-font-family: ;--bs-btn-font-size:1rem;--bs-btn-font-weight: 400;--bs-btn-line-height: 1.5;--bs-btn-color: var(--bs-body-color);--bs-btn-bg: transparent;--bs-btn-border-width: var(--bs-border-width);--bs-btn-border-color: transparent;--bs-btn-border-radius: var(--bs-border-radius);--bs-btn-hover-border-color: transparent;--bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);--bs-btn-disabled-opacity: 0.65;--bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);display:inline-block;padding:var(--bs-btn-padding-y) var(--bs-btn-padding-x);font-family:var(--bs-btn-font-family);font-size:var(--bs-btn-font-size);font-weight:var(--bs-btn-font-weight);line-height:var(--bs-btn-line-height);color:var(--bs-btn-color);text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;user-select:none;border:var(--bs-btn-border-width) solid var(--bs-btn-border-color);border-radius:var(--bs-btn-border-radius);background-color:var(--bs-btn-bg);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media(prefers-reduced-motion: reduce){.btn{transition:none}}.btn:hover{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color)}.btn-check+.btn:hover{color:var(--bs-btn-color);background-color:var(--bs-btn-bg);border-color:var(--bs-btn-border-color)}.btn:focus-visible{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:focus-visible+.btn{border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:checked+.btn,:not(.btn-check)+.btn:active,.btn:first-child:active,.btn.active,.btn.show{color:var(--bs-btn-active-color);background-color:var(--bs-btn-active-bg);border-color:var(--bs-btn-active-border-color)}.btn-check:checked+.btn:focus-visible,:not(.btn-check)+.btn:active:focus-visible,.btn:first-child:active:focus-visible,.btn.active:focus-visible,.btn.show:focus-visible{box-shadow:var(--bs-btn-focus-box-shadow)}.btn:disabled,.btn.disabled,fieldset:disabled .btn{color:var(--bs-btn-disabled-color);pointer-events:none;background-color:var(--bs-btn-disabled-bg);border-color:var(--bs-btn-disabled-border-color);opacity:var(--bs-btn-disabled-opacity)}.btn-primary{--bs-btn-color: #fff;--bs-btn-bg: #0d6efd;--bs-btn-border-color: #0d6efd;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #0b5ed7;--bs-btn-hover-border-color: #0a58ca;--bs-btn-focus-shadow-rgb: 49, 132, 253;--bs-btn-active-color: #fff;--bs-btn-active-bg: #0a58ca;--bs-btn-active-border-color: #0a53be;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #0d6efd;--bs-btn-disabled-border-color: #0d6efd}.btn-secondary{--bs-btn-color: #fff;--bs-btn-bg: #6c757d;--bs-btn-border-color: #6c757d;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #5c636a;--bs-btn-hover-border-color: #565e64;--bs-btn-focus-shadow-rgb: 130, 138, 145;--bs-btn-active-color: #fff;--bs-btn-active-bg: #565e64;--bs-btn-active-border-color: #51585e;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #6c757d;--bs-btn-disabled-border-color: #6c757d}.btn-success{--bs-btn-color: #fff;--bs-btn-bg: #198754;--bs-btn-border-color: #198754;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #157347;--bs-btn-hover-border-color: #146c43;--bs-btn-focus-shadow-rgb: 60, 153, 110;--bs-btn-active-color: #fff;--bs-btn-active-bg: #146c43;--bs-btn-active-border-color: #13653f;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #198754;--bs-btn-disabled-border-color: #198754}.btn-info{--bs-btn-color: #000;--bs-btn-bg: #0dcaf0;--bs-btn-border-color: #0dcaf0;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #31d2f2;--bs-btn-hover-border-color: #25cff2;--bs-btn-focus-shadow-rgb: 11, 172, 204;--bs-btn-active-color: #000;--bs-btn-active-bg: #3dd5f3;--bs-btn-active-border-color: #25cff2;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #000;--bs-btn-disabled-bg: #0dcaf0;--bs-btn-disabled-border-color: #0dcaf0}.btn-warning{--bs-btn-color: #000;--bs-btn-bg: #ffc107;--bs-btn-border-color: #ffc107;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #ffca2c;--bs-btn-hover-border-color: #ffc720;--bs-btn-focus-shadow-rgb: 217, 164, 6;--bs-btn-active-color: #000;--bs-btn-active-bg: #ffcd39;--bs-btn-active-border-color: #ffc720;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #000;--bs-btn-disabled-bg: #ffc107;--bs-btn-disabled-border-color: #ffc107}.btn-danger{--bs-btn-color: #fff;--bs-btn-bg: #dc3545;--bs-btn-border-color: #dc3545;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #bb2d3b;--bs-btn-hover-border-color: #b02a37;--bs-btn-focus-shadow-rgb: 225, 83, 97;--bs-btn-active-color: #fff;--bs-btn-active-bg: #b02a37;--bs-btn-active-border-color: #a52834;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #dc3545;--bs-btn-disabled-border-color: #dc3545}.btn-light{--bs-btn-color: #000;--bs-btn-bg: #f8f9fa;--bs-btn-border-color: #f8f9fa;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #d3d4d5;--bs-btn-hover-border-color: #c6c7c8;--bs-btn-focus-shadow-rgb: 211, 212, 213;--bs-btn-active-color: #000;--bs-btn-active-bg: #c6c7c8;--bs-btn-active-border-color: #babbbc;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #000;--bs-btn-disabled-bg: #f8f9fa;--bs-btn-disabled-border-color: #f8f9fa}.btn-dark{--bs-btn-color: #fff;--bs-btn-bg: #212529;--bs-btn-border-color: #212529;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #424649;--bs-btn-hover-border-color: #373b3e;--bs-btn-focus-shadow-rgb: 66, 70, 73;--bs-btn-active-color: #fff;--bs-btn-active-bg: #4d5154;--bs-btn-active-border-color: #373b3e;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #212529;--bs-btn-disabled-border-color: #212529}.btn-dark-primary{--bs-btn-color: #fff;--bs-btn-bg: #252f3f;--bs-btn-border-color: #252f3f;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #1f2836;--bs-btn-hover-border-color: #1e2632;--bs-btn-focus-shadow-rgb: 70, 78, 92;--bs-btn-active-color: #fff;--bs-btn-active-bg: #1e2632;--bs-btn-active-border-color: #1c232f;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #fff;--bs-btn-disabled-bg: #252f3f;--bs-btn-disabled-border-color: #252f3f}.btn-outline-primary{--bs-btn-color: #0d6efd;--bs-btn-border-color: #0d6efd;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #0d6efd;--bs-btn-hover-border-color: #0d6efd;--bs-btn-focus-shadow-rgb: 13, 110, 253;--bs-btn-active-color: #fff;--bs-btn-active-bg: #0d6efd;--bs-btn-active-border-color: #0d6efd;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #0d6efd;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #0d6efd;--bs-gradient: none}.btn-outline-secondary{--bs-btn-color: #6c757d;--bs-btn-border-color: #6c757d;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #6c757d;--bs-btn-hover-border-color: #6c757d;--bs-btn-focus-shadow-rgb: 108, 117, 125;--bs-btn-active-color: #fff;--bs-btn-active-bg: #6c757d;--bs-btn-active-border-color: #6c757d;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #6c757d;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #6c757d;--bs-gradient: none}.btn-outline-success{--bs-btn-color: #198754;--bs-btn-border-color: #198754;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #198754;--bs-btn-hover-border-color: #198754;--bs-btn-focus-shadow-rgb: 25, 135, 84;--bs-btn-active-color: #fff;--bs-btn-active-bg: #198754;--bs-btn-active-border-color: #198754;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #198754;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #198754;--bs-gradient: none}.btn-outline-info{--bs-btn-color: #0dcaf0;--bs-btn-border-color: #0dcaf0;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #0dcaf0;--bs-btn-hover-border-color: #0dcaf0;--bs-btn-focus-shadow-rgb: 13, 202, 240;--bs-btn-active-color: #000;--bs-btn-active-bg: #0dcaf0;--bs-btn-active-border-color: #0dcaf0;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #0dcaf0;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #0dcaf0;--bs-gradient: none}.btn-outline-warning{--bs-btn-color: #ffc107;--bs-btn-border-color: #ffc107;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #ffc107;--bs-btn-hover-border-color: #ffc107;--bs-btn-focus-shadow-rgb: 255, 193, 7;--bs-btn-active-color: #000;--bs-btn-active-bg: #ffc107;--bs-btn-active-border-color: #ffc107;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #ffc107;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #ffc107;--bs-gradient: none}.btn-outline-danger{--bs-btn-color: #dc3545;--bs-btn-border-color: #dc3545;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #dc3545;--bs-btn-hover-border-color: #dc3545;--bs-btn-focus-shadow-rgb: 220, 53, 69;--bs-btn-active-color: #fff;--bs-btn-active-bg: #dc3545;--bs-btn-active-border-color: #dc3545;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #dc3545;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #dc3545;--bs-gradient: none}.btn-outline-light{--bs-btn-color: #f8f9fa;--bs-btn-border-color: #f8f9fa;--bs-btn-hover-color: #000;--bs-btn-hover-bg: #f8f9fa;--bs-btn-hover-border-color: #f8f9fa;--bs-btn-focus-shadow-rgb: 248, 249, 250;--bs-btn-active-color: #000;--bs-btn-active-bg: #f8f9fa;--bs-btn-active-border-color: #f8f9fa;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #f8f9fa;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #f8f9fa;--bs-gradient: none}.btn-outline-dark{--bs-btn-color: #212529;--bs-btn-border-color: #212529;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #212529;--bs-btn-hover-border-color: #212529;--bs-btn-focus-shadow-rgb: 33, 37, 41;--bs-btn-active-color: #fff;--bs-btn-active-bg: #212529;--bs-btn-active-border-color: #212529;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #212529;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #212529;--bs-gradient: none}.btn-outline-dark-primary{--bs-btn-color: #252f3f;--bs-btn-border-color: #252f3f;--bs-btn-hover-color: #fff;--bs-btn-hover-bg: #252f3f;--bs-btn-hover-border-color: #252f3f;--bs-btn-focus-shadow-rgb: 37, 47, 63;--bs-btn-active-color: #fff;--bs-btn-active-bg: #252f3f;--bs-btn-active-border-color: #252f3f;--bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color: #252f3f;--bs-btn-disabled-bg: transparent;--bs-btn-disabled-border-color: #252f3f;--bs-gradient: none}.btn-link{--bs-btn-font-weight: 400;--bs-btn-color: var(--bs-link-color);--bs-btn-bg: transparent;--bs-btn-border-color: transparent;--bs-btn-hover-color: var(--bs-link-hover-color);--bs-btn-hover-border-color: transparent;--bs-btn-active-color: var(--bs-link-hover-color);--bs-btn-active-border-color: transparent;--bs-btn-disabled-color: #6c757d;--bs-btn-disabled-border-color: transparent;--bs-btn-box-shadow: 0 0 0 #000;--bs-btn-focus-shadow-rgb: 49, 132, 253;text-decoration:underline}.btn-link:focus-visible{color:var(--bs-btn-color)}.btn-link:hover{color:var(--bs-btn-hover-color)}.btn-lg,.btn-group-lg>.btn{--bs-btn-padding-y: 0.5rem;--bs-btn-padding-x: 1rem;--bs-btn-font-size:1.25rem;--bs-btn-border-radius: var(--bs-border-radius-lg)}.btn-sm,.btn-group-sm>.btn{--bs-btn-padding-y: 0.25rem;--bs-btn-padding-x: 0.5rem;--bs-btn-font-size:0.875rem;--bs-btn-border-radius: var(--bs-border-radius-sm)}.fade{transition:opacity .15s linear}@media(prefers-reduced-motion: reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{height:0;overflow:hidden;transition:height .35s ease}@media(prefers-reduced-motion: reduce){.collapsing{transition:none}}.collapsing.collapse-horizontal{width:0;height:auto;transition:width .35s ease}@media(prefers-reduced-motion: reduce){.collapsing.collapse-horizontal{transition:none}}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group>.btn,.btn-group-vertical>.btn{position:relative;flex:1 1 auto}.btn-group>.btn-check:checked+.btn,.btn-group>.btn-check:focus+.btn,.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn-check:checked+.btn,.btn-group-vertical>.btn-check:focus+.btn,.btn-group-vertical>.btn:hover,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn.active{z-index:1}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group{border-radius:var(--bs-border-radius)}.btn-group>:not(.btn-check:first-child)+.btn,.btn-group>.btn-group:not(:first-child){margin-left:calc(var(--bs-border-width)*-1)}.btn-group>.btn:not(:last-child):not(.dropdown-toggle),.btn-group>.btn.dropdown-toggle-split:first-child,.btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:nth-child(n+3),.btn-group>:not(.btn-check)+.btn,.btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after,.dropend .dropdown-toggle-split::after{margin-left:0}.dropstart .dropdown-toggle-split::before{margin-right:0}.btn-sm+.dropdown-toggle-split,.btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-lg+.dropdown-toggle-split,.btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn:not(:first-child),.btn-group-vertical>.btn-group:not(:first-child){margin-top:calc(var(--bs-border-width)*-1)}.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn~.btn,.btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.nav{--bs-nav-link-padding-x: 1rem;--bs-nav-link-padding-y: 0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color: var(--bs-link-color);--bs-nav-link-hover-color: var(--bs-link-hover-color);--bs-nav-link-disabled-color: var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);font-size:var(--bs-nav-link-font-size);font-weight:var(--bs-nav-link-font-weight);color:var(--bs-nav-link-color);text-decoration:none;background:none;border:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media(prefers-reduced-motion: reduce){.nav-link{transition:none}}.nav-link:hover,.nav-link:focus{color:var(--bs-nav-link-hover-color)}.nav-link:focus-visible{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.nav-link.disabled,.nav-link:disabled{color:var(--bs-nav-link-disabled-color);pointer-events:none;cursor:default}.nav-tabs{--bs-nav-tabs-border-width: var(--bs-border-width);--bs-nav-tabs-border-color: var(--bs-border-color);--bs-nav-tabs-border-radius: var(--bs-border-radius);--bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);--bs-nav-tabs-link-active-color: var(--bs-emphasis-color);--bs-nav-tabs-link-active-bg: var(--bs-body-bg);--bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);border-bottom:var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)}.nav-tabs .nav-link{margin-bottom:calc(-1*var(--bs-nav-tabs-border-width));border:var(--bs-nav-tabs-border-width) solid rgba(0,0,0,0);border-top-left-radius:var(--bs-nav-tabs-border-radius);border-top-right-radius:var(--bs-nav-tabs-border-radius)}.nav-tabs .nav-link:hover,.nav-tabs .nav-link:focus{isolation:isolate;border-color:var(--bs-nav-tabs-link-hover-border-color)}.nav-tabs .nav-link.active,.nav-tabs .nav-item.show .nav-link{color:var(--bs-nav-tabs-link-active-color);background-color:var(--bs-nav-tabs-link-active-bg);border-color:var(--bs-nav-tabs-link-active-border-color)}.nav-tabs .dropdown-menu{margin-top:calc(-1*var(--bs-nav-tabs-border-width));border-top-left-radius:0;border-top-right-radius:0}.nav-pills{--bs-nav-pills-border-radius: var(--bs-border-radius);--bs-nav-pills-link-active-color: #fff;--bs-nav-pills-link-active-bg: #0d6efd}.nav-pills .nav-link{border-radius:var(--bs-nav-pills-border-radius)}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:var(--bs-nav-pills-link-active-color);background-color:var(--bs-nav-pills-link-active-bg)}.nav-underline{--bs-nav-underline-gap: 1rem;--bs-nav-underline-border-width: 0.125rem;--bs-nav-underline-link-active-color: var(--bs-emphasis-color);gap:var(--bs-nav-underline-gap)}.nav-underline .nav-link{padding-right:0;padding-left:0;border-bottom:var(--bs-nav-underline-border-width) solid rgba(0,0,0,0)}.nav-underline .nav-link:hover,.nav-underline .nav-link:focus{border-bottom-color:currentcolor}.nav-underline .nav-link.active,.nav-underline .show>.nav-link{font-weight:700;color:var(--bs-nav-underline-link-active-color);border-bottom-color:currentcolor}.nav-fill>.nav-link,.nav-fill .nav-item{flex:1 1 auto;text-align:center}.nav-justified>.nav-link,.nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link,.nav-justified .nav-item .nav-link{width:100%}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{--bs-navbar-padding-x: 0;--bs-navbar-padding-y: 0.5rem;--bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);--bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);--bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);--bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-padding-y: 0.3125rem;--bs-navbar-brand-margin-end: 1rem;--bs-navbar-brand-font-size: 1.25rem;--bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-nav-link-padding-x: 0.5rem;--bs-navbar-toggler-padding-y: 0.25rem;--bs-navbar-toggler-padding-x: 0.75rem;--bs-navbar-toggler-font-size: 1.25rem;--bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");--bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);--bs-navbar-toggler-border-radius: var(--bs-border-radius);--bs-navbar-toggler-focus-width: 0.25rem;--bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)}.navbar>.container,.navbar>.container-fluid,.navbar>.container-sm,.navbar>.container-md,.navbar>.container-lg,.navbar>.container-xl,.navbar>.container-xxl{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand{padding-top:var(--bs-navbar-brand-padding-y);padding-bottom:var(--bs-navbar-brand-padding-y);margin-right:var(--bs-navbar-brand-margin-end);font-size:var(--bs-navbar-brand-font-size);color:var(--bs-navbar-brand-color);text-decoration:none;white-space:nowrap}.navbar-brand:hover,.navbar-brand:focus{color:var(--bs-navbar-brand-hover-color)}.navbar-nav{--bs-nav-link-padding-x: 0;--bs-nav-link-padding-y: 0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color: var(--bs-navbar-color);--bs-nav-link-hover-color: var(--bs-navbar-hover-color);--bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link.active,.navbar-nav .nav-link.show{color:var(--bs-navbar-active-color)}.navbar-nav .dropdown-menu{position:static}.navbar-text{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-navbar-color)}.navbar-text a,.navbar-text a:hover,.navbar-text a:focus{color:var(--bs-navbar-active-color)}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);font-size:var(--bs-navbar-toggler-font-size);line-height:1;color:var(--bs-navbar-color);background-color:rgba(0,0,0,0);border:var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);border-radius:var(--bs-navbar-toggler-border-radius);transition:var(--bs-navbar-toggler-transition)}@media(prefers-reduced-motion: reduce){.navbar-toggler{transition:none}}.navbar-toggler:hover{text-decoration:none}.navbar-toggler:focus{text-decoration:none;outline:0;box-shadow:0 0 0 var(--bs-navbar-toggler-focus-width)}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-image:var(--bs-navbar-toggler-icon-bg);background-repeat:no-repeat;background-position:center;background-size:100%}.navbar-nav-scroll{max-height:var(--bs-scroll-height, 75vh);overflow-y:auto}@media(min-width: 576px){.navbar-expand-sm{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand-sm .offcanvas .offcanvas-header{display:none}.navbar-expand-sm .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media(min-width: 768px){.navbar-expand-md{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand-md .offcanvas .offcanvas-header{display:none}.navbar-expand-md .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media(min-width: 992px){.navbar-expand-lg{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand-lg .offcanvas .offcanvas-header{display:none}.navbar-expand-lg .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media(min-width: 1200px){.navbar-expand-xl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand-xl .offcanvas .offcanvas-header{display:none}.navbar-expand-xl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media(min-width: 1400px){.navbar-expand-xxl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xxl .navbar-nav-scroll{overflow:visible}.navbar-expand-xxl .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler{display:none}.navbar-expand-xxl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand-xxl .offcanvas .offcanvas-header{display:none}.navbar-expand-xxl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:flex !important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto !important;height:auto !important;visibility:visible !important;background-color:rgba(0,0,0,0) !important;border:0 !important;transform:none !important;transition:none}.navbar-expand .offcanvas .offcanvas-header{display:none}.navbar-expand .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-dark,.navbar[data-bs-theme=dark]{--bs-navbar-color: rgba(255, 255, 255, 0.55);--bs-navbar-hover-color: rgba(255, 255, 255, 0.75);--bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);--bs-navbar-active-color: #fff;--bs-navbar-brand-color: #fff;--bs-navbar-brand-hover-color: #fff;--bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);--bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}[data-bs-theme=dark] .navbar-toggler-icon{--bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.card{--bs-card-spacer-y: 1rem;--bs-card-spacer-x: 1rem;--bs-card-title-spacer-y: 0.5rem;--bs-card-title-color: ;--bs-card-subtitle-color: ;--bs-card-border-width: var(--bs-border-width);--bs-card-border-color: var(--bs-border-color-translucent);--bs-card-border-radius: var(--bs-border-radius);--bs-card-box-shadow: ;--bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-card-cap-padding-y: 0.5rem;--bs-card-cap-padding-x: 1rem;--bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);--bs-card-cap-color: ;--bs-card-height: ;--bs-card-color: ;--bs-card-bg: var(--bs-body-bg);--bs-card-img-overlay-padding: 1rem;--bs-card-group-margin: 0.75rem;position:relative;display:flex;flex-direction:column;min-width:0;height:var(--bs-card-height);color:var(--bs-body-color);word-wrap:break-word;background-color:var(--bs-card-bg);background-clip:border-box;border:var(--bs-card-border-width) solid var(--bs-card-border-color);border-radius:var(--bs-card-border-radius)}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{flex:1 1 auto;padding:var(--bs-card-spacer-y) var(--bs-card-spacer-x);color:var(--bs-card-color)}.card-title{margin-bottom:var(--bs-card-title-spacer-y);color:var(--bs-card-title-color)}.card-subtitle{margin-top:calc(-0.5*var(--bs-card-title-spacer-y));margin-bottom:0;color:var(--bs-card-subtitle-color)}.card-text:last-child{margin-bottom:0}.card-link+.card-link{margin-left:var(--bs-card-spacer-x)}.card-header{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);margin-bottom:0;color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-bottom:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-header:first-child{border-radius:var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0}.card-footer{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-top:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-footer:last-child{border-radius:0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)}.card-header-tabs{margin-right:calc(-0.5*var(--bs-card-cap-padding-x));margin-bottom:calc(-1*var(--bs-card-cap-padding-y));margin-left:calc(-0.5*var(--bs-card-cap-padding-x));border-bottom:0}.card-header-tabs .nav-link.active{background-color:var(--bs-card-bg);border-bottom-color:var(--bs-card-bg)}.card-header-pills{margin-right:calc(-0.5*var(--bs-card-cap-padding-x));margin-left:calc(-0.5*var(--bs-card-cap-padding-x))}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:var(--bs-card-img-overlay-padding);border-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-top,.card-img-bottom{width:100%}.card-img,.card-img-top{border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-bottom{border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card-group>.card{margin-bottom:var(--bs-card-group-margin)}@media(min-width: 576px){.card-group{display:flex;flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-img-top,.card-group>.card:not(:last-child) .card-header{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-img-bottom,.card-group>.card:not(:last-child) .card-footer{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-img-top,.card-group>.card:not(:first-child) .card-header{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-img-bottom,.card-group>.card:not(:first-child) .card-footer{border-bottom-left-radius:0}}.badge{--bs-badge-padding-x: 0.65em;--bs-badge-padding-y: 0.35em;--bs-badge-font-size:0.75em;--bs-badge-font-weight: 700;--bs-badge-color: #fff;--bs-badge-border-radius: var(--bs-border-radius);display:inline-block;padding:var(--bs-badge-padding-y) var(--bs-badge-padding-x);font-size:var(--bs-badge-font-size);font-weight:var(--bs-badge-font-weight);line-height:1;color:var(--bs-badge-color);text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:var(--bs-badge-border-radius)}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.alert{--bs-alert-bg: transparent;--bs-alert-padding-x: 1rem;--bs-alert-padding-y: 1rem;--bs-alert-margin-bottom: 1rem;--bs-alert-color: inherit;--bs-alert-border-color: transparent;--bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);--bs-alert-border-radius: var(--bs-border-radius);--bs-alert-link-color: inherit;position:relative;padding:var(--bs-alert-padding-y) var(--bs-alert-padding-x);margin-bottom:var(--bs-alert-margin-bottom);color:var(--bs-alert-color);background-color:var(--bs-alert-bg);border:var(--bs-alert-border);border-radius:var(--bs-alert-border-radius)}.alert-heading{color:inherit}.alert-link{font-weight:700;color:var(--bs-alert-link-color)}.alert-dismissible{padding-right:3rem}.alert-dismissible .btn-close{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary{--bs-alert-color: var(--bs-primary-text-emphasis);--bs-alert-bg: var(--bs-primary-bg-subtle);--bs-alert-border-color: var(--bs-primary-border-subtle);--bs-alert-link-color: var(--bs-primary-text-emphasis)}.alert-secondary{--bs-alert-color: var(--bs-secondary-text-emphasis);--bs-alert-bg: var(--bs-secondary-bg-subtle);--bs-alert-border-color: var(--bs-secondary-border-subtle);--bs-alert-link-color: var(--bs-secondary-text-emphasis)}.alert-success{--bs-alert-color: var(--bs-success-text-emphasis);--bs-alert-bg: var(--bs-success-bg-subtle);--bs-alert-border-color: var(--bs-success-border-subtle);--bs-alert-link-color: var(--bs-success-text-emphasis)}.alert-info{--bs-alert-color: var(--bs-info-text-emphasis);--bs-alert-bg: var(--bs-info-bg-subtle);--bs-alert-border-color: var(--bs-info-border-subtle);--bs-alert-link-color: var(--bs-info-text-emphasis)}.alert-warning{--bs-alert-color: var(--bs-warning-text-emphasis);--bs-alert-bg: var(--bs-warning-bg-subtle);--bs-alert-border-color: var(--bs-warning-border-subtle);--bs-alert-link-color: var(--bs-warning-text-emphasis)}.alert-danger{--bs-alert-color: var(--bs-danger-text-emphasis);--bs-alert-bg: var(--bs-danger-bg-subtle);--bs-alert-border-color: var(--bs-danger-border-subtle);--bs-alert-link-color: var(--bs-danger-text-emphasis)}.alert-light{--bs-alert-color: var(--bs-light-text-emphasis);--bs-alert-bg: var(--bs-light-bg-subtle);--bs-alert-border-color: var(--bs-light-border-subtle);--bs-alert-link-color: var(--bs-light-text-emphasis)}.alert-dark{--bs-alert-color: var(--bs-dark-text-emphasis);--bs-alert-bg: var(--bs-dark-bg-subtle);--bs-alert-border-color: var(--bs-dark-border-subtle);--bs-alert-link-color: var(--bs-dark-text-emphasis)}.alert-dark-primary{--bs-alert-color: var(--bs-dark-primary-text-emphasis);--bs-alert-bg: var(--bs-dark-primary-bg-subtle);--bs-alert-border-color: var(--bs-dark-primary-border-subtle);--bs-alert-link-color: var(--bs-dark-primary-text-emphasis)}.list-group{--bs-list-group-color: var(--bs-body-color);--bs-list-group-bg: var(--bs-body-bg);--bs-list-group-border-color: var(--bs-border-color);--bs-list-group-border-width: var(--bs-border-width);--bs-list-group-border-radius: var(--bs-border-radius);--bs-list-group-item-padding-x: 1rem;--bs-list-group-item-padding-y: 0.5rem;--bs-list-group-action-color: var(--bs-secondary-color);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-tertiary-bg);--bs-list-group-action-active-color: var(--bs-body-color);--bs-list-group-action-active-bg: var(--bs-secondary-bg);--bs-list-group-disabled-color: var(--bs-secondary-color);--bs-list-group-disabled-bg: var(--bs-body-bg);--bs-list-group-active-color: #fff;--bs-list-group-active-bg: #0d6efd;--bs-list-group-active-border-color: #0d6efd;display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:var(--bs-list-group-border-radius)}.list-group-numbered{list-style-type:none;counter-reset:section}.list-group-numbered>.list-group-item::before{content:counters(section, \".\") \". \";counter-increment:section}.list-group-item-action{width:100%;color:var(--bs-list-group-action-color);text-align:inherit}.list-group-item-action:hover,.list-group-item-action:focus{z-index:1;color:var(--bs-list-group-action-hover-color);text-decoration:none;background-color:var(--bs-list-group-action-hover-bg)}.list-group-item-action:active{color:var(--bs-list-group-action-active-color);background-color:var(--bs-list-group-action-active-bg)}.list-group-item{position:relative;display:block;padding:var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);color:var(--bs-list-group-color);text-decoration:none;background-color:var(--bs-list-group-bg);border:var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:var(--bs-list-group-disabled-color);pointer-events:none;background-color:var(--bs-list-group-disabled-bg)}.list-group-item.active{z-index:2;color:var(--bs-list-group-active-color);background-color:var(--bs-list-group-active-bg);border-color:var(--bs-list-group-active-border-color)}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:calc(-1*var(--bs-list-group-border-width));border-top-width:var(--bs-list-group-border-width)}.list-group-horizontal{flex-direction:row}.list-group-horizontal>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}@media(min-width: 576px){.list-group-horizontal-sm{flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media(min-width: 768px){.list-group-horizontal-md{flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media(min-width: 992px){.list-group-horizontal-lg{flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media(min-width: 1200px){.list-group-horizontal-xl{flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media(min-width: 1400px){.list-group-horizontal-xxl{flex-direction:row}.list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active{margin-left:calc(-1*var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 var(--bs-list-group-border-width)}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{--bs-list-group-color: var(--bs-primary-text-emphasis);--bs-list-group-bg: var(--bs-primary-bg-subtle);--bs-list-group-border-color: var(--bs-primary-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-primary-border-subtle);--bs-list-group-active-color: var(--bs-primary-bg-subtle);--bs-list-group-active-bg: var(--bs-primary-text-emphasis);--bs-list-group-active-border-color: var(--bs-primary-text-emphasis)}.list-group-item-secondary{--bs-list-group-color: var(--bs-secondary-text-emphasis);--bs-list-group-bg: var(--bs-secondary-bg-subtle);--bs-list-group-border-color: var(--bs-secondary-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);--bs-list-group-active-color: var(--bs-secondary-bg-subtle);--bs-list-group-active-bg: var(--bs-secondary-text-emphasis);--bs-list-group-active-border-color: var(--bs-secondary-text-emphasis)}.list-group-item-success{--bs-list-group-color: var(--bs-success-text-emphasis);--bs-list-group-bg: var(--bs-success-bg-subtle);--bs-list-group-border-color: var(--bs-success-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-success-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-success-border-subtle);--bs-list-group-active-color: var(--bs-success-bg-subtle);--bs-list-group-active-bg: var(--bs-success-text-emphasis);--bs-list-group-active-border-color: var(--bs-success-text-emphasis)}.list-group-item-info{--bs-list-group-color: var(--bs-info-text-emphasis);--bs-list-group-bg: var(--bs-info-bg-subtle);--bs-list-group-border-color: var(--bs-info-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-info-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-info-border-subtle);--bs-list-group-active-color: var(--bs-info-bg-subtle);--bs-list-group-active-bg: var(--bs-info-text-emphasis);--bs-list-group-active-border-color: var(--bs-info-text-emphasis)}.list-group-item-warning{--bs-list-group-color: var(--bs-warning-text-emphasis);--bs-list-group-bg: var(--bs-warning-bg-subtle);--bs-list-group-border-color: var(--bs-warning-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-warning-border-subtle);--bs-list-group-active-color: var(--bs-warning-bg-subtle);--bs-list-group-active-bg: var(--bs-warning-text-emphasis);--bs-list-group-active-border-color: var(--bs-warning-text-emphasis)}.list-group-item-danger{--bs-list-group-color: var(--bs-danger-text-emphasis);--bs-list-group-bg: var(--bs-danger-bg-subtle);--bs-list-group-border-color: var(--bs-danger-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-danger-border-subtle);--bs-list-group-active-color: var(--bs-danger-bg-subtle);--bs-list-group-active-bg: var(--bs-danger-text-emphasis);--bs-list-group-active-border-color: var(--bs-danger-text-emphasis)}.list-group-item-light{--bs-list-group-color: var(--bs-light-text-emphasis);--bs-list-group-bg: var(--bs-light-bg-subtle);--bs-list-group-border-color: var(--bs-light-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-light-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-light-border-subtle);--bs-list-group-active-color: var(--bs-light-bg-subtle);--bs-list-group-active-bg: var(--bs-light-text-emphasis);--bs-list-group-active-border-color: var(--bs-light-text-emphasis)}.list-group-item-dark{--bs-list-group-color: var(--bs-dark-text-emphasis);--bs-list-group-bg: var(--bs-dark-bg-subtle);--bs-list-group-border-color: var(--bs-dark-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-dark-border-subtle);--bs-list-group-active-color: var(--bs-dark-bg-subtle);--bs-list-group-active-bg: var(--bs-dark-text-emphasis);--bs-list-group-active-border-color: var(--bs-dark-text-emphasis)}.list-group-item-dark-primary{--bs-list-group-color: var(--bs-dark-primary-text-emphasis);--bs-list-group-bg: var(--bs-dark-primary-bg-subtle);--bs-list-group-border-color: var(--bs-dark-primary-border-subtle);--bs-list-group-action-hover-color: var(--bs-emphasis-color);--bs-list-group-action-hover-bg: var(--bs-dark-primary-border-subtle);--bs-list-group-action-active-color: var(--bs-emphasis-color);--bs-list-group-action-active-bg: var(--bs-dark-primary-border-subtle);--bs-list-group-active-color: var(--bs-dark-primary-bg-subtle);--bs-list-group-active-bg: var(--bs-dark-primary-text-emphasis);--bs-list-group-active-border-color: var(--bs-dark-primary-text-emphasis)}.btn-close{--bs-btn-close-color: #000;--bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");--bs-btn-close-opacity: 0.5;--bs-btn-close-hover-opacity: 0.75;--bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-btn-close-focus-opacity: 1;--bs-btn-close-disabled-opacity: 0.25;--bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);box-sizing:content-box;width:1em;height:1em;padding:.25em .25em;color:var(--bs-btn-close-color);background:rgba(0,0,0,0) var(--bs-btn-close-bg) center/1em auto no-repeat;border:0;border-radius:.375rem;opacity:var(--bs-btn-close-opacity)}.btn-close:hover{color:var(--bs-btn-close-color);text-decoration:none;opacity:var(--bs-btn-close-hover-opacity)}.btn-close:focus{outline:0;box-shadow:var(--bs-btn-close-focus-shadow);opacity:var(--bs-btn-close-focus-opacity)}.btn-close:disabled,.btn-close.disabled{pointer-events:none;user-select:none;opacity:var(--bs-btn-close-disabled-opacity)}.btn-close-white{filter:var(--bs-btn-close-white-filter)}[data-bs-theme=dark] .btn-close{filter:var(--bs-btn-close-white-filter)}.modal{--bs-modal-zindex: 1055;--bs-modal-width: 500px;--bs-modal-padding: 1rem;--bs-modal-margin: 0.5rem;--bs-modal-color: ;--bs-modal-bg: var(--bs-body-bg);--bs-modal-border-color: var(--bs-border-color-translucent);--bs-modal-border-width: var(--bs-border-width);--bs-modal-border-radius: var(--bs-border-radius-lg);--bs-modal-box-shadow: var(--bs-box-shadow-sm);--bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));--bs-modal-header-padding-x: 1rem;--bs-modal-header-padding-y: 1rem;--bs-modal-header-padding: 1rem 1rem;--bs-modal-header-border-color: var(--bs-border-color);--bs-modal-header-border-width: var(--bs-border-width);--bs-modal-title-line-height: 1.5;--bs-modal-footer-gap: 0.5rem;--bs-modal-footer-bg: ;--bs-modal-footer-border-color: var(--bs-border-color);--bs-modal-footer-border-width: var(--bs-border-width);position:fixed;top:0;left:0;z-index:var(--bs-modal-zindex);display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog{position:relative;width:auto;margin:var(--bs-modal-margin);pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0, -50px)}@media(prefers-reduced-motion: reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{transform:none}.modal.modal-static .modal-dialog{transform:scale(1.02)}.modal-dialog-scrollable{height:calc(100% - var(--bs-modal-margin)*2)}.modal-dialog-scrollable .modal-content{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - var(--bs-modal-margin)*2)}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;color:var(--bs-modal-color);pointer-events:auto;background-color:var(--bs-modal-bg);background-clip:padding-box;border:var(--bs-modal-border-width) solid var(--bs-modal-border-color);border-radius:var(--bs-modal-border-radius);outline:0}.modal-backdrop{--bs-backdrop-zindex: 1050;--bs-backdrop-bg: #000;--bs-backdrop-opacity: 0.5;position:fixed;top:0;left:0;z-index:var(--bs-backdrop-zindex);width:100vw;height:100vh;background-color:var(--bs-backdrop-bg)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--bs-backdrop-opacity)}.modal-header{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:var(--bs-modal-header-padding);border-bottom:var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);border-top-left-radius:var(--bs-modal-inner-border-radius);border-top-right-radius:var(--bs-modal-inner-border-radius)}.modal-header .btn-close{padding:calc(var(--bs-modal-header-padding-y)*.5) calc(var(--bs-modal-header-padding-x)*.5);margin:calc(-0.5*var(--bs-modal-header-padding-y)) calc(-0.5*var(--bs-modal-header-padding-x)) calc(-0.5*var(--bs-modal-header-padding-y)) auto}.modal-title{margin-bottom:0;line-height:var(--bs-modal-title-line-height)}.modal-body{position:relative;flex:1 1 auto;padding:var(--bs-modal-padding)}.modal-footer{display:flex;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap)*.5);background-color:var(--bs-modal-footer-bg);border-top:var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);border-bottom-right-radius:var(--bs-modal-inner-border-radius);border-bottom-left-radius:var(--bs-modal-inner-border-radius)}.modal-footer>*{margin:calc(var(--bs-modal-footer-gap)*.5)}@media(min-width: 576px){.modal{--bs-modal-margin: 1.75rem;--bs-modal-box-shadow: var(--bs-box-shadow)}.modal-dialog{max-width:var(--bs-modal-width);margin-right:auto;margin-left:auto}.modal-sm{--bs-modal-width: 300px}}@media(min-width: 992px){.modal-lg,.modal-xl{--bs-modal-width: 800px}}@media(min-width: 1200px){.modal-xl{--bs-modal-width: 1140px}}.modal-fullscreen{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-header,.modal-fullscreen .modal-footer{border-radius:0}.modal-fullscreen .modal-body{overflow-y:auto}@media(max-width: 575.98px){.modal-fullscreen-sm-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-header,.modal-fullscreen-sm-down .modal-footer{border-radius:0}.modal-fullscreen-sm-down .modal-body{overflow-y:auto}}@media(max-width: 767.98px){.modal-fullscreen-md-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-header,.modal-fullscreen-md-down .modal-footer{border-radius:0}.modal-fullscreen-md-down .modal-body{overflow-y:auto}}@media(max-width: 991.98px){.modal-fullscreen-lg-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-header,.modal-fullscreen-lg-down .modal-footer{border-radius:0}.modal-fullscreen-lg-down .modal-body{overflow-y:auto}}@media(max-width: 1199.98px){.modal-fullscreen-xl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-header,.modal-fullscreen-xl-down .modal-footer{border-radius:0}.modal-fullscreen-xl-down .modal-body{overflow-y:auto}}@media(max-width: 1399.98px){.modal-fullscreen-xxl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-header,.modal-fullscreen-xxl-down .modal-footer{border-radius:0}.modal-fullscreen-xxl-down .modal-body{overflow-y:auto}}.tooltip{--bs-tooltip-zindex: 1080;--bs-tooltip-max-width: 200px;--bs-tooltip-padding-x: 0.5rem;--bs-tooltip-padding-y: 0.25rem;--bs-tooltip-margin: ;--bs-tooltip-font-size:0.875rem;--bs-tooltip-color: var(--bs-body-bg);--bs-tooltip-bg: var(--bs-emphasis-color);--bs-tooltip-border-radius: var(--bs-border-radius);--bs-tooltip-opacity: 0.9;--bs-tooltip-arrow-width: 0.8rem;--bs-tooltip-arrow-height: 0.4rem;z-index:var(--bs-tooltip-zindex);display:block;margin:var(--bs-tooltip-margin);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-tooltip-font-size);word-wrap:break-word;opacity:0}.tooltip.show{opacity:var(--bs-tooltip-opacity)}.tooltip .tooltip-arrow{display:block;width:var(--bs-tooltip-arrow-width);height:var(--bs-tooltip-arrow-height)}.tooltip .tooltip-arrow::before{position:absolute;content:\"\";border-color:rgba(0,0,0,0);border-style:solid}.bs-tooltip-top .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow{bottom:calc(-1*var(--bs-tooltip-arrow-height))}.bs-tooltip-top .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before{top:-1px;border-width:var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;border-top-color:var(--bs-tooltip-bg)}.bs-tooltip-end .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow{left:calc(-1*var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-end .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before{right:-1px;border-width:calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width)*.5) 0;border-right-color:var(--bs-tooltip-bg)}.bs-tooltip-bottom .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow{top:calc(-1*var(--bs-tooltip-arrow-height))}.bs-tooltip-bottom .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before{bottom:-1px;border-width:0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);border-bottom-color:var(--bs-tooltip-bg)}.bs-tooltip-start .tooltip-arrow,.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow{right:calc(-1*var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-start .tooltip-arrow::before,.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before{left:-1px;border-width:calc(var(--bs-tooltip-arrow-width)*.5) 0 calc(var(--bs-tooltip-arrow-width)*.5) var(--bs-tooltip-arrow-height);border-left-color:var(--bs-tooltip-bg)}.tooltip-inner{max-width:var(--bs-tooltip-max-width);padding:var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);color:var(--bs-tooltip-color);text-align:center;background-color:var(--bs-tooltip-bg);border-radius:var(--bs-tooltip-border-radius)}.clearfix::after{display:block;clear:both;content:\"\"}.text-bg-primary{color:#fff !important;background-color:RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-secondary{color:#fff !important;background-color:RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-success{color:#fff !important;background-color:RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-info{color:#000 !important;background-color:RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-warning{color:#000 !important;background-color:RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-danger{color:#fff !important;background-color:RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-light{color:#000 !important;background-color:RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-dark{color:#fff !important;background-color:RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important}.text-bg-dark-primary{color:#fff !important;background-color:RGBA(var(--bs-dark-primary-rgb), var(--bs-bg-opacity, 1)) !important}.link-primary{color:RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-primary:hover,.link-primary:focus{color:RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important}.link-secondary{color:RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-secondary:hover,.link-secondary:focus{color:RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important}.link-success{color:RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-success:hover,.link-success:focus{color:RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important}.link-info{color:RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-info:hover,.link-info:focus{color:RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important}.link-warning{color:RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-warning:hover,.link-warning:focus{color:RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important}.link-danger{color:RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-danger:hover,.link-danger:focus{color:RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important}.link-light{color:RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-light:hover,.link-light:focus{color:RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important}.link-dark{color:RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-dark:hover,.link-dark:focus{color:RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important}.link-dark-primary{color:RGBA(var(--bs-dark-primary-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-dark-primary-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-dark-primary:hover,.link-dark-primary:focus{color:RGBA(30, 38, 50, var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(30, 38, 50, var(--bs-link-underline-opacity, 1)) !important}.link-body-emphasis{color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-body-emphasis:hover,.link-body-emphasis:focus{color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important}.focus-ring:focus{outline:0;box-shadow:var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)}.icon-link{display:inline-flex;gap:.375rem;align-items:center;text-decoration-color:rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));text-underline-offset:.25em;backface-visibility:hidden}.icon-link>.bi{flex-shrink:0;width:1em;height:1em;fill:currentcolor;transition:.2s ease-in-out transform}@media(prefers-reduced-motion: reduce){.icon-link>.bi{transition:none}}.icon-link-hover:hover>.bi,.icon-link-hover:focus-visible>.bi{transform:var(--bs-icon-link-transform, translate3d(0.25em, 0, 0))}.ratio{position:relative;width:100%}.ratio::before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>*{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1{--bs-aspect-ratio: 100%}.ratio-4x3{--bs-aspect-ratio: 75%}.ratio-16x9{--bs-aspect-ratio: 56.25%}.ratio-21x9{--bs-aspect-ratio: 42.8571428571%}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top{position:sticky;top:0;z-index:1020}.sticky-bottom{position:sticky;bottom:0;z-index:1020}@media(min-width: 576px){.sticky-sm-top{position:sticky;top:0;z-index:1020}.sticky-sm-bottom{position:sticky;bottom:0;z-index:1020}}@media(min-width: 768px){.sticky-md-top{position:sticky;top:0;z-index:1020}.sticky-md-bottom{position:sticky;bottom:0;z-index:1020}}@media(min-width: 992px){.sticky-lg-top{position:sticky;top:0;z-index:1020}.sticky-lg-bottom{position:sticky;bottom:0;z-index:1020}}@media(min-width: 1200px){.sticky-xl-top{position:sticky;top:0;z-index:1020}.sticky-xl-bottom{position:sticky;bottom:0;z-index:1020}}@media(min-width: 1400px){.sticky-xxl-top{position:sticky;top:0;z-index:1020}.sticky-xxl-bottom{position:sticky;bottom:0;z-index:1020}}.hstack{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden,.visually-hidden-focusable:not(:focus):not(:focus-within){width:1px !important;height:1px !important;padding:0 !important;margin:-1px !important;overflow:hidden !important;clip:rect(0, 0, 0, 0) !important;white-space:nowrap !important;border:0 !important}.visually-hidden:not(caption),.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption){position:absolute !important}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr{display:inline-block;align-self:stretch;width:var(--bs-border-width);min-height:1em;background-color:currentcolor;opacity:.25}.align-baseline{vertical-align:baseline !important}.align-top{vertical-align:top !important}.align-middle{vertical-align:middle !important}.align-bottom{vertical-align:bottom !important}.align-text-bottom{vertical-align:text-bottom !important}.align-text-top{vertical-align:text-top !important}.float-start{float:left !important}.float-end{float:right !important}.float-none{float:none !important}.object-fit-contain{object-fit:contain !important}.object-fit-cover{object-fit:cover !important}.object-fit-fill{object-fit:fill !important}.object-fit-scale{object-fit:scale-down !important}.object-fit-none{object-fit:none !important}.opacity-0{opacity:0 !important}.opacity-25{opacity:.25 !important}.opacity-50{opacity:.5 !important}.opacity-75{opacity:.75 !important}.opacity-100{opacity:1 !important}.overflow-auto{overflow:auto !important}.overflow-hidden{overflow:hidden !important}.overflow-visible{overflow:visible !important}.overflow-scroll{overflow:scroll !important}.overflow-x-auto{overflow-x:auto !important}.overflow-x-hidden{overflow-x:hidden !important}.overflow-x-visible{overflow-x:visible !important}.overflow-x-scroll{overflow-x:scroll !important}.overflow-y-auto{overflow-y:auto !important}.overflow-y-hidden{overflow-y:hidden !important}.overflow-y-visible{overflow-y:visible !important}.overflow-y-scroll{overflow-y:scroll !important}.d-inline{display:inline !important}.d-inline-block{display:inline-block !important}.d-block{display:block !important}.d-grid{display:grid !important}.d-inline-grid{display:inline-grid !important}.d-table{display:table !important}.d-table-row{display:table-row !important}.d-table-cell{display:table-cell !important}.d-flex{display:flex !important}.d-inline-flex{display:inline-flex !important}.d-none{display:none !important}.shadow{box-shadow:var(--bs-box-shadow) !important}.shadow-sm{box-shadow:var(--bs-box-shadow-sm) !important}.shadow-lg{box-shadow:var(--bs-box-shadow-lg) !important}.shadow-none{box-shadow:none !important}.focus-ring-primary{--bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-secondary{--bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-success{--bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))}.focus-ring-info{--bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))}.focus-ring-warning{--bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))}.focus-ring-danger{--bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))}.focus-ring-light{--bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))}.focus-ring-dark{--bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))}.focus-ring-dark-primary{--bs-focus-ring-color: rgba(var(--bs-dark-primary-rgb), var(--bs-focus-ring-opacity))}.position-static{position:static !important}.position-relative{position:relative !important}.position-absolute{position:absolute !important}.position-fixed{position:fixed !important}.position-sticky{position:sticky !important}.top-0{top:0 !important}.top-50{top:50% !important}.top-100{top:100% !important}.bottom-0{bottom:0 !important}.bottom-50{bottom:50% !important}.bottom-100{bottom:100% !important}.start-0{left:0 !important}.start-50{left:50% !important}.start-100{left:100% !important}.end-0{right:0 !important}.end-50{right:50% !important}.end-100{right:100% !important}.translate-middle{transform:translate(-50%, -50%) !important}.translate-middle-x{transform:translateX(-50%) !important}.translate-middle-y{transform:translateY(-50%) !important}.border{border:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important}.border-0{border:0 !important}.border-top{border-top:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important}.border-top-0{border-top:0 !important}.border-end{border-right:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important}.border-end-0{border-right:0 !important}.border-bottom{border-bottom:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important}.border-bottom-0{border-bottom:0 !important}.border-start{border-left:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important}.border-start-0{border-left:0 !important}.border-primary{--bs-border-opacity: 1;border-color:rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important}.border-secondary{--bs-border-opacity: 1;border-color:rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important}.border-success{--bs-border-opacity: 1;border-color:rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important}.border-info{--bs-border-opacity: 1;border-color:rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important}.border-warning{--bs-border-opacity: 1;border-color:rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important}.border-danger{--bs-border-opacity: 1;border-color:rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important}.border-light{--bs-border-opacity: 1;border-color:rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important}.border-dark{--bs-border-opacity: 1;border-color:rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important}.border-dark-primary{--bs-border-opacity: 1;border-color:rgba(var(--bs-dark-primary-rgb), var(--bs-border-opacity)) !important}.border-black{--bs-border-opacity: 1;border-color:rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important}.border-white{--bs-border-opacity: 1;border-color:rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important}.border-primary-subtle{border-color:var(--bs-primary-border-subtle) !important}.border-secondary-subtle{border-color:var(--bs-secondary-border-subtle) !important}.border-success-subtle{border-color:var(--bs-success-border-subtle) !important}.border-info-subtle{border-color:var(--bs-info-border-subtle) !important}.border-warning-subtle{border-color:var(--bs-warning-border-subtle) !important}.border-danger-subtle{border-color:var(--bs-danger-border-subtle) !important}.border-light-subtle{border-color:var(--bs-light-border-subtle) !important}.border-dark-subtle{border-color:var(--bs-dark-border-subtle) !important}.border-1{border-width:1px !important}.border-2{border-width:2px !important}.border-3{border-width:3px !important}.border-4{border-width:4px !important}.border-5{border-width:5px !important}.border-opacity-10{--bs-border-opacity: 0.1}.border-opacity-25{--bs-border-opacity: 0.25}.border-opacity-50{--bs-border-opacity: 0.5}.border-opacity-75{--bs-border-opacity: 0.75}.border-opacity-100{--bs-border-opacity: 1}.w-25{width:25% !important}.w-50{width:50% !important}.w-75{width:75% !important}.w-100{width:100% !important}.w-auto{width:auto !important}.mw-100{max-width:100% !important}.vw-100{width:100vw !important}.min-vw-100{min-width:100vw !important}.h-25{height:25% !important}.h-50{height:50% !important}.h-75{height:75% !important}.h-100{height:100% !important}.h-auto{height:auto !important}.mh-100{max-height:100% !important}.vh-100{height:100vh !important}.min-vh-100{min-height:100vh !important}.flex-fill{flex:1 1 auto !important}.flex-row{flex-direction:row !important}.flex-column{flex-direction:column !important}.flex-row-reverse{flex-direction:row-reverse !important}.flex-column-reverse{flex-direction:column-reverse !important}.flex-grow-0{flex-grow:0 !important}.flex-grow-1{flex-grow:1 !important}.flex-shrink-0{flex-shrink:0 !important}.flex-shrink-1{flex-shrink:1 !important}.flex-wrap{flex-wrap:wrap !important}.flex-nowrap{flex-wrap:nowrap !important}.flex-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-start{justify-content:flex-start !important}.justify-content-end{justify-content:flex-end !important}.justify-content-center{justify-content:center !important}.justify-content-between{justify-content:space-between !important}.justify-content-around{justify-content:space-around !important}.justify-content-evenly{justify-content:space-evenly !important}.align-items-start{align-items:flex-start !important}.align-items-end{align-items:flex-end !important}.align-items-center{align-items:center !important}.align-items-baseline{align-items:baseline !important}.align-items-stretch{align-items:stretch !important}.align-content-start{align-content:flex-start !important}.align-content-end{align-content:flex-end !important}.align-content-center{align-content:center !important}.align-content-between{align-content:space-between !important}.align-content-around{align-content:space-around !important}.align-content-stretch{align-content:stretch !important}.align-self-auto{align-self:auto !important}.align-self-start{align-self:flex-start !important}.align-self-end{align-self:flex-end !important}.align-self-center{align-self:center !important}.align-self-baseline{align-self:baseline !important}.align-self-stretch{align-self:stretch !important}.order-first{order:-1 !important}.order-0{order:0 !important}.order-1{order:1 !important}.order-2{order:2 !important}.order-3{order:3 !important}.order-4{order:4 !important}.order-5{order:5 !important}.order-last{order:6 !important}.m-0{margin:0 !important}.m-1{margin:.25rem !important}.m-2{margin:.5rem !important}.m-3{margin:1rem !important}.m-4{margin:1.5rem !important}.m-5{margin:3rem !important}.m-auto{margin:auto !important}.mx-0{margin-right:0 !important;margin-left:0 !important}.mx-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-3{margin-right:1rem !important;margin-left:1rem !important}.mx-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-5{margin-right:3rem !important;margin-left:3rem !important}.mx-auto{margin-right:auto !important;margin-left:auto !important}.my-0{margin-top:0 !important;margin-bottom:0 !important}.my-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-0{margin-top:0 !important}.mt-1{margin-top:.25rem !important}.mt-2{margin-top:.5rem !important}.mt-3{margin-top:1rem !important}.mt-4{margin-top:1.5rem !important}.mt-5{margin-top:3rem !important}.mt-auto{margin-top:auto !important}.me-0{margin-right:0 !important}.me-1{margin-right:.25rem !important}.me-2{margin-right:.5rem !important}.me-3{margin-right:1rem !important}.me-4{margin-right:1.5rem !important}.me-5{margin-right:3rem !important}.me-auto{margin-right:auto !important}.mb-0{margin-bottom:0 !important}.mb-1{margin-bottom:.25rem !important}.mb-2{margin-bottom:.5rem !important}.mb-3{margin-bottom:1rem !important}.mb-4{margin-bottom:1.5rem !important}.mb-5{margin-bottom:3rem !important}.mb-auto{margin-bottom:auto !important}.ms-0{margin-left:0 !important}.ms-1{margin-left:.25rem !important}.ms-2{margin-left:.5rem !important}.ms-3{margin-left:1rem !important}.ms-4{margin-left:1.5rem !important}.ms-5{margin-left:3rem !important}.ms-auto{margin-left:auto !important}.p-0{padding:0 !important}.p-1{padding:.25rem !important}.p-2{padding:.5rem !important}.p-3{padding:1rem !important}.p-4{padding:1.5rem !important}.p-5{padding:3rem !important}.px-0{padding-right:0 !important;padding-left:0 !important}.px-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-3{padding-right:1rem !important;padding-left:1rem !important}.px-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-5{padding-right:3rem !important;padding-left:3rem !important}.py-0{padding-top:0 !important;padding-bottom:0 !important}.py-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-0{padding-top:0 !important}.pt-1{padding-top:.25rem !important}.pt-2{padding-top:.5rem !important}.pt-3{padding-top:1rem !important}.pt-4{padding-top:1.5rem !important}.pt-5{padding-top:3rem !important}.pe-0{padding-right:0 !important}.pe-1{padding-right:.25rem !important}.pe-2{padding-right:.5rem !important}.pe-3{padding-right:1rem !important}.pe-4{padding-right:1.5rem !important}.pe-5{padding-right:3rem !important}.pb-0{padding-bottom:0 !important}.pb-1{padding-bottom:.25rem !important}.pb-2{padding-bottom:.5rem !important}.pb-3{padding-bottom:1rem !important}.pb-4{padding-bottom:1.5rem !important}.pb-5{padding-bottom:3rem !important}.ps-0{padding-left:0 !important}.ps-1{padding-left:.25rem !important}.ps-2{padding-left:.5rem !important}.ps-3{padding-left:1rem !important}.ps-4{padding-left:1.5rem !important}.ps-5{padding-left:3rem !important}.gap-0{gap:0 !important}.gap-1{gap:.25rem !important}.gap-2{gap:.5rem !important}.gap-3{gap:1rem !important}.gap-4{gap:1.5rem !important}.gap-5{gap:3rem !important}.row-gap-0{row-gap:0 !important}.row-gap-1{row-gap:.25rem !important}.row-gap-2{row-gap:.5rem !important}.row-gap-3{row-gap:1rem !important}.row-gap-4{row-gap:1.5rem !important}.row-gap-5{row-gap:3rem !important}.column-gap-0{column-gap:0 !important}.column-gap-1{column-gap:.25rem !important}.column-gap-2{column-gap:.5rem !important}.column-gap-3{column-gap:1rem !important}.column-gap-4{column-gap:1.5rem !important}.column-gap-5{column-gap:3rem !important}.font-monospace{font-family:var(--bs-font-monospace) !important}.fs-1{font-size:calc(1.375rem + 1.5vw) !important}.fs-2{font-size:calc(1.325rem + 0.9vw) !important}.fs-3{font-size:calc(1.3rem + 0.6vw) !important}.fs-4{font-size:calc(1.275rem + 0.3vw) !important}.fs-5{font-size:1.25rem !important}.fs-6{font-size:1rem !important}.fst-italic{font-style:italic !important}.fst-normal{font-style:normal !important}.fw-lighter{font-weight:lighter !important}.fw-light{font-weight:300 !important}.fw-normal{font-weight:400 !important}.fw-medium{font-weight:500 !important}.fw-semibold{font-weight:600 !important}.fw-bold{font-weight:700 !important}.fw-bolder{font-weight:bolder !important}.lh-1{line-height:1 !important}.lh-sm{line-height:1.25 !important}.lh-base{line-height:1.5 !important}.lh-lg{line-height:2 !important}.text-start{text-align:left !important}.text-end{text-align:right !important}.text-center{text-align:center !important}.text-decoration-none{text-decoration:none !important}.text-decoration-underline{text-decoration:underline !important}.text-decoration-line-through{text-decoration:line-through !important}.text-lowercase{text-transform:lowercase !important}.text-uppercase{text-transform:uppercase !important}.text-capitalize{text-transform:capitalize !important}.text-wrap{white-space:normal !important}.text-nowrap{white-space:nowrap !important}.text-break{word-wrap:break-word !important;word-break:break-word !important}.text-primary{--bs-text-opacity: 1;color:rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important}.text-secondary{--bs-text-opacity: 1;color:rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important}.text-success{--bs-text-opacity: 1;color:rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important}.text-info{--bs-text-opacity: 1;color:rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important}.text-warning{--bs-text-opacity: 1;color:rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important}.text-danger{--bs-text-opacity: 1;color:rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important}.text-light{--bs-text-opacity: 1;color:rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important}.text-dark{--bs-text-opacity: 1;color:rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important}.text-dark-primary{--bs-text-opacity: 1;color:rgba(var(--bs-dark-primary-rgb), var(--bs-text-opacity)) !important}.text-black{--bs-text-opacity: 1;color:rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important}.text-white{--bs-text-opacity: 1;color:rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important}.text-body{--bs-text-opacity: 1;color:rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important}.text-muted{--bs-text-opacity: 1;color:var(--bs-secondary-color) !important}.text-black-50{--bs-text-opacity: 1;color:rgba(0,0,0,.5) !important}.text-white-50{--bs-text-opacity: 1;color:rgba(255,255,255,.5) !important}.text-body-secondary{--bs-text-opacity: 1;color:var(--bs-secondary-color) !important}.text-body-tertiary{--bs-text-opacity: 1;color:var(--bs-tertiary-color) !important}.text-body-emphasis{--bs-text-opacity: 1;color:var(--bs-emphasis-color) !important}.text-reset{--bs-text-opacity: 1;color:inherit !important}.text-opacity-25{--bs-text-opacity: 0.25}.text-opacity-50{--bs-text-opacity: 0.5}.text-opacity-75{--bs-text-opacity: 0.75}.text-opacity-100{--bs-text-opacity: 1}.text-primary-emphasis{color:var(--bs-primary-text-emphasis) !important}.text-secondary-emphasis{color:var(--bs-secondary-text-emphasis) !important}.text-success-emphasis{color:var(--bs-success-text-emphasis) !important}.text-info-emphasis{color:var(--bs-info-text-emphasis) !important}.text-warning-emphasis{color:var(--bs-warning-text-emphasis) !important}.text-danger-emphasis{color:var(--bs-danger-text-emphasis) !important}.text-light-emphasis{color:var(--bs-light-text-emphasis) !important}.text-dark-emphasis{color:var(--bs-dark-text-emphasis) !important}.link-opacity-10{--bs-link-opacity: 0.1}.link-opacity-10-hover:hover{--bs-link-opacity: 0.1}.link-opacity-25{--bs-link-opacity: 0.25}.link-opacity-25-hover:hover{--bs-link-opacity: 0.25}.link-opacity-50{--bs-link-opacity: 0.5}.link-opacity-50-hover:hover{--bs-link-opacity: 0.5}.link-opacity-75{--bs-link-opacity: 0.75}.link-opacity-75-hover:hover{--bs-link-opacity: 0.75}.link-opacity-100{--bs-link-opacity: 1}.link-opacity-100-hover:hover{--bs-link-opacity: 1}.link-offset-1{text-underline-offset:.125em !important}.link-offset-1-hover:hover{text-underline-offset:.125em !important}.link-offset-2{text-underline-offset:.25em !important}.link-offset-2-hover:hover{text-underline-offset:.25em !important}.link-offset-3{text-underline-offset:.375em !important}.link-offset-3-hover:hover{text-underline-offset:.375em !important}.link-underline-primary{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-secondary{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-success{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-info{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-warning{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-danger{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-light{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-dark{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important}.link-underline-dark-primary{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-dark-primary-rgb), var(--bs-link-underline-opacity)) !important}.link-underline{--bs-link-underline-opacity: 1;text-decoration-color:rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important}.link-underline-opacity-0{--bs-link-underline-opacity: 0}.link-underline-opacity-0-hover:hover{--bs-link-underline-opacity: 0}.link-underline-opacity-10{--bs-link-underline-opacity: 0.1}.link-underline-opacity-10-hover:hover{--bs-link-underline-opacity: 0.1}.link-underline-opacity-25{--bs-link-underline-opacity: 0.25}.link-underline-opacity-25-hover:hover{--bs-link-underline-opacity: 0.25}.link-underline-opacity-50{--bs-link-underline-opacity: 0.5}.link-underline-opacity-50-hover:hover{--bs-link-underline-opacity: 0.5}.link-underline-opacity-75{--bs-link-underline-opacity: 0.75}.link-underline-opacity-75-hover:hover{--bs-link-underline-opacity: 0.75}.link-underline-opacity-100{--bs-link-underline-opacity: 1}.link-underline-opacity-100-hover:hover{--bs-link-underline-opacity: 1}.bg-primary{--bs-bg-opacity: 1;background-color:rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important}.bg-secondary{--bs-bg-opacity: 1;background-color:rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important}.bg-success{--bs-bg-opacity: 1;background-color:rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important}.bg-info{--bs-bg-opacity: 1;background-color:rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important}.bg-warning{--bs-bg-opacity: 1;background-color:rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important}.bg-danger{--bs-bg-opacity: 1;background-color:rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important}.bg-light{--bs-bg-opacity: 1;background-color:rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important}.bg-dark{--bs-bg-opacity: 1;background-color:rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important}.bg-dark-primary{--bs-bg-opacity: 1;background-color:rgba(var(--bs-dark-primary-rgb), var(--bs-bg-opacity)) !important}.bg-black{--bs-bg-opacity: 1;background-color:rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important}.bg-white{--bs-bg-opacity: 1;background-color:rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important}.bg-body{--bs-bg-opacity: 1;background-color:rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important}.bg-transparent{--bs-bg-opacity: 1;background-color:rgba(0,0,0,0) !important}.bg-body-secondary{--bs-bg-opacity: 1;background-color:rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important}.bg-body-tertiary{--bs-bg-opacity: 1;background-color:rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important}.bg-opacity-10{--bs-bg-opacity: 0.1}.bg-opacity-25{--bs-bg-opacity: 0.25}.bg-opacity-50{--bs-bg-opacity: 0.5}.bg-opacity-75{--bs-bg-opacity: 0.75}.bg-opacity-100{--bs-bg-opacity: 1}.bg-primary-subtle{background-color:var(--bs-primary-bg-subtle) !important}.bg-secondary-subtle{background-color:var(--bs-secondary-bg-subtle) !important}.bg-success-subtle{background-color:var(--bs-success-bg-subtle) !important}.bg-info-subtle{background-color:var(--bs-info-bg-subtle) !important}.bg-warning-subtle{background-color:var(--bs-warning-bg-subtle) !important}.bg-danger-subtle{background-color:var(--bs-danger-bg-subtle) !important}.bg-light-subtle{background-color:var(--bs-light-bg-subtle) !important}.bg-dark-subtle{background-color:var(--bs-dark-bg-subtle) !important}.bg-gradient{background-image:var(--bs-gradient) !important}.user-select-all{user-select:all !important}.user-select-auto{user-select:auto !important}.user-select-none{user-select:none !important}.pe-none{pointer-events:none !important}.pe-auto{pointer-events:auto !important}.rounded{border-radius:var(--bs-border-radius) !important}.rounded-0{border-radius:0 !important}.rounded-1{border-radius:var(--bs-border-radius-sm) !important}.rounded-2{border-radius:var(--bs-border-radius) !important}.rounded-3{border-radius:var(--bs-border-radius-lg) !important}.rounded-4{border-radius:var(--bs-border-radius-xl) !important}.rounded-5{border-radius:var(--bs-border-radius-xxl) !important}.rounded-circle{border-radius:50% !important}.rounded-pill{border-radius:var(--bs-border-radius-pill) !important}.rounded-top{border-top-left-radius:var(--bs-border-radius) !important;border-top-right-radius:var(--bs-border-radius) !important}.rounded-top-0{border-top-left-radius:0 !important;border-top-right-radius:0 !important}.rounded-top-1{border-top-left-radius:var(--bs-border-radius-sm) !important;border-top-right-radius:var(--bs-border-radius-sm) !important}.rounded-top-2{border-top-left-radius:var(--bs-border-radius) !important;border-top-right-radius:var(--bs-border-radius) !important}.rounded-top-3{border-top-left-radius:var(--bs-border-radius-lg) !important;border-top-right-radius:var(--bs-border-radius-lg) !important}.rounded-top-4{border-top-left-radius:var(--bs-border-radius-xl) !important;border-top-right-radius:var(--bs-border-radius-xl) !important}.rounded-top-5{border-top-left-radius:var(--bs-border-radius-xxl) !important;border-top-right-radius:var(--bs-border-radius-xxl) !important}.rounded-top-circle{border-top-left-radius:50% !important;border-top-right-radius:50% !important}.rounded-top-pill{border-top-left-radius:var(--bs-border-radius-pill) !important;border-top-right-radius:var(--bs-border-radius-pill) !important}.rounded-end{border-top-right-radius:var(--bs-border-radius) !important;border-bottom-right-radius:var(--bs-border-radius) !important}.rounded-end-0{border-top-right-radius:0 !important;border-bottom-right-radius:0 !important}.rounded-end-1{border-top-right-radius:var(--bs-border-radius-sm) !important;border-bottom-right-radius:var(--bs-border-radius-sm) !important}.rounded-end-2{border-top-right-radius:var(--bs-border-radius) !important;border-bottom-right-radius:var(--bs-border-radius) !important}.rounded-end-3{border-top-right-radius:var(--bs-border-radius-lg) !important;border-bottom-right-radius:var(--bs-border-radius-lg) !important}.rounded-end-4{border-top-right-radius:var(--bs-border-radius-xl) !important;border-bottom-right-radius:var(--bs-border-radius-xl) !important}.rounded-end-5{border-top-right-radius:var(--bs-border-radius-xxl) !important;border-bottom-right-radius:var(--bs-border-radius-xxl) !important}.rounded-end-circle{border-top-right-radius:50% !important;border-bottom-right-radius:50% !important}.rounded-end-pill{border-top-right-radius:var(--bs-border-radius-pill) !important;border-bottom-right-radius:var(--bs-border-radius-pill) !important}.rounded-bottom{border-bottom-right-radius:var(--bs-border-radius) !important;border-bottom-left-radius:var(--bs-border-radius) !important}.rounded-bottom-0{border-bottom-right-radius:0 !important;border-bottom-left-radius:0 !important}.rounded-bottom-1{border-bottom-right-radius:var(--bs-border-radius-sm) !important;border-bottom-left-radius:var(--bs-border-radius-sm) !important}.rounded-bottom-2{border-bottom-right-radius:var(--bs-border-radius) !important;border-bottom-left-radius:var(--bs-border-radius) !important}.rounded-bottom-3{border-bottom-right-radius:var(--bs-border-radius-lg) !important;border-bottom-left-radius:var(--bs-border-radius-lg) !important}.rounded-bottom-4{border-bottom-right-radius:var(--bs-border-radius-xl) !important;border-bottom-left-radius:var(--bs-border-radius-xl) !important}.rounded-bottom-5{border-bottom-right-radius:var(--bs-border-radius-xxl) !important;border-bottom-left-radius:var(--bs-border-radius-xxl) !important}.rounded-bottom-circle{border-bottom-right-radius:50% !important;border-bottom-left-radius:50% !important}.rounded-bottom-pill{border-bottom-right-radius:var(--bs-border-radius-pill) !important;border-bottom-left-radius:var(--bs-border-radius-pill) !important}.rounded-start{border-bottom-left-radius:var(--bs-border-radius) !important;border-top-left-radius:var(--bs-border-radius) !important}.rounded-start-0{border-bottom-left-radius:0 !important;border-top-left-radius:0 !important}.rounded-start-1{border-bottom-left-radius:var(--bs-border-radius-sm) !important;border-top-left-radius:var(--bs-border-radius-sm) !important}.rounded-start-2{border-bottom-left-radius:var(--bs-border-radius) !important;border-top-left-radius:var(--bs-border-radius) !important}.rounded-start-3{border-bottom-left-radius:var(--bs-border-radius-lg) !important;border-top-left-radius:var(--bs-border-radius-lg) !important}.rounded-start-4{border-bottom-left-radius:var(--bs-border-radius-xl) !important;border-top-left-radius:var(--bs-border-radius-xl) !important}.rounded-start-5{border-bottom-left-radius:var(--bs-border-radius-xxl) !important;border-top-left-radius:var(--bs-border-radius-xxl) !important}.rounded-start-circle{border-bottom-left-radius:50% !important;border-top-left-radius:50% !important}.rounded-start-pill{border-bottom-left-radius:var(--bs-border-radius-pill) !important;border-top-left-radius:var(--bs-border-radius-pill) !important}.visible{visibility:visible !important}.invisible{visibility:hidden !important}.z-n1{z-index:-1 !important}.z-0{z-index:0 !important}.z-1{z-index:1 !important}.z-2{z-index:2 !important}.z-3{z-index:3 !important}@media(min-width: 576px){.float-sm-start{float:left !important}.float-sm-end{float:right !important}.float-sm-none{float:none !important}.object-fit-sm-contain{object-fit:contain !important}.object-fit-sm-cover{object-fit:cover !important}.object-fit-sm-fill{object-fit:fill !important}.object-fit-sm-scale{object-fit:scale-down !important}.object-fit-sm-none{object-fit:none !important}.d-sm-inline{display:inline !important}.d-sm-inline-block{display:inline-block !important}.d-sm-block{display:block !important}.d-sm-grid{display:grid !important}.d-sm-inline-grid{display:inline-grid !important}.d-sm-table{display:table !important}.d-sm-table-row{display:table-row !important}.d-sm-table-cell{display:table-cell !important}.d-sm-flex{display:flex !important}.d-sm-inline-flex{display:inline-flex !important}.d-sm-none{display:none !important}.flex-sm-fill{flex:1 1 auto !important}.flex-sm-row{flex-direction:row !important}.flex-sm-column{flex-direction:column !important}.flex-sm-row-reverse{flex-direction:row-reverse !important}.flex-sm-column-reverse{flex-direction:column-reverse !important}.flex-sm-grow-0{flex-grow:0 !important}.flex-sm-grow-1{flex-grow:1 !important}.flex-sm-shrink-0{flex-shrink:0 !important}.flex-sm-shrink-1{flex-shrink:1 !important}.flex-sm-wrap{flex-wrap:wrap !important}.flex-sm-nowrap{flex-wrap:nowrap !important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-sm-start{justify-content:flex-start !important}.justify-content-sm-end{justify-content:flex-end !important}.justify-content-sm-center{justify-content:center !important}.justify-content-sm-between{justify-content:space-between !important}.justify-content-sm-around{justify-content:space-around !important}.justify-content-sm-evenly{justify-content:space-evenly !important}.align-items-sm-start{align-items:flex-start !important}.align-items-sm-end{align-items:flex-end !important}.align-items-sm-center{align-items:center !important}.align-items-sm-baseline{align-items:baseline !important}.align-items-sm-stretch{align-items:stretch !important}.align-content-sm-start{align-content:flex-start !important}.align-content-sm-end{align-content:flex-end !important}.align-content-sm-center{align-content:center !important}.align-content-sm-between{align-content:space-between !important}.align-content-sm-around{align-content:space-around !important}.align-content-sm-stretch{align-content:stretch !important}.align-self-sm-auto{align-self:auto !important}.align-self-sm-start{align-self:flex-start !important}.align-self-sm-end{align-self:flex-end !important}.align-self-sm-center{align-self:center !important}.align-self-sm-baseline{align-self:baseline !important}.align-self-sm-stretch{align-self:stretch !important}.order-sm-first{order:-1 !important}.order-sm-0{order:0 !important}.order-sm-1{order:1 !important}.order-sm-2{order:2 !important}.order-sm-3{order:3 !important}.order-sm-4{order:4 !important}.order-sm-5{order:5 !important}.order-sm-last{order:6 !important}.m-sm-0{margin:0 !important}.m-sm-1{margin:.25rem !important}.m-sm-2{margin:.5rem !important}.m-sm-3{margin:1rem !important}.m-sm-4{margin:1.5rem !important}.m-sm-5{margin:3rem !important}.m-sm-auto{margin:auto !important}.mx-sm-0{margin-right:0 !important;margin-left:0 !important}.mx-sm-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-sm-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-sm-3{margin-right:1rem !important;margin-left:1rem !important}.mx-sm-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-sm-5{margin-right:3rem !important;margin-left:3rem !important}.mx-sm-auto{margin-right:auto !important;margin-left:auto !important}.my-sm-0{margin-top:0 !important;margin-bottom:0 !important}.my-sm-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-sm-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-sm-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-sm-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-sm-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-sm-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-sm-0{margin-top:0 !important}.mt-sm-1{margin-top:.25rem !important}.mt-sm-2{margin-top:.5rem !important}.mt-sm-3{margin-top:1rem !important}.mt-sm-4{margin-top:1.5rem !important}.mt-sm-5{margin-top:3rem !important}.mt-sm-auto{margin-top:auto !important}.me-sm-0{margin-right:0 !important}.me-sm-1{margin-right:.25rem !important}.me-sm-2{margin-right:.5rem !important}.me-sm-3{margin-right:1rem !important}.me-sm-4{margin-right:1.5rem !important}.me-sm-5{margin-right:3rem !important}.me-sm-auto{margin-right:auto !important}.mb-sm-0{margin-bottom:0 !important}.mb-sm-1{margin-bottom:.25rem !important}.mb-sm-2{margin-bottom:.5rem !important}.mb-sm-3{margin-bottom:1rem !important}.mb-sm-4{margin-bottom:1.5rem !important}.mb-sm-5{margin-bottom:3rem !important}.mb-sm-auto{margin-bottom:auto !important}.ms-sm-0{margin-left:0 !important}.ms-sm-1{margin-left:.25rem !important}.ms-sm-2{margin-left:.5rem !important}.ms-sm-3{margin-left:1rem !important}.ms-sm-4{margin-left:1.5rem !important}.ms-sm-5{margin-left:3rem !important}.ms-sm-auto{margin-left:auto !important}.p-sm-0{padding:0 !important}.p-sm-1{padding:.25rem !important}.p-sm-2{padding:.5rem !important}.p-sm-3{padding:1rem !important}.p-sm-4{padding:1.5rem !important}.p-sm-5{padding:3rem !important}.px-sm-0{padding-right:0 !important;padding-left:0 !important}.px-sm-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-sm-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-sm-3{padding-right:1rem !important;padding-left:1rem !important}.px-sm-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-sm-5{padding-right:3rem !important;padding-left:3rem !important}.py-sm-0{padding-top:0 !important;padding-bottom:0 !important}.py-sm-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-sm-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-sm-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-sm-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-sm-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-sm-0{padding-top:0 !important}.pt-sm-1{padding-top:.25rem !important}.pt-sm-2{padding-top:.5rem !important}.pt-sm-3{padding-top:1rem !important}.pt-sm-4{padding-top:1.5rem !important}.pt-sm-5{padding-top:3rem !important}.pe-sm-0{padding-right:0 !important}.pe-sm-1{padding-right:.25rem !important}.pe-sm-2{padding-right:.5rem !important}.pe-sm-3{padding-right:1rem !important}.pe-sm-4{padding-right:1.5rem !important}.pe-sm-5{padding-right:3rem !important}.pb-sm-0{padding-bottom:0 !important}.pb-sm-1{padding-bottom:.25rem !important}.pb-sm-2{padding-bottom:.5rem !important}.pb-sm-3{padding-bottom:1rem !important}.pb-sm-4{padding-bottom:1.5rem !important}.pb-sm-5{padding-bottom:3rem !important}.ps-sm-0{padding-left:0 !important}.ps-sm-1{padding-left:.25rem !important}.ps-sm-2{padding-left:.5rem !important}.ps-sm-3{padding-left:1rem !important}.ps-sm-4{padding-left:1.5rem !important}.ps-sm-5{padding-left:3rem !important}.gap-sm-0{gap:0 !important}.gap-sm-1{gap:.25rem !important}.gap-sm-2{gap:.5rem !important}.gap-sm-3{gap:1rem !important}.gap-sm-4{gap:1.5rem !important}.gap-sm-5{gap:3rem !important}.row-gap-sm-0{row-gap:0 !important}.row-gap-sm-1{row-gap:.25rem !important}.row-gap-sm-2{row-gap:.5rem !important}.row-gap-sm-3{row-gap:1rem !important}.row-gap-sm-4{row-gap:1.5rem !important}.row-gap-sm-5{row-gap:3rem !important}.column-gap-sm-0{column-gap:0 !important}.column-gap-sm-1{column-gap:.25rem !important}.column-gap-sm-2{column-gap:.5rem !important}.column-gap-sm-3{column-gap:1rem !important}.column-gap-sm-4{column-gap:1.5rem !important}.column-gap-sm-5{column-gap:3rem !important}.text-sm-start{text-align:left !important}.text-sm-end{text-align:right !important}.text-sm-center{text-align:center !important}}@media(min-width: 768px){.float-md-start{float:left !important}.float-md-end{float:right !important}.float-md-none{float:none !important}.object-fit-md-contain{object-fit:contain !important}.object-fit-md-cover{object-fit:cover !important}.object-fit-md-fill{object-fit:fill !important}.object-fit-md-scale{object-fit:scale-down !important}.object-fit-md-none{object-fit:none !important}.d-md-inline{display:inline !important}.d-md-inline-block{display:inline-block !important}.d-md-block{display:block !important}.d-md-grid{display:grid !important}.d-md-inline-grid{display:inline-grid !important}.d-md-table{display:table !important}.d-md-table-row{display:table-row !important}.d-md-table-cell{display:table-cell !important}.d-md-flex{display:flex !important}.d-md-inline-flex{display:inline-flex !important}.d-md-none{display:none !important}.flex-md-fill{flex:1 1 auto !important}.flex-md-row{flex-direction:row !important}.flex-md-column{flex-direction:column !important}.flex-md-row-reverse{flex-direction:row-reverse !important}.flex-md-column-reverse{flex-direction:column-reverse !important}.flex-md-grow-0{flex-grow:0 !important}.flex-md-grow-1{flex-grow:1 !important}.flex-md-shrink-0{flex-shrink:0 !important}.flex-md-shrink-1{flex-shrink:1 !important}.flex-md-wrap{flex-wrap:wrap !important}.flex-md-nowrap{flex-wrap:nowrap !important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-md-start{justify-content:flex-start !important}.justify-content-md-end{justify-content:flex-end !important}.justify-content-md-center{justify-content:center !important}.justify-content-md-between{justify-content:space-between !important}.justify-content-md-around{justify-content:space-around !important}.justify-content-md-evenly{justify-content:space-evenly !important}.align-items-md-start{align-items:flex-start !important}.align-items-md-end{align-items:flex-end !important}.align-items-md-center{align-items:center !important}.align-items-md-baseline{align-items:baseline !important}.align-items-md-stretch{align-items:stretch !important}.align-content-md-start{align-content:flex-start !important}.align-content-md-end{align-content:flex-end !important}.align-content-md-center{align-content:center !important}.align-content-md-between{align-content:space-between !important}.align-content-md-around{align-content:space-around !important}.align-content-md-stretch{align-content:stretch !important}.align-self-md-auto{align-self:auto !important}.align-self-md-start{align-self:flex-start !important}.align-self-md-end{align-self:flex-end !important}.align-self-md-center{align-self:center !important}.align-self-md-baseline{align-self:baseline !important}.align-self-md-stretch{align-self:stretch !important}.order-md-first{order:-1 !important}.order-md-0{order:0 !important}.order-md-1{order:1 !important}.order-md-2{order:2 !important}.order-md-3{order:3 !important}.order-md-4{order:4 !important}.order-md-5{order:5 !important}.order-md-last{order:6 !important}.m-md-0{margin:0 !important}.m-md-1{margin:.25rem !important}.m-md-2{margin:.5rem !important}.m-md-3{margin:1rem !important}.m-md-4{margin:1.5rem !important}.m-md-5{margin:3rem !important}.m-md-auto{margin:auto !important}.mx-md-0{margin-right:0 !important;margin-left:0 !important}.mx-md-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-md-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-md-3{margin-right:1rem !important;margin-left:1rem !important}.mx-md-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-md-5{margin-right:3rem !important;margin-left:3rem !important}.mx-md-auto{margin-right:auto !important;margin-left:auto !important}.my-md-0{margin-top:0 !important;margin-bottom:0 !important}.my-md-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-md-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-md-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-md-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-md-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-md-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-md-0{margin-top:0 !important}.mt-md-1{margin-top:.25rem !important}.mt-md-2{margin-top:.5rem !important}.mt-md-3{margin-top:1rem !important}.mt-md-4{margin-top:1.5rem !important}.mt-md-5{margin-top:3rem !important}.mt-md-auto{margin-top:auto !important}.me-md-0{margin-right:0 !important}.me-md-1{margin-right:.25rem !important}.me-md-2{margin-right:.5rem !important}.me-md-3{margin-right:1rem !important}.me-md-4{margin-right:1.5rem !important}.me-md-5{margin-right:3rem !important}.me-md-auto{margin-right:auto !important}.mb-md-0{margin-bottom:0 !important}.mb-md-1{margin-bottom:.25rem !important}.mb-md-2{margin-bottom:.5rem !important}.mb-md-3{margin-bottom:1rem !important}.mb-md-4{margin-bottom:1.5rem !important}.mb-md-5{margin-bottom:3rem !important}.mb-md-auto{margin-bottom:auto !important}.ms-md-0{margin-left:0 !important}.ms-md-1{margin-left:.25rem !important}.ms-md-2{margin-left:.5rem !important}.ms-md-3{margin-left:1rem !important}.ms-md-4{margin-left:1.5rem !important}.ms-md-5{margin-left:3rem !important}.ms-md-auto{margin-left:auto !important}.p-md-0{padding:0 !important}.p-md-1{padding:.25rem !important}.p-md-2{padding:.5rem !important}.p-md-3{padding:1rem !important}.p-md-4{padding:1.5rem !important}.p-md-5{padding:3rem !important}.px-md-0{padding-right:0 !important;padding-left:0 !important}.px-md-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-md-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-md-3{padding-right:1rem !important;padding-left:1rem !important}.px-md-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-md-5{padding-right:3rem !important;padding-left:3rem !important}.py-md-0{padding-top:0 !important;padding-bottom:0 !important}.py-md-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-md-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-md-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-md-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-md-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-md-0{padding-top:0 !important}.pt-md-1{padding-top:.25rem !important}.pt-md-2{padding-top:.5rem !important}.pt-md-3{padding-top:1rem !important}.pt-md-4{padding-top:1.5rem !important}.pt-md-5{padding-top:3rem !important}.pe-md-0{padding-right:0 !important}.pe-md-1{padding-right:.25rem !important}.pe-md-2{padding-right:.5rem !important}.pe-md-3{padding-right:1rem !important}.pe-md-4{padding-right:1.5rem !important}.pe-md-5{padding-right:3rem !important}.pb-md-0{padding-bottom:0 !important}.pb-md-1{padding-bottom:.25rem !important}.pb-md-2{padding-bottom:.5rem !important}.pb-md-3{padding-bottom:1rem !important}.pb-md-4{padding-bottom:1.5rem !important}.pb-md-5{padding-bottom:3rem !important}.ps-md-0{padding-left:0 !important}.ps-md-1{padding-left:.25rem !important}.ps-md-2{padding-left:.5rem !important}.ps-md-3{padding-left:1rem !important}.ps-md-4{padding-left:1.5rem !important}.ps-md-5{padding-left:3rem !important}.gap-md-0{gap:0 !important}.gap-md-1{gap:.25rem !important}.gap-md-2{gap:.5rem !important}.gap-md-3{gap:1rem !important}.gap-md-4{gap:1.5rem !important}.gap-md-5{gap:3rem !important}.row-gap-md-0{row-gap:0 !important}.row-gap-md-1{row-gap:.25rem !important}.row-gap-md-2{row-gap:.5rem !important}.row-gap-md-3{row-gap:1rem !important}.row-gap-md-4{row-gap:1.5rem !important}.row-gap-md-5{row-gap:3rem !important}.column-gap-md-0{column-gap:0 !important}.column-gap-md-1{column-gap:.25rem !important}.column-gap-md-2{column-gap:.5rem !important}.column-gap-md-3{column-gap:1rem !important}.column-gap-md-4{column-gap:1.5rem !important}.column-gap-md-5{column-gap:3rem !important}.text-md-start{text-align:left !important}.text-md-end{text-align:right !important}.text-md-center{text-align:center !important}}@media(min-width: 992px){.float-lg-start{float:left !important}.float-lg-end{float:right !important}.float-lg-none{float:none !important}.object-fit-lg-contain{object-fit:contain !important}.object-fit-lg-cover{object-fit:cover !important}.object-fit-lg-fill{object-fit:fill !important}.object-fit-lg-scale{object-fit:scale-down !important}.object-fit-lg-none{object-fit:none !important}.d-lg-inline{display:inline !important}.d-lg-inline-block{display:inline-block !important}.d-lg-block{display:block !important}.d-lg-grid{display:grid !important}.d-lg-inline-grid{display:inline-grid !important}.d-lg-table{display:table !important}.d-lg-table-row{display:table-row !important}.d-lg-table-cell{display:table-cell !important}.d-lg-flex{display:flex !important}.d-lg-inline-flex{display:inline-flex !important}.d-lg-none{display:none !important}.flex-lg-fill{flex:1 1 auto !important}.flex-lg-row{flex-direction:row !important}.flex-lg-column{flex-direction:column !important}.flex-lg-row-reverse{flex-direction:row-reverse !important}.flex-lg-column-reverse{flex-direction:column-reverse !important}.flex-lg-grow-0{flex-grow:0 !important}.flex-lg-grow-1{flex-grow:1 !important}.flex-lg-shrink-0{flex-shrink:0 !important}.flex-lg-shrink-1{flex-shrink:1 !important}.flex-lg-wrap{flex-wrap:wrap !important}.flex-lg-nowrap{flex-wrap:nowrap !important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-lg-start{justify-content:flex-start !important}.justify-content-lg-end{justify-content:flex-end !important}.justify-content-lg-center{justify-content:center !important}.justify-content-lg-between{justify-content:space-between !important}.justify-content-lg-around{justify-content:space-around !important}.justify-content-lg-evenly{justify-content:space-evenly !important}.align-items-lg-start{align-items:flex-start !important}.align-items-lg-end{align-items:flex-end !important}.align-items-lg-center{align-items:center !important}.align-items-lg-baseline{align-items:baseline !important}.align-items-lg-stretch{align-items:stretch !important}.align-content-lg-start{align-content:flex-start !important}.align-content-lg-end{align-content:flex-end !important}.align-content-lg-center{align-content:center !important}.align-content-lg-between{align-content:space-between !important}.align-content-lg-around{align-content:space-around !important}.align-content-lg-stretch{align-content:stretch !important}.align-self-lg-auto{align-self:auto !important}.align-self-lg-start{align-self:flex-start !important}.align-self-lg-end{align-self:flex-end !important}.align-self-lg-center{align-self:center !important}.align-self-lg-baseline{align-self:baseline !important}.align-self-lg-stretch{align-self:stretch !important}.order-lg-first{order:-1 !important}.order-lg-0{order:0 !important}.order-lg-1{order:1 !important}.order-lg-2{order:2 !important}.order-lg-3{order:3 !important}.order-lg-4{order:4 !important}.order-lg-5{order:5 !important}.order-lg-last{order:6 !important}.m-lg-0{margin:0 !important}.m-lg-1{margin:.25rem !important}.m-lg-2{margin:.5rem !important}.m-lg-3{margin:1rem !important}.m-lg-4{margin:1.5rem !important}.m-lg-5{margin:3rem !important}.m-lg-auto{margin:auto !important}.mx-lg-0{margin-right:0 !important;margin-left:0 !important}.mx-lg-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-lg-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-lg-3{margin-right:1rem !important;margin-left:1rem !important}.mx-lg-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-lg-5{margin-right:3rem !important;margin-left:3rem !important}.mx-lg-auto{margin-right:auto !important;margin-left:auto !important}.my-lg-0{margin-top:0 !important;margin-bottom:0 !important}.my-lg-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-lg-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-lg-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-lg-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-lg-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-lg-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-lg-0{margin-top:0 !important}.mt-lg-1{margin-top:.25rem !important}.mt-lg-2{margin-top:.5rem !important}.mt-lg-3{margin-top:1rem !important}.mt-lg-4{margin-top:1.5rem !important}.mt-lg-5{margin-top:3rem !important}.mt-lg-auto{margin-top:auto !important}.me-lg-0{margin-right:0 !important}.me-lg-1{margin-right:.25rem !important}.me-lg-2{margin-right:.5rem !important}.me-lg-3{margin-right:1rem !important}.me-lg-4{margin-right:1.5rem !important}.me-lg-5{margin-right:3rem !important}.me-lg-auto{margin-right:auto !important}.mb-lg-0{margin-bottom:0 !important}.mb-lg-1{margin-bottom:.25rem !important}.mb-lg-2{margin-bottom:.5rem !important}.mb-lg-3{margin-bottom:1rem !important}.mb-lg-4{margin-bottom:1.5rem !important}.mb-lg-5{margin-bottom:3rem !important}.mb-lg-auto{margin-bottom:auto !important}.ms-lg-0{margin-left:0 !important}.ms-lg-1{margin-left:.25rem !important}.ms-lg-2{margin-left:.5rem !important}.ms-lg-3{margin-left:1rem !important}.ms-lg-4{margin-left:1.5rem !important}.ms-lg-5{margin-left:3rem !important}.ms-lg-auto{margin-left:auto !important}.p-lg-0{padding:0 !important}.p-lg-1{padding:.25rem !important}.p-lg-2{padding:.5rem !important}.p-lg-3{padding:1rem !important}.p-lg-4{padding:1.5rem !important}.p-lg-5{padding:3rem !important}.px-lg-0{padding-right:0 !important;padding-left:0 !important}.px-lg-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-lg-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-lg-3{padding-right:1rem !important;padding-left:1rem !important}.px-lg-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-lg-5{padding-right:3rem !important;padding-left:3rem !important}.py-lg-0{padding-top:0 !important;padding-bottom:0 !important}.py-lg-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-lg-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-lg-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-lg-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-lg-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-lg-0{padding-top:0 !important}.pt-lg-1{padding-top:.25rem !important}.pt-lg-2{padding-top:.5rem !important}.pt-lg-3{padding-top:1rem !important}.pt-lg-4{padding-top:1.5rem !important}.pt-lg-5{padding-top:3rem !important}.pe-lg-0{padding-right:0 !important}.pe-lg-1{padding-right:.25rem !important}.pe-lg-2{padding-right:.5rem !important}.pe-lg-3{padding-right:1rem !important}.pe-lg-4{padding-right:1.5rem !important}.pe-lg-5{padding-right:3rem !important}.pb-lg-0{padding-bottom:0 !important}.pb-lg-1{padding-bottom:.25rem !important}.pb-lg-2{padding-bottom:.5rem !important}.pb-lg-3{padding-bottom:1rem !important}.pb-lg-4{padding-bottom:1.5rem !important}.pb-lg-5{padding-bottom:3rem !important}.ps-lg-0{padding-left:0 !important}.ps-lg-1{padding-left:.25rem !important}.ps-lg-2{padding-left:.5rem !important}.ps-lg-3{padding-left:1rem !important}.ps-lg-4{padding-left:1.5rem !important}.ps-lg-5{padding-left:3rem !important}.gap-lg-0{gap:0 !important}.gap-lg-1{gap:.25rem !important}.gap-lg-2{gap:.5rem !important}.gap-lg-3{gap:1rem !important}.gap-lg-4{gap:1.5rem !important}.gap-lg-5{gap:3rem !important}.row-gap-lg-0{row-gap:0 !important}.row-gap-lg-1{row-gap:.25rem !important}.row-gap-lg-2{row-gap:.5rem !important}.row-gap-lg-3{row-gap:1rem !important}.row-gap-lg-4{row-gap:1.5rem !important}.row-gap-lg-5{row-gap:3rem !important}.column-gap-lg-0{column-gap:0 !important}.column-gap-lg-1{column-gap:.25rem !important}.column-gap-lg-2{column-gap:.5rem !important}.column-gap-lg-3{column-gap:1rem !important}.column-gap-lg-4{column-gap:1.5rem !important}.column-gap-lg-5{column-gap:3rem !important}.text-lg-start{text-align:left !important}.text-lg-end{text-align:right !important}.text-lg-center{text-align:center !important}}@media(min-width: 1200px){.float-xl-start{float:left !important}.float-xl-end{float:right !important}.float-xl-none{float:none !important}.object-fit-xl-contain{object-fit:contain !important}.object-fit-xl-cover{object-fit:cover !important}.object-fit-xl-fill{object-fit:fill !important}.object-fit-xl-scale{object-fit:scale-down !important}.object-fit-xl-none{object-fit:none !important}.d-xl-inline{display:inline !important}.d-xl-inline-block{display:inline-block !important}.d-xl-block{display:block !important}.d-xl-grid{display:grid !important}.d-xl-inline-grid{display:inline-grid !important}.d-xl-table{display:table !important}.d-xl-table-row{display:table-row !important}.d-xl-table-cell{display:table-cell !important}.d-xl-flex{display:flex !important}.d-xl-inline-flex{display:inline-flex !important}.d-xl-none{display:none !important}.flex-xl-fill{flex:1 1 auto !important}.flex-xl-row{flex-direction:row !important}.flex-xl-column{flex-direction:column !important}.flex-xl-row-reverse{flex-direction:row-reverse !important}.flex-xl-column-reverse{flex-direction:column-reverse !important}.flex-xl-grow-0{flex-grow:0 !important}.flex-xl-grow-1{flex-grow:1 !important}.flex-xl-shrink-0{flex-shrink:0 !important}.flex-xl-shrink-1{flex-shrink:1 !important}.flex-xl-wrap{flex-wrap:wrap !important}.flex-xl-nowrap{flex-wrap:nowrap !important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-xl-start{justify-content:flex-start !important}.justify-content-xl-end{justify-content:flex-end !important}.justify-content-xl-center{justify-content:center !important}.justify-content-xl-between{justify-content:space-between !important}.justify-content-xl-around{justify-content:space-around !important}.justify-content-xl-evenly{justify-content:space-evenly !important}.align-items-xl-start{align-items:flex-start !important}.align-items-xl-end{align-items:flex-end !important}.align-items-xl-center{align-items:center !important}.align-items-xl-baseline{align-items:baseline !important}.align-items-xl-stretch{align-items:stretch !important}.align-content-xl-start{align-content:flex-start !important}.align-content-xl-end{align-content:flex-end !important}.align-content-xl-center{align-content:center !important}.align-content-xl-between{align-content:space-between !important}.align-content-xl-around{align-content:space-around !important}.align-content-xl-stretch{align-content:stretch !important}.align-self-xl-auto{align-self:auto !important}.align-self-xl-start{align-self:flex-start !important}.align-self-xl-end{align-self:flex-end !important}.align-self-xl-center{align-self:center !important}.align-self-xl-baseline{align-self:baseline !important}.align-self-xl-stretch{align-self:stretch !important}.order-xl-first{order:-1 !important}.order-xl-0{order:0 !important}.order-xl-1{order:1 !important}.order-xl-2{order:2 !important}.order-xl-3{order:3 !important}.order-xl-4{order:4 !important}.order-xl-5{order:5 !important}.order-xl-last{order:6 !important}.m-xl-0{margin:0 !important}.m-xl-1{margin:.25rem !important}.m-xl-2{margin:.5rem !important}.m-xl-3{margin:1rem !important}.m-xl-4{margin:1.5rem !important}.m-xl-5{margin:3rem !important}.m-xl-auto{margin:auto !important}.mx-xl-0{margin-right:0 !important;margin-left:0 !important}.mx-xl-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-xl-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-xl-3{margin-right:1rem !important;margin-left:1rem !important}.mx-xl-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-xl-5{margin-right:3rem !important;margin-left:3rem !important}.mx-xl-auto{margin-right:auto !important;margin-left:auto !important}.my-xl-0{margin-top:0 !important;margin-bottom:0 !important}.my-xl-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-xl-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-xl-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-xl-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-xl-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-xl-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-xl-0{margin-top:0 !important}.mt-xl-1{margin-top:.25rem !important}.mt-xl-2{margin-top:.5rem !important}.mt-xl-3{margin-top:1rem !important}.mt-xl-4{margin-top:1.5rem !important}.mt-xl-5{margin-top:3rem !important}.mt-xl-auto{margin-top:auto !important}.me-xl-0{margin-right:0 !important}.me-xl-1{margin-right:.25rem !important}.me-xl-2{margin-right:.5rem !important}.me-xl-3{margin-right:1rem !important}.me-xl-4{margin-right:1.5rem !important}.me-xl-5{margin-right:3rem !important}.me-xl-auto{margin-right:auto !important}.mb-xl-0{margin-bottom:0 !important}.mb-xl-1{margin-bottom:.25rem !important}.mb-xl-2{margin-bottom:.5rem !important}.mb-xl-3{margin-bottom:1rem !important}.mb-xl-4{margin-bottom:1.5rem !important}.mb-xl-5{margin-bottom:3rem !important}.mb-xl-auto{margin-bottom:auto !important}.ms-xl-0{margin-left:0 !important}.ms-xl-1{margin-left:.25rem !important}.ms-xl-2{margin-left:.5rem !important}.ms-xl-3{margin-left:1rem !important}.ms-xl-4{margin-left:1.5rem !important}.ms-xl-5{margin-left:3rem !important}.ms-xl-auto{margin-left:auto !important}.p-xl-0{padding:0 !important}.p-xl-1{padding:.25rem !important}.p-xl-2{padding:.5rem !important}.p-xl-3{padding:1rem !important}.p-xl-4{padding:1.5rem !important}.p-xl-5{padding:3rem !important}.px-xl-0{padding-right:0 !important;padding-left:0 !important}.px-xl-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-xl-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-xl-3{padding-right:1rem !important;padding-left:1rem !important}.px-xl-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-xl-5{padding-right:3rem !important;padding-left:3rem !important}.py-xl-0{padding-top:0 !important;padding-bottom:0 !important}.py-xl-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-xl-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-xl-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-xl-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-xl-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-xl-0{padding-top:0 !important}.pt-xl-1{padding-top:.25rem !important}.pt-xl-2{padding-top:.5rem !important}.pt-xl-3{padding-top:1rem !important}.pt-xl-4{padding-top:1.5rem !important}.pt-xl-5{padding-top:3rem !important}.pe-xl-0{padding-right:0 !important}.pe-xl-1{padding-right:.25rem !important}.pe-xl-2{padding-right:.5rem !important}.pe-xl-3{padding-right:1rem !important}.pe-xl-4{padding-right:1.5rem !important}.pe-xl-5{padding-right:3rem !important}.pb-xl-0{padding-bottom:0 !important}.pb-xl-1{padding-bottom:.25rem !important}.pb-xl-2{padding-bottom:.5rem !important}.pb-xl-3{padding-bottom:1rem !important}.pb-xl-4{padding-bottom:1.5rem !important}.pb-xl-5{padding-bottom:3rem !important}.ps-xl-0{padding-left:0 !important}.ps-xl-1{padding-left:.25rem !important}.ps-xl-2{padding-left:.5rem !important}.ps-xl-3{padding-left:1rem !important}.ps-xl-4{padding-left:1.5rem !important}.ps-xl-5{padding-left:3rem !important}.gap-xl-0{gap:0 !important}.gap-xl-1{gap:.25rem !important}.gap-xl-2{gap:.5rem !important}.gap-xl-3{gap:1rem !important}.gap-xl-4{gap:1.5rem !important}.gap-xl-5{gap:3rem !important}.row-gap-xl-0{row-gap:0 !important}.row-gap-xl-1{row-gap:.25rem !important}.row-gap-xl-2{row-gap:.5rem !important}.row-gap-xl-3{row-gap:1rem !important}.row-gap-xl-4{row-gap:1.5rem !important}.row-gap-xl-5{row-gap:3rem !important}.column-gap-xl-0{column-gap:0 !important}.column-gap-xl-1{column-gap:.25rem !important}.column-gap-xl-2{column-gap:.5rem !important}.column-gap-xl-3{column-gap:1rem !important}.column-gap-xl-4{column-gap:1.5rem !important}.column-gap-xl-5{column-gap:3rem !important}.text-xl-start{text-align:left !important}.text-xl-end{text-align:right !important}.text-xl-center{text-align:center !important}}@media(min-width: 1400px){.float-xxl-start{float:left !important}.float-xxl-end{float:right !important}.float-xxl-none{float:none !important}.object-fit-xxl-contain{object-fit:contain !important}.object-fit-xxl-cover{object-fit:cover !important}.object-fit-xxl-fill{object-fit:fill !important}.object-fit-xxl-scale{object-fit:scale-down !important}.object-fit-xxl-none{object-fit:none !important}.d-xxl-inline{display:inline !important}.d-xxl-inline-block{display:inline-block !important}.d-xxl-block{display:block !important}.d-xxl-grid{display:grid !important}.d-xxl-inline-grid{display:inline-grid !important}.d-xxl-table{display:table !important}.d-xxl-table-row{display:table-row !important}.d-xxl-table-cell{display:table-cell !important}.d-xxl-flex{display:flex !important}.d-xxl-inline-flex{display:inline-flex !important}.d-xxl-none{display:none !important}.flex-xxl-fill{flex:1 1 auto !important}.flex-xxl-row{flex-direction:row !important}.flex-xxl-column{flex-direction:column !important}.flex-xxl-row-reverse{flex-direction:row-reverse !important}.flex-xxl-column-reverse{flex-direction:column-reverse !important}.flex-xxl-grow-0{flex-grow:0 !important}.flex-xxl-grow-1{flex-grow:1 !important}.flex-xxl-shrink-0{flex-shrink:0 !important}.flex-xxl-shrink-1{flex-shrink:1 !important}.flex-xxl-wrap{flex-wrap:wrap !important}.flex-xxl-nowrap{flex-wrap:nowrap !important}.flex-xxl-wrap-reverse{flex-wrap:wrap-reverse !important}.justify-content-xxl-start{justify-content:flex-start !important}.justify-content-xxl-end{justify-content:flex-end !important}.justify-content-xxl-center{justify-content:center !important}.justify-content-xxl-between{justify-content:space-between !important}.justify-content-xxl-around{justify-content:space-around !important}.justify-content-xxl-evenly{justify-content:space-evenly !important}.align-items-xxl-start{align-items:flex-start !important}.align-items-xxl-end{align-items:flex-end !important}.align-items-xxl-center{align-items:center !important}.align-items-xxl-baseline{align-items:baseline !important}.align-items-xxl-stretch{align-items:stretch !important}.align-content-xxl-start{align-content:flex-start !important}.align-content-xxl-end{align-content:flex-end !important}.align-content-xxl-center{align-content:center !important}.align-content-xxl-between{align-content:space-between !important}.align-content-xxl-around{align-content:space-around !important}.align-content-xxl-stretch{align-content:stretch !important}.align-self-xxl-auto{align-self:auto !important}.align-self-xxl-start{align-self:flex-start !important}.align-self-xxl-end{align-self:flex-end !important}.align-self-xxl-center{align-self:center !important}.align-self-xxl-baseline{align-self:baseline !important}.align-self-xxl-stretch{align-self:stretch !important}.order-xxl-first{order:-1 !important}.order-xxl-0{order:0 !important}.order-xxl-1{order:1 !important}.order-xxl-2{order:2 !important}.order-xxl-3{order:3 !important}.order-xxl-4{order:4 !important}.order-xxl-5{order:5 !important}.order-xxl-last{order:6 !important}.m-xxl-0{margin:0 !important}.m-xxl-1{margin:.25rem !important}.m-xxl-2{margin:.5rem !important}.m-xxl-3{margin:1rem !important}.m-xxl-4{margin:1.5rem !important}.m-xxl-5{margin:3rem !important}.m-xxl-auto{margin:auto !important}.mx-xxl-0{margin-right:0 !important;margin-left:0 !important}.mx-xxl-1{margin-right:.25rem !important;margin-left:.25rem !important}.mx-xxl-2{margin-right:.5rem !important;margin-left:.5rem !important}.mx-xxl-3{margin-right:1rem !important;margin-left:1rem !important}.mx-xxl-4{margin-right:1.5rem !important;margin-left:1.5rem !important}.mx-xxl-5{margin-right:3rem !important;margin-left:3rem !important}.mx-xxl-auto{margin-right:auto !important;margin-left:auto !important}.my-xxl-0{margin-top:0 !important;margin-bottom:0 !important}.my-xxl-1{margin-top:.25rem !important;margin-bottom:.25rem !important}.my-xxl-2{margin-top:.5rem !important;margin-bottom:.5rem !important}.my-xxl-3{margin-top:1rem !important;margin-bottom:1rem !important}.my-xxl-4{margin-top:1.5rem !important;margin-bottom:1.5rem !important}.my-xxl-5{margin-top:3rem !important;margin-bottom:3rem !important}.my-xxl-auto{margin-top:auto !important;margin-bottom:auto !important}.mt-xxl-0{margin-top:0 !important}.mt-xxl-1{margin-top:.25rem !important}.mt-xxl-2{margin-top:.5rem !important}.mt-xxl-3{margin-top:1rem !important}.mt-xxl-4{margin-top:1.5rem !important}.mt-xxl-5{margin-top:3rem !important}.mt-xxl-auto{margin-top:auto !important}.me-xxl-0{margin-right:0 !important}.me-xxl-1{margin-right:.25rem !important}.me-xxl-2{margin-right:.5rem !important}.me-xxl-3{margin-right:1rem !important}.me-xxl-4{margin-right:1.5rem !important}.me-xxl-5{margin-right:3rem !important}.me-xxl-auto{margin-right:auto !important}.mb-xxl-0{margin-bottom:0 !important}.mb-xxl-1{margin-bottom:.25rem !important}.mb-xxl-2{margin-bottom:.5rem !important}.mb-xxl-3{margin-bottom:1rem !important}.mb-xxl-4{margin-bottom:1.5rem !important}.mb-xxl-5{margin-bottom:3rem !important}.mb-xxl-auto{margin-bottom:auto !important}.ms-xxl-0{margin-left:0 !important}.ms-xxl-1{margin-left:.25rem !important}.ms-xxl-2{margin-left:.5rem !important}.ms-xxl-3{margin-left:1rem !important}.ms-xxl-4{margin-left:1.5rem !important}.ms-xxl-5{margin-left:3rem !important}.ms-xxl-auto{margin-left:auto !important}.p-xxl-0{padding:0 !important}.p-xxl-1{padding:.25rem !important}.p-xxl-2{padding:.5rem !important}.p-xxl-3{padding:1rem !important}.p-xxl-4{padding:1.5rem !important}.p-xxl-5{padding:3rem !important}.px-xxl-0{padding-right:0 !important;padding-left:0 !important}.px-xxl-1{padding-right:.25rem !important;padding-left:.25rem !important}.px-xxl-2{padding-right:.5rem !important;padding-left:.5rem !important}.px-xxl-3{padding-right:1rem !important;padding-left:1rem !important}.px-xxl-4{padding-right:1.5rem !important;padding-left:1.5rem !important}.px-xxl-5{padding-right:3rem !important;padding-left:3rem !important}.py-xxl-0{padding-top:0 !important;padding-bottom:0 !important}.py-xxl-1{padding-top:.25rem !important;padding-bottom:.25rem !important}.py-xxl-2{padding-top:.5rem !important;padding-bottom:.5rem !important}.py-xxl-3{padding-top:1rem !important;padding-bottom:1rem !important}.py-xxl-4{padding-top:1.5rem !important;padding-bottom:1.5rem !important}.py-xxl-5{padding-top:3rem !important;padding-bottom:3rem !important}.pt-xxl-0{padding-top:0 !important}.pt-xxl-1{padding-top:.25rem !important}.pt-xxl-2{padding-top:.5rem !important}.pt-xxl-3{padding-top:1rem !important}.pt-xxl-4{padding-top:1.5rem !important}.pt-xxl-5{padding-top:3rem !important}.pe-xxl-0{padding-right:0 !important}.pe-xxl-1{padding-right:.25rem !important}.pe-xxl-2{padding-right:.5rem !important}.pe-xxl-3{padding-right:1rem !important}.pe-xxl-4{padding-right:1.5rem !important}.pe-xxl-5{padding-right:3rem !important}.pb-xxl-0{padding-bottom:0 !important}.pb-xxl-1{padding-bottom:.25rem !important}.pb-xxl-2{padding-bottom:.5rem !important}.pb-xxl-3{padding-bottom:1rem !important}.pb-xxl-4{padding-bottom:1.5rem !important}.pb-xxl-5{padding-bottom:3rem !important}.ps-xxl-0{padding-left:0 !important}.ps-xxl-1{padding-left:.25rem !important}.ps-xxl-2{padding-left:.5rem !important}.ps-xxl-3{padding-left:1rem !important}.ps-xxl-4{padding-left:1.5rem !important}.ps-xxl-5{padding-left:3rem !important}.gap-xxl-0{gap:0 !important}.gap-xxl-1{gap:.25rem !important}.gap-xxl-2{gap:.5rem !important}.gap-xxl-3{gap:1rem !important}.gap-xxl-4{gap:1.5rem !important}.gap-xxl-5{gap:3rem !important}.row-gap-xxl-0{row-gap:0 !important}.row-gap-xxl-1{row-gap:.25rem !important}.row-gap-xxl-2{row-gap:.5rem !important}.row-gap-xxl-3{row-gap:1rem !important}.row-gap-xxl-4{row-gap:1.5rem !important}.row-gap-xxl-5{row-gap:3rem !important}.column-gap-xxl-0{column-gap:0 !important}.column-gap-xxl-1{column-gap:.25rem !important}.column-gap-xxl-2{column-gap:.5rem !important}.column-gap-xxl-3{column-gap:1rem !important}.column-gap-xxl-4{column-gap:1.5rem !important}.column-gap-xxl-5{column-gap:3rem !important}.text-xxl-start{text-align:left !important}.text-xxl-end{text-align:right !important}.text-xxl-center{text-align:center !important}}@media(min-width: 1200px){.fs-1{font-size:2.5rem !important}.fs-2{font-size:2rem !important}.fs-3{font-size:1.75rem !important}.fs-4{font-size:1.5rem !important}}@media print{.d-print-inline{display:inline !important}.d-print-inline-block{display:inline-block !important}.d-print-block{display:block !important}.d-print-grid{display:grid !important}.d-print-inline-grid{display:inline-grid !important}.d-print-table{display:table !important}.d-print-table-row{display:table-row !important}.d-print-table-cell{display:table-cell !important}.d-print-flex{display:flex !important}.d-print-inline-flex{display:inline-flex !important}.d-print-none{display:none !important}}pre{margin-bottom:0}.c-sidebar-menu-item{padding-top:.75rem;padding-bottom:.75rem}.c-sidebar-menu-item.active{background-color:#495057}",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// Part of earth file.\r\n\r\npre {\r\n  margin-bottom: 0;\r\n}\r\n\r\ncode {\r\n  //color: $secondary;\r\n}\r\n","// Part of starter file.\r\n\r\n.c-sidebar-menu-item {\r\n  padding-top: .75rem;\r\n  padding-bottom: .75rem;\r\n}\r\n\r\n.c-sidebar-menu-item.active {\r\n  background-color: $gray-700;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
